var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/appConfig.tsx
import {
  AcademicsLogoColor,
  AMSLogoColor,
  CampsLogoColor,
  CollectivesLogoColor,
  ComplianceLogoColor,
  HubLogoColor,
  InflcrLogoColor,
  NutritionLogoColor,
  PathwaysLogoColor,
  PulseLogoColor,
  StrengthLogoColor,
  TracColor
} from "@teamworksdev/icons";

// src/types.ts
var App = /* @__PURE__ */ ((App2) => {
  App2["ams"] = "ams";
  App2["arms"] = "arms";
  App2["academics"] = "academics";
  App2["axle"] = "axle";
  App2["camps"] = "camps";
  App2["collectives"] = "collectives";
  App2["hub"] = "hub";
  App2["inflcr"] = "inflcr";
  App2["inventory"] = "inventory";
  App2["nutrition"] = "nutrition";
  App2["pathways"] = "pathways";
  App2["pulse"] = "pulse";
  App2["strength"] = "strength";
  return App2;
})(App || {});
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["staging"] = "staging";
  Environment2["prod"] = "prod";
  return Environment2;
})(Environment || {});

// src/appConfig.tsx
import { jsx } from "react/jsx-runtime";
var appMetadata = {
  ["hub" /* hub */]: {
    appId: "hub" /* hub */,
    name: "Hub",
    icon: /* @__PURE__ */ jsx(HubLogoColor, {})
  },
  ["camps" /* camps */]: {
    appId: "camps" /* camps */,
    name: "Camps",
    icon: /* @__PURE__ */ jsx(CampsLogoColor, {})
  },
  ["inventory" /* inventory */]: {
    appId: "inventory" /* inventory */,
    name: "Inventory Management",
    icon: /* @__PURE__ */ jsx(TracColor, {})
  },
  ["arms" /* arms */]: {
    appId: "arms" /* arms */,
    name: "Compliance + Recruiting",
    icon: /* @__PURE__ */ jsx(ComplianceLogoColor, {})
  },
  ["inflcr" /* inflcr */]: {
    appId: "inflcr" /* inflcr */,
    name: "Influencer",
    icon: /* @__PURE__ */ jsx(InflcrLogoColor, {})
  },
  ["collectives" /* collectives */]: {
    appId: "collectives" /* collectives */,
    name: "Collectives",
    icon: /* @__PURE__ */ jsx(CollectivesLogoColor, {})
  },
  ["ams" /* ams */]: {
    appId: "ams" /* ams */,
    name: "AMS",
    icon: /* @__PURE__ */ jsx(AMSLogoColor, {})
  },
  ["nutrition" /* nutrition */]: {
    appId: "nutrition" /* nutrition */,
    name: "Nutrition",
    icon: /* @__PURE__ */ jsx(NutritionLogoColor, {})
  },
  ["strength" /* strength */]: {
    appId: "strength" /* strength */,
    name: "Strength + Conditioning",
    icon: /* @__PURE__ */ jsx(StrengthLogoColor, {})
  },
  ["academics" /* academics */]: {
    appId: "academics" /* academics */,
    name: "Academics",
    icon: /* @__PURE__ */ jsx(AcademicsLogoColor, {})
  },
  ["pathways" /* pathways */]: {
    appId: "pathways" /* pathways */,
    name: "Pathways",
    icon: /* @__PURE__ */ jsx(PathwaysLogoColor, {})
  },
  ["pulse" /* pulse */]: {
    appId: "pulse" /* pulse */,
    name: "Pulse",
    icon: /* @__PURE__ */ jsx(PulseLogoColor, {})
  }
};

// src/components/Accordion/Accordion.tsx
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";
import { MdKeyboardArrowDown } from "@teamworksdev/icons";

// src/utils/tailwind.ts
import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
var twMerge = extendTailwindMerge({
  prefix: "tw-"
});
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/Accordion/Accordion.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var AccordionRoot = AccordionPrimitive.Root;
var AccordionItem = AccordionPrimitive.Item;
var AccordionHeader = AccordionPrimitive.Header;
var AccordionTrigger = forwardRef((_a, ref) => {
  var _b = _a, { arrowPlacement = "right", className, children } = _b, props = __objRest(_b, ["arrowPlacement", "className", "children"]);
  return /* @__PURE__ */ jsxs(
    AccordionPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-items-center tw-justify-between tw-rounded-md tw-px-2 tw-py-2 tw-ring-offset-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>svg]:data-[state=open]:tw-rotate-180",
        className
      )
    }, props), {
      children: [
        arrowPlacement === "left" && /* @__PURE__ */ jsx2(MdKeyboardArrowDown, { className: "tw-h-4 tw-w-4" }),
        children,
        arrowPlacement === "right" && /* @__PURE__ */ jsx2(MdKeyboardArrowDown, { className: "tw-h-4 tw-w-4" })
      ]
    })
  );
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
var AccordionContent = forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx2(
    AccordionPrimitive.Content,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-overflow-hidden tw-rounded-md tw-px-2 tw-py-2 tw-ring-offset-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        className
      )
    }, props), {
      children
    })
  );
});
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

// src/components/ActionBar/useActionBar.tsx
import { useCallback, useEffect, useRef, useState } from "react";
var throttle = (f) => {
  let frameId = null, lastArgs;
  const invoke = () => {
    f(lastArgs);
    frameId = null;
  };
  const result = (args) => {
    lastArgs = args;
    if (!frameId) {
      frameId = requestAnimationFrame(invoke);
    }
  };
  result.cancel = () => frameId && cancelAnimationFrame(frameId);
  return result;
};
var useRefEffect = (handler) => {
  const storedValue = useRef();
  const unsubscribe = useRef();
  const result = useCallback(
    (value) => {
      storedValue.current = value;
      if (unsubscribe.current) {
        unsubscribe.current();
        unsubscribe.current = void 0;
      }
      if (value) {
        unsubscribe.current = handler(value);
      }
    },
    [handler]
  );
  useEffect(() => {
    result(storedValue.current);
  }, [result]);
  return result;
};
var useCombinedRef = (refs) => {
  const initialRefs = useRef(refs);
  return useCallback((value) => {
    initialRefs.current.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  }, []);
};
var useDomEvent = (name, handler) => {
  return useCallback(
    (elem) => {
      elem.addEventListener(name, handler);
      return () => {
        elem.removeEventListener(name, handler);
      };
    },
    [name, handler]
  );
};
var usePersistentCallback = (f) => {
  const realF = useRef(f);
  useEffect(() => {
    realF.current = f;
  }, [f]);
  return useCallback((...args) => {
    return realF.current(...args);
  }, []);
};
var useDraggable = ({
  offsetBottom,
  onDrag
}) => {
  const screenDimensions = useWindowDimensions();
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({
    x: Infinity,
    y: Infinity
  });
  const [dimensions, setDimensions] = useState({
    height: 0,
    width: 0,
    screenHeight: screenDimensions.y,
    screenWidth: screenDimensions.x
  });
  useEffect(() => {
    setDimensions((prev) => __spreadProps(__spreadValues({}, prev), {
      screenHeight: screenDimensions.y,
      screenWidth: screenDimensions.x
    }));
  }, [screenDimensions.x, screenDimensions.y]);
  const ref = useRef();
  const handleMouseDown = useCallback(
    (e) => {
      if (isDragging) {
        e.preventDefault();
      }
      if (e.button !== 0) {
        return;
      }
      setIsDragging(true);
    },
    [isDragging]
  );
  useEffect(() => {
    if (!ref.current)
      return;
    const elem = ref.current;
    const height = ref.current.offsetHeight;
    const width = ref.current.offsetWidth;
    if (position.x === Infinity || position.y === Infinity) {
      const initialPosition = {
        x: (screenDimensions.x - width) / 2,
        y: screenDimensions.y - height - offsetBottom
      };
      setPosition(initialPosition);
      elem.style.userSelect = "none";
      elem.style.left = initialPosition.x + "px";
      elem.style.top = initialPosition.y + "px";
    }
    setDimensions({
      height,
      width,
      screenHeight: screenDimensions.y,
      screenWidth: screenDimensions.x
    });
    return () => {
      elem.style.userSelect = "auto";
    };
  }, [offsetBottom, screenDimensions.x, screenDimensions.y]);
  const subscribeMouseDown = useDomEvent(
    "pointerdown",
    handleMouseDown
  );
  const ref2 = useRefEffect(subscribeMouseDown);
  const combinedRef = useCombinedRef([ref, ref2]);
  const onDragWithCurriedDimensions = useCallback(
    (delta) => {
      return onDrag({
        width: dimensions.width,
        height: dimensions.height,
        screenHeight: dimensions.screenHeight,
        screenWidth: dimensions.screenWidth
      })(delta);
    },
    [
      onDrag,
      dimensions.width,
      dimensions.height,
      dimensions.screenHeight,
      dimensions.screenWidth
    ]
  );
  const persistentOnDrag = usePersistentCallback(onDragWithCurriedDimensions);
  useEffect(() => {
    if (!isDragging) {
      return;
    }
    let delta = position, lastPosition = position;
    const applyTransform = () => {
      if (!ref.current) {
        return;
      }
      const { x, y: y2 } = lastPosition;
      ref.current.style.left = `${x}px`;
      ref.current.style.top = `${y2}px`;
    };
    const handleMouseMove = throttle((e) => {
      e.preventDefault();
      const { x, y: y2 } = delta;
      delta = { x: x + e.movementX, y: y2 + e.movementY };
      lastPosition = persistentOnDrag(delta);
      applyTransform();
    });
    const handleMouseUp = (e) => {
      handleMouseMove(e);
      setIsDragging(false);
      setPosition(lastPosition);
    };
    const terminate = () => {
      lastPosition = position;
      applyTransform();
      setIsDragging(false);
    };
    const handleKeyDown = (e) => {
      if (e.code === "Escape") {
        e.preventDefault();
        terminate();
      }
    };
    document.addEventListener("pointermove", handleMouseMove);
    document.addEventListener("pointerup", handleMouseUp);
    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("blur", terminate);
    return () => {
      handleMouseMove.cancel();
      document.removeEventListener("pointermove", handleMouseMove);
      document.removeEventListener("pointerup", handleMouseUp);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("blur", terminate);
    };
  }, [position, isDragging, persistentOnDrag]);
  return [combinedRef, isDragging, position];
};
var useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    x: window.innerWidth,
    y: window.innerHeight
  });
  const onResize = useCallback(() => {
    setWindowDimensions({
      x: window.innerWidth,
      y: window.innerHeight
    });
  }, []);
  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [onResize]);
  return windowDimensions;
};
function useActionBar({ offsetBottom = 50 }) {
  const onDrag = useCallback(
    ({ height, width, screenHeight, screenWidth }) => ({ x, y: y2 }) => ({
      x: Math.max(0, Math.min(x, screenWidth - width)),
      y: Math.max(0, Math.min(y2, screenHeight - height))
    }),
    []
  );
  const [ref, isDragging, position] = useDraggable({
    offsetBottom,
    onDrag
  });
  return {
    ref,
    isDragging,
    position
  };
}

// src/components/ActionBar/ActionBar.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Container = (_a) => {
  var _b = _a, { open } = _b, props = __objRest(_b, ["open"]);
  if (!open)
    return null;
  return /* @__PURE__ */ jsx3(ActionBar, __spreadValues({}, props));
};
var ActionBar = ({
  className,
  children,
  maxWidth = 900,
  offsetBottom = 50
}) => {
  const { ref } = useActionBar({
    offsetBottom
  });
  return /* @__PURE__ */ jsx3(
    "div",
    {
      ref,
      style: {
        maxWidth,
        zIndex: 9999
      },
      className: cn(
        "tw-flex tw-text-white tw-bg-light-900 dark:tw-text-black dark:bg-light-50 tw-w-auto tw-items-center tw-fixed tw-shadow-xl tw-rounded-md tw-p-2 tw-cursor-move",
        className
      ),
      children
    }
  );
};

// src/components/Alert/Alert.tsx
import { cva } from "class-variance-authority";
import { forwardRef as forwardRef2 } from "react";
import {
  MdCheckCircle,
  MdClose,
  MdError,
  MdInfo,
  MdWarning
} from "@teamworksdev/icons";

// ../teamworks-style/dist/index.mjs
var colors = {
  white: "#ffffff",
  black: "#000000",
  gray: {
    DEFAULT: "#667085",
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F4F5F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#474567",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  primary: {
    DEFAULT: "#9E77ED",
    25: "#FCFAFF",
    50: "#F9F5FF",
    100: "#F4EBFF",
    200: "#E9D7FE",
    300: "#D6BBFB",
    400: "#B692F6",
    500: "#9E77ED",
    600: "#7F4ED9",
    700: "#6941C6",
    800: "#53389E",
    900: "#42307D"
  },
  error: {
    DEFAULT: "#F04438",
    25: "#FBECEB",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#EFB1AD",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#D83D32",
    800: "#918018",
    900: "#7A271A"
  },
  warning: {
    DEFAULT: "#F79009",
    25: "#FEF4E6",
    200: "#FCD39D",
    700: "#F79009",
    800: "#EF6820"
  },
  success: {
    DEFAULT: "#12B76A",
    25: "#E7F3EC",
    50: "#ECFDF3",
    100: "#D1FADF",
    200: "#B6DCC5",
    300: "#6CE9A6",
    400: "#32D583",
    500: "#12B76A",
    600: "#039855",
    700: "#0A893C",
    800: "#05603A",
    900: "#054F31"
  },
  info: {
    DEFAULT: "#045DFF",
    25: "#E6EFFF",
    200: "#9BBEFF",
    700: "#045DFF"
  },
  light: {
    25: "#FCFCFC",
    50: "#F8FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  dark: {
    25: "#E7E8E8",
    50: "#D0D0D0",
    100: "#B8B9B9",
    200: "#A0A1A2",
    300: "#898A8B",
    400: "#717373",
    500: "#595B5C",
    600: "#414445",
    700: "#2A2C2D",
    800: "#121516",
    900: "#0B0D0D"
  }
};

// src/components/Alert/Alert.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var alertVariants = cva(
  "tw-relative tw-z-[100] tw-rounded-lg tw-flex-1 tw-p-4 tw-m-4 tw-text-sm [&>svg+div]:tw-translate-y-[-3px] [&>svg]:tw-absolute [&>svg]:tw-left-4 [&>svg]:tw-top-4 [&>svg]:tw-text-foreground [&>svg~*]:tw-pl-7 data-[state=closed]:tw-hidden",
  {
    variants: {
      variant: {
        success: "tw-bg-success-25 tw-text-foreground",
        destructive: "tw-bg-error-25 tw-text-foreground",
        warning: "tw-bg-warning-25 tw-text-foreground",
        info: "tw-bg-info-25 tw-text-foreground"
      }
    },
    defaultVariants: {
      variant: "success"
    }
  }
);
var getAlertIcon = (variant) => {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx4(MdCheckCircle, { color: colors.success[700], size: 20 });
    case "destructive":
      return /* @__PURE__ */ jsx4(MdError, { color: colors.error[700], size: 20 });
    case "info":
      return /* @__PURE__ */ jsx4(MdInfo, { color: colors.info[700], size: 20 });
    case "warning":
      return /* @__PURE__ */ jsx4(MdWarning, { color: colors.warning[700], size: 20 });
    default:
      return null;
  }
};
var Alert = forwardRef2(
  (_a, ref) => {
    var _b = _a, { className, variant = "success", open = true, children } = _b, props = __objRest(_b, ["className", "variant", "open", "children"]);
    return /* @__PURE__ */ jsx4(
      "div",
      __spreadProps(__spreadValues({
        className: cn(alertVariants({ variant }), className),
        ref,
        role: "alert",
        "data-state": open ? "open" : "closed"
      }, props), {
        children: /* @__PURE__ */ jsxs2("div", { className: "tw-flex tw-flex-row tw-space-x-2", children: [
          getAlertIcon(variant),
          /* @__PURE__ */ jsx4("div", { className: "tw-flex-1", children })
        ] })
      })
    );
  }
);
Alert.displayName = "Alert";
var AlertTitle = forwardRef2((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    "h5",
    __spreadValues({
      className: cn(
        "tw-mb-1 tw-text-sm tw-font-semibold tw-leading{18}",
        className
      ),
      ref
    }, props)
  );
});
AlertTitle.displayName = "AlertTitle";
var AlertDescription = forwardRef2((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    "div",
    __spreadValues({
      className: cn("tw-text-sm [&_p]:tw-leading-relaxed", className),
      ref
    }, props)
  );
});
AlertDescription.displayName = "AlertDescription";
var AlertFooter = forwardRef2((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    "div",
    __spreadValues({
      className: cn("tw-flex tw-space-x-2 tw-text-sm tw-mt-4", className),
      ref
    }, props)
  );
});
AlertFooter.displayName = "AlertFooter";
var AlertClose = forwardRef2((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    "button",
    __spreadProps(__spreadValues({
      className: cn(
        "tw-absolute tw-right-4 tw-top-0 tw-translate-y-1/2 tw-text-foreground",
        className
      ),
      ref,
      type: "button"
    }, props), {
      children: /* @__PURE__ */ jsx4(MdClose, { size: 20 })
    })
  );
});
AlertClose.displayName = "AlertClose";

// src/components/Avatar/Avatar.tsx
import { cva as cva2 } from "class-variance-authority";
import {
  Children,
  createContext,
  forwardRef as forwardRef3,
  useContext,
  useEffect as useEffect2,
  useState as useState2
} from "react";
import { Fragment, jsx as jsx5 } from "react/jsx-runtime";
var avatarVariants = cva2(
  "tw-inline-flex tw-overflow-hidden tw-rounded-full tw-items-center tw-justify-center tw-text-white",
  {
    variants: {
      size: {
        xl: "tw-h-16 tw-w-16 tw-text-2xl",
        lg: "tw-h-10 tw-w-10 tw-text-xl",
        md: "tw-h-9 tw-w-9 tw-text-lg",
        sm: "tw-h-7 tw-w-7 tw-text-base",
        xs: "tw-h-6 tw-w-6 tw-text-sm",
        xxs: "tw-h-5 tw-w-5 tw-text-xs",
        xxxs: "tw-h-4 tw-w-4 tw-text-xs",
        xxxxs: "tw-h-3.5 tw-w-3.5 tw-text-xs",
        xxxxxs: "tw-h-3 tw-w-3 tw-text-xs"
      },
      isGroup: {
        true: "tw-ring-2 tw-ring-white"
      }
    },
    defaultVariants: {
      size: "lg",
      isGroup: false
    }
  }
);
var Avatar = forwardRef3(
  (_a, ref) => {
    var _b = _a, { className, name, src, size, children } = _b, props = __objRest(_b, ["className", "name", "src", "size", "children"]);
    var _a2, _b2;
    const isGroup = !!((_a2 = useAvatarGroupContext()) == null ? void 0 : _a2.limit);
    const avatarGroupSize = (_b2 = useAvatarGroupContext()) == null ? void 0 : _b2.size;
    const avatarSize = size != null ? size : avatarGroupSize;
    const avatarInitials = initials(name != null ? name : "");
    const [hasError, setHasError] = useState2(false);
    return src && !hasError ? /* @__PURE__ */ jsx5(
      "img",
      {
        className: cn(
          avatarVariants({ size, className, isGroup }),
          "tw-object-cover tw-bg-black/10 tw-border tw-border-black/10"
        ),
        alt: name != null ? name : "avatar",
        src,
        onError: () => setHasError(true)
      }
    ) : /* @__PURE__ */ jsx5(
      "span",
      __spreadProps(__spreadValues({
        className: cn(
          avatarVariants({
            size: avatarSize,
            className,
            isGroup
          }),
          "tw-bg-light-400"
        )
      }, props), {
        ref,
        children: /* @__PURE__ */ jsx5(Fragment, { children: avatarInitials ? /* @__PURE__ */ jsx5("span", { className: "tw-text-white", children: avatarInitials }) : /* @__PURE__ */ jsx5(
          "svg",
          {
            className: "tw-h-full tw-w-full tw-text-light-700",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ jsx5("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
          }
        ) })
      })
    );
  }
);
Avatar.displayName = "Avatar";
function initials(name) {
  var _a;
  const names = name.split(" ");
  const firstName = (_a = names[0]) != null ? _a : "";
  const lastName = names.length > 1 ? names[names.length - 1] : "";
  return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
var AvatarGroupContext = createContext({
  size: "lg"
});
var AvatarGroupProvider = ({
  children,
  limit,
  size
}) => {
  const [count2, setCount] = useState2(0);
  return /* @__PURE__ */ jsx5(
    AvatarGroupContext.Provider,
    {
      value: {
        count: count2,
        setCount,
        limit,
        size
      },
      children
    }
  );
};
var useAvatarGroupContext = () => useContext(AvatarGroupContext);
var AvatarGroup = forwardRef3(
  (_a, ref) => {
    var _b = _a, { children, className, limit, size = "lg" } = _b, props = __objRest(_b, ["children", "className", "limit", "size"]);
    return /* @__PURE__ */ jsx5(AvatarGroupProvider, { limit, size, children: /* @__PURE__ */ jsx5(
      "div",
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "tw-flex tw-items-center tw-justify-start tw--space-x-4",
          className
        )
      }, props), {
        children
      })
    ) });
  }
);
AvatarGroup.displayName = "AvatarGroup";
var AvatarGroupList = ({ children }) => {
  const { limit, setCount } = useAvatarGroupContext();
  useEffect2(() => {
    setCount == null ? void 0 : setCount(Children.count(children));
  }, [children, setCount]);
  return /* @__PURE__ */ jsx5(Fragment, { children: limit ? Children.toArray(children).slice(0, limit) : children });
};
var AvatarOverflowIndicator = forwardRef3((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { limit, count: count2, size } = useAvatarGroupContext();
  if (!limit || !count2 || count2 <= limit)
    return null;
  return /* @__PURE__ */ jsx5(
    "span",
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        avatarVariants({ size, isGroup: true }),
        "tw-relative tw-flex tw-bg-light-400",
        className
      )
    }, props), {
      children: count2 - limit
    })
  );
});
AvatarOverflowIndicator.displayName = "AvatarOverflowIndicator";

// src/components/Badge/Badge.tsx
import { cva as cva3 } from "class-variance-authority";
import { jsx as jsx6 } from "react/jsx-runtime";
var base = ["tw-text-xs tw-rounded-full tw-px-2 tw-py-0.5"];
var badgeVariants = cva3(base, {
  variants: {
    colorScheme: {
      count: "tw-bg-info-25 tw-text-info-700",
      default: "tw-bg-light-600 tw-text-white",
      destructive: "tw-bg-error-700 tw-text-white",
      info: "tw-bg-info-700 tw-text-white",
      success: "tw-bg-success-700 tw-text-white",
      warning: "tw-bg-warning-800 tw-text-white"
    }
  }
});
var Badge = (props) => {
  const { value, className, colorScheme, maxValue = 99 } = props;
  if (!value)
    return null;
  return /* @__PURE__ */ jsx6(
    "span",
    {
      className: cn(
        badgeVariants({
          colorScheme
        }),
        className
      ),
      children: value > maxValue ? `${maxValue}+` : value
    }
  );
};

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { cloneElement as cloneElement2, forwardRef as forwardRef5 } from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@teamworksdev/icons";

// src/components/Button/Button.tsx
import { Slot, Slottable } from "@radix-ui/react-slot";
import { cva as cva4 } from "class-variance-authority";
import { cloneElement, forwardRef as forwardRef4 } from "react";
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var base2 = [
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap",
  // layout
  "tw-font-semibold tw-transition-all tw-cursor-pointer",
  // appearance
  "focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 tw-ring-offset-white ",
  // focus
  "disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
  // disabled
].join(" ");
var buttonVariants = cva4(base2, {
  variants: {
    colorScheme: {
      default: "",
      destructive: "",
      info: "",
      warning: "",
      success: ""
    },
    variant: {
      primary: "tw-shadow",
      secondary: "tw-border tw-shadow",
      ghost: "tw-shadow-none",
      link: "tw-underline-offset-4 hover:tw-underline"
    },
    size: {
      sm: "tw-h-7 tw-rounded-md tw-text-xs",
      md: "tw-h-9 tw-text-sm",
      lg: "tw-h-11 tw-rounded-md tw-text-base"
    },
    isDisabled: {
      true: "tw-opacity-50 disabled:tw-cursor-not-allowed"
    },
    isLoading: {
      true: "tw-opacity-50 tw-pointer-events-none"
    },
    isIcon: {
      false: "tw-px-4"
    },
    isRound: {
      true: "tw-rounded-full",
      false: "tw-rounded-md"
    }
  },
  compoundVariants: [
    {
      colorScheme: "default",
      variant: "primary",
      class: "tw-bg-black tw-text-white hover:tw-bg-black/90 hover:tw-text-white"
    },
    {
      colorScheme: "default",
      variant: "secondary",
      class: "tw-border-light-300 tw-text-black tw-bg-white hover:tw-bg-light-100 hover:tw-text-black"
    },
    {
      colorScheme: "default",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-light-200 tw-text-black hover:tw-text-black"
    },
    {
      colorScheme: "default",
      variant: "link",
      class: "tw-text-black hover:tw-text-black"
    },
    {
      colorScheme: "destructive",
      variant: "primary",
      class: "tw-bg-error-700 tw-text-white hover:tw-bg-error-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "destructive",
      variant: "secondary",
      class: "tw-border-error-200 tw-text-error-700 tw-bg-white hover:tw-bg-error-100 hover:tw-text-error-700"
    },
    {
      colorScheme: "destructive",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-error-200 tw-text-error-700 hover:tw-text-error-700"
    },
    {
      colorScheme: "destructive",
      variant: "link",
      class: "tw-text-error-700 hover:tw-text-error-700"
    },
    {
      colorScheme: "info",
      variant: "primary",
      class: "tw-bg-info-700 tw-text-white hover:tw-bg-info-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "info",
      variant: "secondary",
      class: "tw-border-info-200 tw-text-info-700 tw-bg-white hover:tw-bg-info-25 hover:tw-text-info-700"
    },
    {
      colorScheme: "info",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-info-25 tw-text-info-700 hover:tw-text-info-700"
    },
    {
      colorScheme: "info",
      variant: "link",
      class: "tw-text-info-700 hover:tw-text-info-700"
    },
    {
      colorScheme: "warning",
      variant: "primary",
      class: "tw-bg-warning-800 tw-text-white hover:tw-bg-warning-800/90 hover:tw-text-white"
    },
    {
      colorScheme: "warning",
      variant: "secondary",
      class: "tw-border-warning-200 tw-text-warning-800 tw-bg-white hover:tw-bg-warning-200 hover:tw-text-warning-800"
    },
    {
      colorScheme: "warning",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-warning-25 tw-text-warning-800 hover:tw-text-warning-800"
    },
    {
      colorScheme: "warning",
      variant: "link",
      class: "tw-text-warning-800 hover:tw-text-warning-800"
    },
    {
      colorScheme: "success",
      variant: "primary",
      class: "tw-bg-success-700 tw-text-white hover:tw-bg-success-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "success",
      variant: "secondary",
      class: "tw-border-success-200 tw-text-success-700 tw-bg-white hover:tw-bg-success-25 hover:tw-text-success-700"
    },
    {
      colorScheme: "success",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-success-25 tw-text-success-700 hover:tw-text-success-700"
    },
    {
      colorScheme: "success",
      variant: "link",
      class: "tw-text-success-700 hover:tw-text-success-700"
    },
    {
      size: "sm",
      isIcon: true,
      class: "tw-w-7"
    },
    {
      size: "md",
      isIcon: true,
      class: "tw-w-9"
    },
    {
      size: "lg",
      isIcon: true,
      class: "tw-w-11"
    }
  ],
  defaultVariants: {
    variant: "primary",
    colorScheme: "default",
    size: "md",
    isRound: false
  }
});
var Button = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      asChild = false,
      className,
      colorScheme,
      disableAnimation,
      variant,
      size,
      isDisabled,
      isIcon = false,
      isLoading,
      isRound = false,
      leftIcon,
      rightIcon,
      children
    } = _b, props = __objRest(_b, [
      "asChild",
      "className",
      "colorScheme",
      "disableAnimation",
      "variant",
      "size",
      "isDisabled",
      "isIcon",
      "isLoading",
      "isRound",
      "leftIcon",
      "rightIcon",
      "children"
    ]);
    var _a2, _b2, _c;
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsxs3(
      Comp,
      __spreadProps(__spreadValues({}, props), {
        className: cn([
          buttonVariants({
            colorScheme,
            variant,
            size,
            isDisabled,
            isIcon,
            isLoading,
            isRound,
            className
          }),
          { "tw-button-transform": !disableAnimation }
          // on press animation
        ]),
        type: asChild ? void 0 : (_a2 = props.type) != null ? _a2 : "button",
        disabled: isDisabled || props.disabled,
        role: asChild ? void 0 : "button",
        ref,
        children: [
          isLoading && /* @__PURE__ */ jsx7(Loader, {}),
          !isLoading && leftIcon && cloneElement(leftIcon, {
            className: !((_b2 = leftIcon.props) == null ? void 0 : _b2.size) ? cn("tw-mr-2 tw-h-4 tw-w-4", leftIcon.props.className) : cn("tw-mr-2", leftIcon.props.className)
          }),
          /* @__PURE__ */ jsx7(Slottable, { children }),
          rightIcon && cloneElement(rightIcon, {
            className: !((_c = rightIcon.props) == null ? void 0 : _c.size) ? cn("tw-ml-2 tw-h-4 tw-w-4", rightIcon.props.className) : cn("tw-ml-2", rightIcon.props.className)
          })
        ]
      })
    );
  }
);
Button.displayName = "Button";
function Loader() {
  return /* @__PURE__ */ jsx7(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin",
      children: /* @__PURE__ */ jsx7("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
    }
  );
}

// src/utils/react.tsx
import { Children as Children2, isValidElement } from "react";
function getValidChildren(children) {
  return Children2.toArray(children).filter(
    (child) => isValidElement(child)
  );
}

// src/components/Breadcrumbs/useBreadcrumbs.tsx
import { useContext as useContext2 } from "react";
import { createContext as createContext2 } from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var BreadcrumbsContext = createContext2(false);
var BreadcrumbsProvider = ({
  children,
  useReactRouter = false
}) => {
  return /* @__PURE__ */ jsx8(BreadcrumbsContext.Provider, { value: useReactRouter, children });
};
var useBreadcrumbs = () => {
  const useReactRouter = useContext2(BreadcrumbsContext);
  return useReactRouter;
};

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
var Breadcrumbs = forwardRef5((_a, ref) => {
  var _b = _a, { className, children, useReactRouter = true } = _b, props = __objRest(_b, ["className", "children", "useReactRouter"]);
  const validChildren = getValidChildren(children);
  const count2 = validChildren.length;
  const clones = validChildren.map(
    (child, index) => cloneElement2(child, {
      isFirstChild: index === 0,
      isLastChild: index === count2 - 1
    })
  );
  return /* @__PURE__ */ jsx9(
    "nav",
    __spreadProps(__spreadValues({
      "aria-label": "Breadcrumb",
      ref,
      className: cn("tw-reset tw-flex", className)
    }, props), {
      children: /* @__PURE__ */ jsx9("ol", { className: "tw-inline-flex tw-items-center tw-space-x-1 tw-md:space-x-3", children: /* @__PURE__ */ jsx9(BreadcrumbsProvider, { useReactRouter, children: clones }) })
    })
  );
});
Breadcrumbs.displayName = "Breadcrumbs";
var BreadcrumbItem = forwardRef5((_a, ref) => {
  var _b = _a, { className, children, isFirstChild, isLastChild } = _b, props = __objRest(_b, ["className", "children", "isFirstChild", "isLastChild"]);
  return /* @__PURE__ */ jsxs4(
    "li",
    __spreadProps(__spreadValues({
      ref,
      className: cn("tw-inline-flex tw-items-center", className)
    }, props), {
      children: [
        !isFirstChild && /* @__PURE__ */ jsx9(ChevronRightIcon, { className: "tw-text-black/60 tw-h-3 tw-w-3" }),
        children
      ]
    })
  );
});
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = forwardRef5((_a, ref) => {
  var _b = _a, { className, children, isCurrentPage } = _b, props = __objRest(_b, ["className", "children", "isCurrentPage"]);
  const useReactRouter = useBreadcrumbs();
  return /* @__PURE__ */ jsx9(Button, { variant: "ghost", className: cn("tw-px-2", className), asChild: true, children: isCurrentPage ? /* @__PURE__ */ jsx9("span", __spreadProps(__spreadValues({ "aria-current": "page", ref }, props), { children })) : useReactRouter ? /* @__PURE__ */ jsx9(Link, __spreadProps(__spreadValues({ ref }, props), { children })) : /* @__PURE__ */ jsx9("a", __spreadProps(__spreadValues({ href: props.to, ref }, props), { children })) });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/components/Calendar/Calendar.tsx
import {
  CalendarDate,
  createCalendar,
  getLocalTimeZone as getLocalTimeZone3,
  today
} from "@internationalized/date";
import { useCalendar } from "@react-aria/calendar";
import { useCalendarState } from "@react-stately/calendar";
import { useEffect as useEffect3, useMemo, useRef as useRef4, useState as useState3 } from "react";

// src/components/Select/Select.tsx
import * as SelectPrimitive from "@radix-ui/react-select";
import { forwardRef as forwardRef6 } from "react";
import React from "react";
import {
  CheckIcon,
  MdKeyboardArrowDown as MdKeyboardArrowDown2,
  MdKeyboardArrowUp
} from "@teamworksdev/icons";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var Select = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const renderChildren = () => {
    return React.Children.map(children, (child) => {
      var _a2;
      if (React.isValidElement(child)) {
        return React.cloneElement(
          child,
          {
            "aria-invalid": (_a2 = props["aria-invalid"]) != null ? _a2 : "false"
          }
        );
      }
      return null;
    });
  };
  return /* @__PURE__ */ jsx10(SelectPrimitive.Root, __spreadProps(__spreadValues({}, props), { children: renderChildren() }));
};
Select.displayName = SelectPrimitive.Root.displayName;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = forwardRef6((_a, ref) => {
  var _b = _a, { className, children, useDefaultClassName = true } = _b, props = __objRest(_b, ["className", "children", "useDefaultClassName"]);
  return /* @__PURE__ */ jsxs5(
    SelectPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: useDefaultClassName ? cn(
        "tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-between tw-rounded-md tw-border tw-border-input tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-ring-offset-white placeholder:tw-text-light-300 focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-cursor-pointer",
        "aria-invalid:tw-focus-error",
        "tw-focus",
        className
      ) : className
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx10(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx10(MdKeyboardArrowDown2, { className: "tw-h-4 tw-w-4" }) })
      ]
    })
  );
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectContent = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      className,
      children,
      container,
      position = "popper",
      sideOffset = 5
    } = _b, props = __objRest(_b, [
      "className",
      "children",
      "container",
      "position",
      "sideOffset"
    ]);
    return /* @__PURE__ */ jsx10(SelectPrimitive.Portal, { container, children: /* @__PURE__ */ jsxs5(
      SelectPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "tw-relative tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-white tw-text-black tw-shadow-md tw-animate-in tw-fade-in-80",
          position === "popper" && "translate-y-1",
          className
        ),
        position,
        sideOffset
      }, props), {
        children: [
          /* @__PURE__ */ jsx10(SelectPrimitive.ScrollUpButton, { className: "tw-flex tw-flex-col tw-items-center", children: /* @__PURE__ */ jsx10(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx10(MdKeyboardArrowUp, { className: "tw-h-4 tw-w-4" }) }) }),
          /* @__PURE__ */ jsx10(
            SelectPrimitive.Viewport,
            {
              className: cn(
                "tw-p-1",
                position === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-w-full tw-min-w-[var(--radix-select-trigger-width)]"
              ),
              children
            }
          ),
          /* @__PURE__ */ jsx10(SelectPrimitive.ScrollDownButton, { className: "tw-flex tw-flex-col tw-items-center", children: /* @__PURE__ */ jsx10(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx10(MdKeyboardArrowDown2, { className: "tw-h-4 tw-w-4" }) }) })
        ]
      })
    ) });
  }
);
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = forwardRef6((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    SelectPrimitive.Label,
    __spreadValues({
      ref,
      className: cn(
        "tw-py-1.5 tw-pl-2 tw-pr-8 tw-text-sm tw-font-semibold",
        className
      )
    }, props)
  );
});
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = forwardRef6((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs5(
    SelectPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pr-8 tw-pl-2 tw-text-sm tw-outline-none focus:tw-bg-black/10 focus:tw-text-black data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 data-[disabled]:tw-text-black/60",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx10(SelectPrimitive.ItemText, { children }),
        /* @__PURE__ */ jsx10("span", { className: "tw-absolute tw-right-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx10(SelectPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx10(CheckIcon, { className: "tw-h-4 tw-w-4" }) }) })
      ]
    })
  );
});
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = forwardRef6((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    SelectPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("tw--mx-1 tw-my-1 tw-h-px tw-bg-light-200", className)
    }, props)
  );
});
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;

// src/components/Calendar/CalendarGrid.tsx
import { endOfMonth, getWeeksInMonth } from "@internationalized/date";
import { useCalendarGrid } from "@react-aria/calendar";

// src/components/Calendar/CalendarCell.tsx
import {
  getLocalTimeZone,
  isToday as isDateToday,
  isSameMonth
} from "@internationalized/date";
import { useCalendarCell } from "@react-aria/calendar";
import clsx2 from "clsx";
import { useRef as useRef2 } from "react";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var CalendarCell = ({
  state,
  date,
  currentMonth
}) => {
  const ref = useRef2(null);
  const {
    cellProps,
    buttonProps,
    isSelected,
    isInvalid,
    isDisabled,
    isUnavailable,
    isFocused,
    formattedDate
  } = useCalendarCell({ date }, state, ref);
  const isOutsideMonth = !isSameMonth(currentMonth, date);
  const isToday = isDateToday(date, getLocalTimeZone());
  return /* @__PURE__ */ jsxs6("td", __spreadProps(__spreadValues({ className: "tw-text-center relative" }, cellProps), { children: [
    /* @__PURE__ */ jsx11(
      Button,
      __spreadProps(__spreadValues({}, buttonProps), {
        ref,
        size: "sm",
        variant: isSelected ? "primary" : "ghost",
        className: clsx2(
          "tw-p-0 tw-w-8 tw-h-8 tw-rounded-full hover:tw-bg-info-25 tw-font-normal",
          {
            "tw-bg-info-200": isFocused,
            "tw-bg-info-700 tw-text-white hover:tw-bg-info-700": isSelected,
            "tw-opacity-50 hover:tw-bg-white focus:tw-bg-white": isInvalid || isDisabled || isUnavailable,
            "tw-hidden": isOutsideMonth
          }
        ),
        children: formattedDate
      })
    ),
    isToday && /* @__PURE__ */ jsx11(
      "span",
      {
        className: clsx2(
          "absolute tw-w-1 tw-h-1 tw-rounded-full tw-bottom-1 tw-left-1/2 tw-transform tw--translate-x-1/2",
          {
            "tw-bg-white": isSelected,
            "tw-bg-info-700 ": !isSelected
          }
        )
      }
    )
  ] }));
};
var CalendarCell_default = CalendarCell;

// src/components/Calendar/CalendarRangeCell.tsx
import {
  getDayOfWeek,
  getLocalTimeZone as getLocalTimeZone2,
  isToday as isDateToday2,
  isSameDay,
  isSameMonth as isSameMonth2
} from "@internationalized/date";
import { useCalendarCell as useCalendarCell2 } from "@react-aria/calendar";
import clsx3 from "clsx";
import { useRef as useRef3 } from "react";
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var CalendarRangeCell = ({
  state,
  date,
  currentMonth,
  locale = "en-US"
}) => {
  const ref = useRef3(null);
  const {
    cellProps,
    buttonProps,
    isSelected,
    isInvalid,
    isDisabled,
    isUnavailable,
    isFocused,
    formattedDate
  } = useCalendarCell2({ date }, state, ref);
  const isOutsideMonth = !isSameMonth2(currentMonth, date);
  const isToday = isDateToday2(date, getLocalTimeZone2());
  const isSelectionStart = state.highlightedRange ? isSameDay(date, state.highlightedRange.start) : isSelected;
  const isSelectionEnd = state.highlightedRange ? isSameDay(date, state.highlightedRange.end) : isSelected;
  const dayOfWeek = getDayOfWeek(date, locale);
  const isRoundedLeft = isSelected && (isSelectionStart || dayOfWeek === 0 || date.day === 1);
  const isRoundedRight = isSelected && (isSelectionEnd || dayOfWeek === 6 || date.day === date.calendar.getDaysInMonth(date));
  return /* @__PURE__ */ jsxs7("td", __spreadProps(__spreadValues({ className: "tw-text-center relative" }, cellProps), { children: [
    /* @__PURE__ */ jsx12(
      Button,
      __spreadProps(__spreadValues({}, buttonProps), {
        ref,
        size: "sm",
        variant: isSelected ? "primary" : "ghost",
        className: clsx3(
          "tw-p-0 tw-w-8 tw-h-8 tw-rounded-none tw-shadow-none tw-font-normal hover:tw-bg-info-25",
          {
            "tw-bg-info-200": isFocused,
            "tw-bg-info-700 tw-text-white hover:tw-bg-info-700": isSelected,
            "tw-opacity-50 hover:tw-bg-white focus:tw-bg-white": isInvalid || isDisabled || isUnavailable,
            "hover:tw-rounded-full": !isSelected,
            "tw-hidden": isOutsideMonth,
            "tw-rounded-l-full": isRoundedLeft,
            "tw-rounded-r-full": isRoundedRight,
            "tw-rounded-full": isFocused && !isSelected
          }
        ),
        children: formattedDate
      })
    ),
    isToday && /* @__PURE__ */ jsx12(
      "span",
      {
        className: clsx3(
          "absolute tw-w-1 tw-h-1 tw-bottom-1 tw-rounded-full tw-left-1/2 tw-transform tw--translate-x-1/2",
          {
            "tw-bg-white": isSelected,
            "tw-bg-info-700 ": !isSelected
          }
        )
      }
    )
  ] }));
};
var CalendarRangeCell_default = CalendarRangeCell;

// src/components/Calendar/CalendarGrid.tsx
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var CalendarGrid = ({
  state,
  locale,
  offset = {},
  isRangeCalendar = false
}) => {
  const startDate = state.visibleRange.start.add(offset);
  const endDate = endOfMonth(startDate);
  const { gridProps, headerProps, weekDays } = useCalendarGrid(
    {
      startDate,
      endDate
    },
    state
  );
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
  return /* @__PURE__ */ jsxs8(
    "table",
    __spreadProps(__spreadValues({}, gridProps), {
      className: "tw-w-full tw-border-collapse tw-space-y-1",
      cellPadding: isRangeCalendar ? "0" : void 0,
      children: [
        /* @__PURE__ */ jsx13("thead", __spreadProps(__spreadValues({}, headerProps), { children: /* @__PURE__ */ jsx13("tr", { children: weekDays.map((day, index) => /* @__PURE__ */ jsx13(
          "th",
          {
            className: "tw-text-light-500 tw-rounded-md w-8 tw-font-normal tw-text-[0.8rem]",
            children: day
          },
          index
        )) }) })),
        /* @__PURE__ */ jsx13("tbody", { children: [...new Array(weeksInMonth).keys()].map((weekIndex) => /* @__PURE__ */ jsx13("tr", { className: "tw-h-9", children: state.getDatesInWeek(weekIndex, startDate).map(
          (date, i) => date ? isRangeCalendar ? /* @__PURE__ */ jsx13(
            CalendarRangeCell_default,
            {
              state,
              date,
              currentMonth: startDate,
              locale
            },
            i
          ) : /* @__PURE__ */ jsx13(
            CalendarCell_default,
            {
              state,
              date,
              currentMonth: startDate
            },
            i
          ) : /* @__PURE__ */ jsx13("td", {}, i)
        ) }, weekIndex)) })
      ]
    })
  );
};
var CalendarGrid_default = CalendarGrid;

// src/components/Calendar/Calendar.tsx
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var Calendar = (_a) => {
  var _b = _a, {
    bordered = true,
    selectedMonth,
    setSelectedMonth,
    selectedYear,
    setSelectedYear
  } = _b, props = __objRest(_b, [
    "bordered",
    "selectedMonth",
    "setSelectedMonth",
    "selectedYear",
    "setSelectedYear"
  ]);
  var _a2, _b2, _c, _d;
  const state = useCalendarState(__spreadProps(__spreadValues({}, props), {
    locale: (_a2 = props.locale) != null ? _a2 : "en-US",
    createCalendar
  }));
  const ref = useRef4(null);
  const todaysDate = useMemo(() => today(getLocalTimeZone3()), []);
  const { calendarProps } = useCalendar(props, state);
  const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState3(false);
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState3(false);
  const [isMonthFieldFocused, setIsMonthFieldFocused] = useState3(false);
  const [isYearFieldFocused, setIsYearFieldFocused] = useState3(false);
  useEffect3(() => {
    var _a3, _b3;
    state.setFocusedDate(
      new CalendarDate(
        selectedYear,
        selectedMonth,
        (_b3 = (_a3 = state.value) == null ? void 0 : _a3.day) != null ? _b3 : todaysDate.day
      )
    );
  }, [selectedMonth, selectedYear]);
  return /* @__PURE__ */ jsxs9(
    "div",
    __spreadProps(__spreadValues({}, calendarProps), {
      ref,
      className: cn("tw-p-4 ", {
        "tw-rounded-md tw-border tw-shadow": bordered
      }),
      children: [
        /* @__PURE__ */ jsxs9(
          "div",
          {
            className: "tw-flex tw-items-center tw-justify-center tw-pb-4",
            onKeyDown: (e) => {
              if (e.key === "Escape") {
                if (isMonthDropdownOpen) {
                  e.stopPropagation();
                  setIsMonthDropdownOpen(false);
                  setIsMonthFieldFocused(false);
                }
                if (isYearDropdownOpen) {
                  e.stopPropagation();
                  setIsYearDropdownOpen(false);
                  setIsYearFieldFocused(false);
                }
              }
            },
            children: [
              /* @__PURE__ */ jsx14(
                MonthDropdown,
                {
                  state,
                  locale: (_b2 = props.locale) != null ? _b2 : "en-US",
                  selectedMonth,
                  setSelectedMonth,
                  isMonthDropdownOpen,
                  setIsMonthDropdownOpen,
                  isMonthFieldFocused,
                  setIsMonthFieldFocused
                }
              ),
              /* @__PURE__ */ jsx14("div", { className: "tw-ml-3 tw-mr-3" }),
              /* @__PURE__ */ jsx14(
                YearDropdown,
                {
                  state,
                  locale: (_c = props.locale) != null ? _c : "en-US",
                  selectedYear,
                  setSelectedYear,
                  isYearDropdownOpen,
                  setIsYearDropdownOpen,
                  isYearFieldFocused,
                  setIsYearFieldFocused
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx14(CalendarGrid_default, { state, locale: (_d = props.locale) != null ? _d : "en-US" })
      ]
    })
  );
};
var Calendar_default = Calendar;
var MonthDropdown = ({
  state,
  locale,
  selectedMonth,
  setSelectedMonth,
  isMonthDropdownOpen,
  setIsMonthDropdownOpen,
  isMonthFieldFocused,
  setIsMonthFieldFocused
}) => {
  const months = [];
  const dateFormatter = useMemo(() => {
    return new Intl.DateTimeFormat(locale, {
      month: "long",
      timeZone: state.timeZone
    });
  }, [locale, state.timeZone]);
  const numMonths = state.focusedDate.calendar.getMonthsInYear(
    state.focusedDate
  );
  for (let i = 1; i <= numMonths; i++) {
    const date = state.focusedDate.set({ month: i });
    months.push({
      value: String(i),
      label: dateFormatter.format(date.toDate(state.timeZone))
    });
  }
  const onChange = (month) => {
    const value = Number(month);
    setSelectedMonth(value);
  };
  return /* @__PURE__ */ jsx14(
    "div",
    {
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      },
      children: /* @__PURE__ */ jsxs9(
        Select,
        {
          value: String(selectedMonth),
          onValueChange: onChange,
          onOpenChange: (open) => {
            setIsMonthDropdownOpen(open);
            setIsMonthFieldFocused(open);
          },
          open: isMonthDropdownOpen,
          children: [
            /* @__PURE__ */ jsx14(
              SelectTrigger,
              {
                className: cn(
                  "tw-flex tw-items-center tw-font-semibold tw-text-base tw-rounded-md hover:tw-bg-light-100 hover:tw-rounded-md",
                  "tw-transition-colors tw-duration-200 tw-ease-in-out tw-bg-transparent tw-p-1 tw-cursor-pointer focus:tw-ring-1 focus:tw-ring-offset-1",
                  isMonthFieldFocused && "tw-bg-light-100"
                ),
                useDefaultClassName: false,
                "aria-label": "Month",
                children: /* @__PURE__ */ jsx14(SelectValue, { children: dateFormatter.format(state.focusedDate.toDate(state.timeZone)) })
              }
            ),
            /* @__PURE__ */ jsx14(SelectContent, { children: months.map((month) => /* @__PURE__ */ jsx14(
              SelectItem,
              {
                "aria-label": month.label,
                value: month.value,
                className: "tw-cursor-pointer",
                children: month.label
              },
              month.value
            )) })
          ]
        }
      )
    }
  );
};
var YearDropdown = ({
  state,
  locale,
  selectedYear,
  setSelectedYear,
  isYearDropdownOpen,
  setIsYearDropdownOpen,
  isYearFieldFocused,
  setIsYearFieldFocused
}) => {
  const years = [];
  const dateFormatter = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    timeZone: state.timeZone
  });
  for (let i = -50; i <= 50; i++) {
    const date = state.focusedDate.add({ years: i });
    const { year } = date;
    years.push({
      value: String(year),
      label: dateFormatter.format(date.toDate(state.timeZone))
    });
  }
  const onChange = (year) => {
    const value = Number(year);
    setSelectedYear(value);
  };
  return /* @__PURE__ */ jsx14(
    "div",
    {
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      },
      children: /* @__PURE__ */ jsxs9(
        Select,
        {
          value: String(selectedYear),
          onValueChange: onChange,
          onOpenChange: (open) => {
            setIsYearDropdownOpen(open);
            setIsYearFieldFocused(open);
          },
          open: isYearDropdownOpen,
          children: [
            /* @__PURE__ */ jsx14(
              SelectTrigger,
              {
                className: cn(
                  "tw-flex tw-items-center tw-font-semibold tw-text-base tw-rounded-md hover:tw-bg-light-100 hover:tw-rounded-md",
                  "tw-transition-colors tw-duration-200 tw-ease-in-out tw-bg-transparent tw-p-1 tw-cursor-pointer focus:tw-ring-1 focus:tw-ring-offset-1",
                  isYearFieldFocused && "tw-bg-light-100"
                ),
                useDefaultClassName: false,
                "aria-label": "Year",
                children: /* @__PURE__ */ jsx14(SelectValue, { children: dateFormatter.format(state.focusedDate.toDate(state.timeZone)) })
              }
            ),
            /* @__PURE__ */ jsx14(SelectContent, { className: "tw-h-[400px]", children: years.map((year) => /* @__PURE__ */ jsx14(
              SelectItem,
              {
                value: year.value,
                className: "tw-cursor-pointer",
                children: year.label
              },
              year.value
            )) })
          ]
        }
      )
    }
  );
};

// src/components/Calendar/CalendarRange.tsx
import { createCalendar as createCalendar2 } from "@internationalized/date";
import { useRangeCalendar } from "@react-aria/calendar";
import { useRangeCalendarState } from "@react-stately/calendar";
import clsx4 from "clsx";
import { useEffect as useEffect4, useMemo as useMemo2, useRef as useRef6 } from "react";
import {
  MdChevronLeft,
  MdChevronRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight
} from "@teamworksdev/icons";

// src/components/Calendar/CalendarButton.tsx
import { useButton } from "@react-aria/button";
import { useRef as useRef5 } from "react";

// src/components/IconButton/IconButton.tsx
import { cloneElement as cloneElement3, forwardRef as forwardRef7, isValidElement as isValidElement2 } from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var IconButton = forwardRef7(
  (_a, ref) => {
    var _b = _a, { icon, "aria-label": ariaLabel, isRound, children } = _b, props = __objRest(_b, ["icon", "aria-label", "isRound", "children"]);
    const element = icon || children;
    const _children = isValidElement2(element) ? cloneElement3(element, {
      "aria-hidden": true,
      focusable: false
    }) : null;
    return /* @__PURE__ */ jsx15(
      Button,
      __spreadProps(__spreadValues({
        "aria-label": ariaLabel,
        ref,
        isIcon: true,
        isRound
      }, props), {
        children: _children
      })
    );
  }
);
IconButton.displayName = "IconButton";

// src/components/Calendar/CalendarButton.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var CalendarButton = (props) => {
  const ref = useRef5(null);
  let { buttonProps } = useButton(props, ref);
  return /* @__PURE__ */ jsx16(
    IconButton,
    __spreadProps(__spreadValues({}, buttonProps), {
      icon: props.icon,
      "aria-label": props["aria-label"],
      className: props.className,
      variant: props.variant
    })
  );
};

// src/components/Calendar/CalendarRange.tsx
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var CalendarRange = (_a) => {
  var _b = _a, {
    bordered = true,
    locale = "en-US"
  } = _b, props = __objRest(_b, [
    "bordered",
    "locale"
  ]);
  const state = useRangeCalendarState(__spreadProps(__spreadValues({}, props), {
    visibleDuration: { months: 2 },
    locale,
    createCalendar: createCalendar2
  }));
  useEffect4(() => {
    var _a2;
    if (!((_a2 = props.value) == null ? void 0 : _a2.start))
      return;
    state.setFocusedDate(props.value.start);
  }, [props.value]);
  const ref = useRef6(null);
  const { calendarProps, prevButtonProps, nextButtonProps } = useRangeCalendar(
    props,
    state,
    ref
  );
  const startTitle = useLocalizedTitle(
    state.visibleRange.start,
    state.timeZone,
    locale
  );
  const endTitle = useLocalizedTitle(
    state.visibleRange.end,
    state.timeZone,
    locale
  );
  const numMonths = state.focusedDate.calendar.getMonthsInYear(
    state.focusedDate
  );
  const handlePrevYear = () => {
    state.setFocusedDate(
      state.visibleRange.start.subtract({ months: numMonths - 1 })
    );
  };
  const handleNextYear = () => {
    state.setFocusedDate(state.visibleRange.start.add({ years: 1 }));
  };
  return /* @__PURE__ */ jsxs10("div", __spreadProps(__spreadValues({}, calendarProps), { ref, className: "tw-flex", children: [
    /* @__PURE__ */ jsxs10(
      "div",
      {
        className: clsx4("tw-p-4 tw-border-r tw-border-light-200", {
          "tw-rounded-md tw-border tw-shadow": bordered
        }),
        children: [
          /* @__PURE__ */ jsxs10("div", { className: "tw-flex tw-items-center tw-pb-4", children: [
            /* @__PURE__ */ jsx17(
              CalendarButton,
              {
                onClick: handlePrevYear,
                "aria-label": "Previous Year",
                className: "tw-rounded-full",
                icon: /* @__PURE__ */ jsx17(MdOutlineKeyboardDoubleArrowLeft, {}),
                size: "sm",
                variant: "ghost"
              }
            ),
            /* @__PURE__ */ jsx17(
              CalendarButton,
              __spreadProps(__spreadValues({}, prevButtonProps), {
                "aria-label": "Previous Month",
                className: "tw-rounded-full",
                icon: /* @__PURE__ */ jsx17(MdChevronLeft, {}),
                size: "sm",
                variant: "ghost"
              })
            ),
            /* @__PURE__ */ jsx17("div", { className: "tw-font-semibold tw-text-left tw-text-base tw-flex-1 tw-pl-2", children: startTitle })
          ] }),
          /* @__PURE__ */ jsx17("div", { className: "tw-flex tw-gap-8", children: /* @__PURE__ */ jsx17(CalendarGrid_default, { state, locale, isRangeCalendar: true }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs10(
      "div",
      {
        className: clsx4("tw-p-4 ", {
          "tw-rounded-md tw-border tw-shadow": bordered
        }),
        children: [
          /* @__PURE__ */ jsxs10("div", { className: "tw-flex tw-items-center tw-pb-4", children: [
            /* @__PURE__ */ jsx17("div", { className: "tw-font-semibold tw-text-right tw-text-base tw-flex-1 tw-pr-2", children: endTitle }),
            /* @__PURE__ */ jsx17(
              CalendarButton,
              __spreadProps(__spreadValues({}, nextButtonProps), {
                "aria-label": "Next Month",
                className: "tw-rounded-full",
                icon: /* @__PURE__ */ jsx17(MdChevronRight, {}),
                size: "sm",
                variant: "ghost"
              })
            ),
            /* @__PURE__ */ jsx17(
              CalendarButton,
              {
                onClick: handleNextYear,
                "aria-label": "Next Year",
                className: "tw-rounded-full",
                icon: /* @__PURE__ */ jsx17(MdOutlineKeyboardDoubleArrowRight, {}),
                size: "sm",
                variant: "ghost"
              }
            )
          ] }),
          /* @__PURE__ */ jsx17("div", { className: "tw-flex tw-gap-8", children: /* @__PURE__ */ jsx17(
            CalendarGrid_default,
            {
              state,
              locale,
              offset: { months: 1 },
              isRangeCalendar: true
            }
          ) })
        ]
      }
    )
  ] }));
};
var CalendarRange_default = CalendarRange;
function useLocalizedTitle(date, timeZone, locale) {
  const dateFormatter = useMemo2(() => {
    return new Intl.DateTimeFormat(locale, {
      month: "long",
      year: "numeric"
    });
  }, [locale]);
  return dateFormatter.format(date.toDate(timeZone));
}

// src/components/Checkbox/Checkbox.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cva as cva5 } from "class-variance-authority";
import { forwardRef as forwardRef8 } from "react";
import { CheckIcon as CheckIcon2, IndeterminateIcon } from "@teamworksdev/icons";
import { jsx as jsx18 } from "react/jsx-runtime";
var checkboxVariants = cva5("", {
  variants: {
    size: {
      sm: "tw-w-3.5 tw-h-3.5",
      md: "tw-w-4 tw-h-4",
      lg: "tw-w-[1.125rem] tw-h-[1.125rem]",
      xl: "tw-w-6 tw-h-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var Checkbox = forwardRef8((_a, ref) => {
  var _b = _a, { isChecked, isIndeterminate, size, className } = _b, props = __objRest(_b, ["isChecked", "isIndeterminate", "size", "className"]);
  return /* @__PURE__ */ jsx18(
    CheckboxPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        checkboxVariants({
          size
        }),
        "tw-peer tw-bg-transparent tw-p-0 tw-shrink-0 tw-rounded-sm tw-border tw-border-light-300 hover:tw-border-dark-400 disabled:hover:tw-border-light-300 active:tw-border-dark-400 tw-ring-offset-white disabled:tw-cursor-not-allowed data-[state=checked]:disabled:tw-opacity-40 data-[state=checked]:tw-border-info-700  data-[state=checked]:active:tw-border-info-700 data-[state=checked]:disabled:tw-border-dark-700",
        {
          " data-[state=checked]:tw-text-info-700 data-[state=checked]:active:tw-text-info-700 disabled:data-[state=checked]:tw-text-dark-700": isIndeterminate,
          "data-[state=checked]:tw-bg-info-700   disabled:data-[state=checked]:tw-bg-dark-700  data-[state=checked]:tw-text-white": !isIndeterminate
        },
        "aria-invalid:tw-focus-error",
        "tw-focus",
        className
      )
    }, props), {
      checked: typeof isChecked === "boolean" ? isChecked : props.checked,
      children: /* @__PURE__ */ jsx18(
        CheckboxPrimitive.Indicator,
        {
          className: cn(
            "tw-flex tw-items-center tw-justify-center tw-text-current tw-mt-[-1px]"
          ),
          children: isIndeterminate ? /* @__PURE__ */ jsx18(IndeterminateIcon, { className: cn(checkboxVariants({ size })) }) : /* @__PURE__ */ jsx18(CheckIcon2, { className: cn(checkboxVariants({ size })) })
        }
      )
    })
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

// src/components/Checkbox/CheckboxButton.tsx
import * as CheckboxPrimitive2 from "@radix-ui/react-checkbox";
import { cva as cva6 } from "class-variance-authority";
import { forwardRef as forwardRef9 } from "react";
import { CheckIcon as CheckIcon3 } from "@teamworksdev/icons";
import { jsx as jsx19, jsxs as jsxs11 } from "react/jsx-runtime";
var checkboxVariants2 = cva6("tw-peer tw-p-0 tw-shrink-0 tw-border", {
  variants: {
    size: {
      sm: "tw-w-4 tw-h-4",
      default: "tw-w-[1.125rem] tw-h-[1.125rem]"
    },
    isCheckboxRound: {
      true: "tw-rounded-full",
      false: "tw-rounded-sm"
    }
  },
  defaultVariants: {
    size: "default",
    isCheckboxRound: false
  }
});
var checkboxButtonBaseClasses = [
  "tw-grid tw-grid-cols-[min-content,auto] tw-items-center tw-justify-items-start text-left tw-min-w-[130px]",
  "focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2",
  "[&>span]:tw-border-light-500 [&:active>span]:tw-border-dark-400 [&>span]:tw-ring-offset-white",
  "disabled:tw-cursor-not-allowed [&>span]:data-[state=checked]:tw-border-info-700  [&>span]:data-[state=checked]:active:tw-border-info-700 [&>span]:data-[state=checked]:disabled:tw-border-dark-700 [&>span]:data-[state=checked]:tw-bg-info-700 [&>span]:disabled:data-[state=checked]:tw-bg-light-100  [&>span]:data-[state=checked]:tw-text-white [&>span]:data-[state=checked]:disabled:tw-bg-dark-800 [&>label]:disabled:tw-opacity-40 [&>label]:tw-cursor-pointer [&>label]:disabled:tw-cursor-not-allowed [&>span]:data-[state=checked]:disabled:tw-opacity-40"
];
var checkboxButtonVariants = cva6(checkboxButtonBaseClasses.join(" "), {
  variants: {
    size: {
      sm: "tw-space-x-[6px]",
      default: "tw-space-x-2"
    },
    bordered: {
      true: "disabled:tw-border-light-300 disabled:tw-bg-light-100 tw-bg-white tw-rounded-md tw-border tw-border-light-500 data-[state=checked]:enabled:tw-border-info-700 data-[state=checked]:enabled:tw-bg-info-25 data-[state=checked]:enabled:tw-shadow-[0_0_0_3px] data-[state=checked]:enabled:tw-shadow-info-25",
      false: ""
    }
  },
  compoundVariants: [
    {
      size: "sm",
      bordered: true,
      class: "tw-py-2 tw-px-[6px]"
    },
    {
      size: "default",
      bordered: true,
      class: "tw-p-3 "
    }
  ],
  defaultVariants: {
    size: "default",
    bordered: true
  }
});
var labelVariants = cva6("tw-font-semibold", {
  variants: {
    size: {
      sm: "tw-text-xs",
      default: "tw-text-base"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
var subTextVariants = cva6("tw-font-normal", {
  variants: {
    size: {
      sm: "tw-text-xs",
      default: "tw-text-sm"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
var CheckboxButton = forwardRef9(
  (_a, ref) => {
    var _b = _a, {
      bordered,
      label,
      id,
      isChecked,
      isCheckboxRound,
      size,
      subText,
      className,
      labelClassName
    } = _b, props = __objRest(_b, [
      "bordered",
      "label",
      "id",
      "isChecked",
      "isCheckboxRound",
      "size",
      "subText",
      "className",
      "labelClassName"
    ]);
    return /* @__PURE__ */ jsxs11(
      CheckboxPrimitive2.Root,
      __spreadProps(__spreadValues({
        ref,
        id,
        className: cn(
          checkboxButtonVariants({
            bordered,
            size
          }),
          {
            "[&>label]:tw-opacity-60": !props.disabled && !props.checked
          },
          className
        )
      }, props), {
        checked: typeof isChecked === "boolean" ? isChecked : props.checked,
        children: [
          /* @__PURE__ */ jsx19(
            "span",
            {
              className: cn(
                "tw-self-center",
                checkboxVariants2({
                  size,
                  isCheckboxRound
                })
              ),
              children: /* @__PURE__ */ jsx19(
                CheckboxPrimitive2.Indicator,
                {
                  className: cn(
                    "tw-flex tw-items-center tw-justify-center tw-text-current tw-mt-[-1px]"
                  ),
                  children: /* @__PURE__ */ jsx19(
                    CheckIcon3,
                    {
                      className: cn(checkboxVariants2({ size, isCheckboxRound }))
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ jsx19(
            "label",
            {
              htmlFor: id,
              className: cn(
                labelVariants({
                  size
                }),
                labelClassName
              ),
              children: label
            }
          ),
          subText && /* @__PURE__ */ jsx19("label", { className: cn("tw-col-start-2", subTextVariants({ size })), children: subText })
        ]
      })
    );
  }
);
CheckboxButton.displayName = CheckboxPrimitive2.Root.displayName;

// src/components/Combobox/Combobox.tsx
import { MdCheck, MdUnfoldMore } from "@teamworksdev/icons";

// ../../node_modules/cmdk/dist/chunk-XJATAMEX.mjs
var U = 1;
var Y = 0.9;
var a = 0.8;
var H = 0.17;
var p = 0.1;
var u = 0.999;
var J = 0.9999;
var k = 0.99;
var m = /[\\\/_+.#"@\[\(\{&]/;
var B = /[\\\/_+.#"@\[\(\{&]/g;
var K = /[\s-]/;
var X = /[\s-]/g;
function G(c, f, P, C, h, A2, O2) {
  if (A2 === f.length)
    return h === c.length ? U : k;
  var T = `${h},${A2}`;
  if (O2[T] !== void 0)
    return O2[T];
  for (var L2 = C.charAt(A2), E = P.indexOf(L2, h), S2 = 0, _2, N, R, M; E >= 0; )
    _2 = G(c, f, P, C, E + 1, A2 + 1, O2), _2 > S2 && (E === h ? _2 *= U : m.test(c.charAt(E - 1)) ? (_2 *= a, R = c.slice(h, E - 1).match(B), R && h > 0 && (_2 *= Math.pow(u, R.length))) : K.test(c.charAt(E - 1)) ? (_2 *= Y, M = c.slice(h, E - 1).match(X), M && h > 0 && (_2 *= Math.pow(u, M.length))) : (_2 *= H, h > 0 && (_2 *= Math.pow(u, E - h))), c.charAt(E) !== f.charAt(A2) && (_2 *= J)), (_2 < p && P.charAt(E - 1) === C.charAt(A2 + 1) || C.charAt(A2 + 1) === C.charAt(A2) && P.charAt(E - 1) !== C.charAt(A2)) && (N = G(c, f, P, C, E + 1, A2 + 2, O2), N * p > _2 && (_2 = N * p)), _2 > S2 && (S2 = _2), E = P.indexOf(L2, E + 1);
  return O2[T] = S2, S2;
}
function D(c) {
  return c.toLowerCase().replace(X, " ");
}
function W(c, f) {
  return G(c, f, D(c), D(f), 0, 0, {});
}

// ../../node_modules/cmdk/dist/index.mjs
import * as y from "@radix-ui/react-dialog";
import * as t from "react";
var fe = '[cmdk-list-sizer=""]';
var O = '[cmdk-group=""]';
var U2 = '[cmdk-group-items=""]';
var me = '[cmdk-group-heading=""]';
var W2 = '[cmdk-item=""]';
var ae = `${W2}:not([aria-disabled="true"])`;
var B2 = "cmdk-item-select";
var S = "data-value";
var pe = (r, c) => W(r, c);
var se = t.createContext(void 0);
var A = () => t.useContext(se);
var ie = t.createContext(void 0);
var J2 = () => t.useContext(ie);
var ce = t.createContext(void 0);
var le = t.forwardRef((r, c) => {
  let n = t.useRef(null), o = w(() => {
    var e, s, a2;
    return { search: "", value: (a2 = (s = r.value) != null ? s : (e = r.defaultValue) == null ? void 0 : e.toLowerCase()) != null ? a2 : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), l = w(() => /* @__PURE__ */ new Set()), d = w(() => /* @__PURE__ */ new Map()), f = w(() => /* @__PURE__ */ new Map()), g = w(() => /* @__PURE__ */ new Set()), u2 = ue(r), _a = r, { label: b, children: p2, value: R, onValueChange: T, filter: I, shouldFilter: C, vimBindings: F = true } = _a, P = __objRest(_a, ["label", "children", "value", "onValueChange", "filter", "shouldFilter", "vimBindings"]), Q = t.useId(), K2 = t.useId(), V = t.useId(), E = Le();
  D2(() => {
    if (R !== void 0) {
      let e = R.trim().toLowerCase();
      o.current.value = e, E(6, Y2), m2.emit();
    }
  }, [R]);
  let m2 = t.useMemo(() => ({ subscribe: (e) => (g.current.add(e), () => g.current.delete(e)), snapshot: () => o.current, setState: (e, s, a2) => {
    var i, v, h;
    if (!Object.is(o.current[e], s)) {
      if (o.current[e] = s, e === "search")
        $(), N(), E(1, j);
      else if (e === "value")
        if (((i = u2.current) == null ? void 0 : i.value) !== void 0) {
          let x = s != null ? s : "";
          (h = (v = u2.current).onValueChange) == null || h.call(v, x);
          return;
        } else
          a2 || E(5, Y2);
      m2.emit();
    }
  }, emit: () => {
    g.current.forEach((e) => e());
  } }), []), M = t.useMemo(() => ({ value: (e, s) => {
    s !== f.current.get(e) && (f.current.set(e, s), o.current.filtered.items.set(e, X2(s)), E(2, () => {
      N(), m2.emit();
    }));
  }, item: (e, s) => (l.current.add(e), s && (d.current.has(s) ? d.current.get(s).add(e) : d.current.set(s, /* @__PURE__ */ new Set([e]))), E(3, () => {
    $(), N(), o.current.value || j(), m2.emit();
  }), () => {
    f.current.delete(e), l.current.delete(e), o.current.filtered.items.delete(e);
    let a2 = k2();
    E(4, () => {
      $(), (a2 == null ? void 0 : a2.getAttribute("id")) === e && j(), m2.emit();
    });
  }), group: (e) => (d.current.has(e) || d.current.set(e, /* @__PURE__ */ new Set()), () => {
    f.current.delete(e), d.current.delete(e);
  }), filter: () => u2.current.shouldFilter, label: b || r["aria-label"], commandRef: n, listId: Q, inputId: V, labelId: K2 }), []);
  function X2(e) {
    var a2, i;
    let s = (i = (a2 = u2.current) == null ? void 0 : a2.filter) != null ? i : pe;
    return e ? s(e, o.current.search) : 0;
  }
  function N() {
    if (!n.current || !o.current.search || u2.current.shouldFilter === false)
      return;
    let e = o.current.filtered.items, s = [];
    o.current.filtered.groups.forEach((i) => {
      let v = d.current.get(i), h = 0;
      v.forEach((x) => {
        let G2 = e.get(x);
        h = Math.max(G2, h);
      }), s.push([i, h]);
    });
    let a2 = n.current.querySelector(fe);
    H2().sort((i, v) => {
      var G2, re;
      let h = i.getAttribute(S), x = v.getAttribute(S);
      return ((G2 = e.get(x)) != null ? G2 : 0) - ((re = e.get(h)) != null ? re : 0);
    }).forEach((i) => {
      let v = i.closest(U2);
      v ? v.appendChild(i.parentElement === v ? i : i.closest(`${U2} > *`)) : a2.appendChild(i.parentElement === a2 ? i : i.closest(`${U2} > *`));
    }), s.sort((i, v) => v[1] - i[1]).forEach((i) => {
      let v = n.current.querySelector(`${O}[${S}="${i[0]}"]`);
      v == null || v.parentElement.appendChild(v);
    });
  }
  function j() {
    let e = H2().find((a2) => !a2.ariaDisabled), s = e == null ? void 0 : e.getAttribute(S);
    m2.setState("value", s || void 0);
  }
  function $() {
    if (!o.current.search || u2.current.shouldFilter === false) {
      o.current.filtered.count = l.current.size;
      return;
    }
    o.current.filtered.groups = /* @__PURE__ */ new Set();
    let e = 0;
    for (let s of l.current) {
      let a2 = f.current.get(s), i = X2(a2);
      o.current.filtered.items.set(s, i), i > 0 && e++;
    }
    for (let [s, a2] of d.current)
      for (let i of a2)
        if (o.current.filtered.items.get(i) > 0) {
          o.current.filtered.groups.add(s);
          break;
        }
    o.current.filtered.count = e;
  }
  function Y2() {
    var s, a2, i;
    let e = k2();
    e && (((s = e.parentElement) == null ? void 0 : s.firstChild) === e && ((i = (a2 = e.closest(O)) == null ? void 0 : a2.querySelector(me)) == null || i.scrollIntoView({ block: "nearest" })), e.scrollIntoView({ block: "nearest" }));
  }
  function k2() {
    var e;
    return (e = n.current) == null ? void 0 : e.querySelector(`${W2}[aria-selected="true"]`);
  }
  function H2() {
    return Array.from(n.current.querySelectorAll(ae));
  }
  function q(e) {
    let a2 = H2()[e];
    a2 && m2.setState("value", a2.getAttribute(S));
  }
  function z(e) {
    var h;
    let s = k2(), a2 = H2(), i = a2.findIndex((x) => x === s), v = a2[i + e];
    (h = u2.current) != null && h.loop && (v = i + e < 0 ? a2[a2.length - 1] : i + e === a2.length ? a2[0] : a2[i + e]), v && m2.setState("value", v.getAttribute(S));
  }
  function Z(e) {
    let s = k2(), a2 = s == null ? void 0 : s.closest(O), i;
    for (; a2 && !i; )
      a2 = e > 0 ? ye(a2, O) : xe(a2, O), i = a2 == null ? void 0 : a2.querySelector(ae);
    i ? m2.setState("value", i.getAttribute(S)) : z(e);
  }
  let ee = () => q(H2().length - 1), te = (e) => {
    e.preventDefault(), e.metaKey ? ee() : e.altKey ? Z(1) : z(1);
  }, ne = (e) => {
    e.preventDefault(), e.metaKey ? q(0) : e.altKey ? Z(-1) : z(-1);
  };
  return t.createElement("div", __spreadProps(__spreadValues({ ref: _([n, c]) }, P), { "cmdk-root": "", onKeyDown: (e) => {
    var s;
    if ((s = P.onKeyDown) == null || s.call(P, e), !e.defaultPrevented)
      switch (e.key) {
        case "n":
        case "j": {
          F && e.ctrlKey && te(e);
          break;
        }
        case "ArrowDown": {
          te(e);
          break;
        }
        case "p":
        case "k": {
          F && e.ctrlKey && ne(e);
          break;
        }
        case "ArrowUp": {
          ne(e);
          break;
        }
        case "Home": {
          e.preventDefault(), q(0);
          break;
        }
        case "End": {
          e.preventDefault(), ee();
          break;
        }
        case "Enter":
          if (!e.nativeEvent.isComposing) {
            e.preventDefault();
            let a2 = k2();
            if (a2) {
              let i = new Event(B2);
              a2.dispatchEvent(i);
            }
          }
      }
  } }), t.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: Te }, b), t.createElement(ie.Provider, { value: m2 }, t.createElement(se.Provider, { value: M }, p2)));
});
var ve = t.forwardRef((r, c) => {
  var V, E;
  let n = t.useId(), o = t.useRef(null), l = t.useContext(ce), d = A(), f = ue(r), g = (E = (V = f.current) == null ? void 0 : V.forceMount) != null ? E : l == null ? void 0 : l.forceMount;
  D2(() => d.item(n, l == null ? void 0 : l.id), []);
  let u2 = de(n, o, [r.value, r.children, o]), b = J2(), p2 = L((m2) => m2.value && m2.value === u2.current), R = L((m2) => g || d.filter() === false ? true : m2.search ? m2.filtered.items.get(n) > 0 : true);
  t.useEffect(() => {
    let m2 = o.current;
    if (!(!m2 || r.disabled))
      return m2.addEventListener(B2, T), () => m2.removeEventListener(B2, T);
  }, [R, r.onSelect, r.disabled]);
  function T() {
    var m2, M;
    I(), (M = (m2 = f.current).onSelect) == null || M.call(m2, u2.current);
  }
  function I() {
    b.setState("value", u2.current, true);
  }
  if (!R)
    return null;
  let _a = r, { disabled: C, value: F, onSelect: P, forceMount: Q } = _a, K2 = __objRest(_a, ["disabled", "value", "onSelect", "forceMount"]);
  return t.createElement("div", __spreadProps(__spreadValues({ ref: _([o, c]) }, K2), { id: n, "cmdk-item": "", role: "option", "aria-disabled": C || void 0, "aria-selected": p2 || void 0, "data-disabled": C || void 0, "data-selected": p2 || void 0, onPointerMove: C ? void 0 : I, onClick: C ? void 0 : T }), r.children);
});
var ge = t.forwardRef((r, c) => {
  let _a = r, { heading: n, children: o, forceMount: l } = _a, d = __objRest(_a, ["heading", "children", "forceMount"]), f = t.useId(), g = t.useRef(null), u2 = t.useRef(null), b = t.useId(), p2 = A(), R = L((C) => l || p2.filter() === false ? true : C.search ? C.filtered.groups.has(f) : true);
  D2(() => p2.group(f), []), de(f, g, [r.value, r.heading, u2]);
  let T = t.useMemo(() => ({ id: f, forceMount: l }), [l]), I = t.createElement(ce.Provider, { value: T }, o);
  return t.createElement("div", __spreadProps(__spreadValues({ ref: _([g, c]) }, d), { "cmdk-group": "", role: "presentation", hidden: R ? void 0 : true }), n && t.createElement("div", { ref: u2, "cmdk-group-heading": "", "aria-hidden": true, id: b }, n), t.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? b : void 0 }, I));
});
var Re = t.forwardRef((r, c) => {
  let _a = r, { alwaysRender: n } = _a, o = __objRest(_a, ["alwaysRender"]), l = t.useRef(null), d = L((f) => !f.search);
  return !n && !d ? null : t.createElement("div", __spreadProps(__spreadValues({ ref: _([l, c]) }, o), { "cmdk-separator": "", role: "separator" }));
});
var be = t.forwardRef((r, c) => {
  let _a = r, { onValueChange: n } = _a, o = __objRest(_a, ["onValueChange"]), l = r.value != null, d = J2(), f = L((p2) => p2.search), g = L((p2) => p2.value), u2 = A(), b = t.useMemo(() => {
    var R;
    let p2 = (R = u2.commandRef.current) == null ? void 0 : R.querySelector(`${W2}[${S}="${g}"]`);
    return p2 == null ? void 0 : p2.getAttribute("id");
  }, [g, u2.commandRef]);
  return t.useEffect(() => {
    r.value != null && d.setState("search", r.value);
  }, [r.value]), t.createElement("input", __spreadProps(__spreadValues({ ref: c }, o), { "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: false, "aria-autocomplete": "list", role: "combobox", "aria-expanded": true, "aria-controls": u2.listId, "aria-labelledby": u2.labelId, "aria-activedescendant": b, id: u2.inputId, type: "text", value: l ? r.value : f, onChange: (p2) => {
    l || d.setState("search", p2.target.value), n == null || n(p2.target.value);
  } }));
});
var he = t.forwardRef((r, c) => {
  let _a = r, { children: n } = _a, o = __objRest(_a, ["children"]), l = t.useRef(null), d = t.useRef(null), f = A();
  return t.useEffect(() => {
    if (d.current && l.current) {
      let g = d.current, u2 = l.current, b, p2 = new ResizeObserver(() => {
        b = requestAnimationFrame(() => {
          let R = g.offsetHeight;
          u2.style.setProperty("--cmdk-list-height", R.toFixed(1) + "px");
        });
      });
      return p2.observe(g), () => {
        cancelAnimationFrame(b), p2.unobserve(g);
      };
    }
  }, []), t.createElement("div", __spreadProps(__spreadValues({ ref: _([l, c]) }, o), { "cmdk-list": "", role: "listbox", "aria-label": "Suggestions", id: f.listId, "aria-labelledby": f.inputId }), t.createElement("div", { ref: d, "cmdk-list-sizer": "" }, n));
});
var Ee = t.forwardRef((r, c) => {
  let _a = r, { open: n, onOpenChange: o, overlayClassName: l, contentClassName: d, container: f } = _a, g = __objRest(_a, ["open", "onOpenChange", "overlayClassName", "contentClassName", "container"]);
  return t.createElement(y.Root, { open: n, onOpenChange: o }, t.createElement(y.Portal, { container: f }, t.createElement(y.Overlay, { "cmdk-overlay": "", className: l }), t.createElement(y.Content, { "aria-label": r.label, "cmdk-dialog": "", className: d }, t.createElement(le, __spreadValues({ ref: c }, g)))));
});
var Se = t.forwardRef((r, c) => {
  let n = t.useRef(true), o = L((l) => l.filtered.count === 0);
  return t.useEffect(() => {
    n.current = false;
  }, []), n.current || !o ? null : t.createElement("div", __spreadProps(__spreadValues({ ref: c }, r), { "cmdk-empty": "", role: "presentation" }));
});
var Ce = t.forwardRef((r, c) => {
  let _a = r, { progress: n, children: o } = _a, l = __objRest(_a, ["progress", "children"]);
  return t.createElement("div", __spreadProps(__spreadValues({ ref: c }, l), { "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": "Loading..." }), t.createElement("div", { "aria-hidden": true }, o));
});
var we = Object.assign(le, { List: he, Item: ve, Input: be, Group: ge, Separator: Re, Dialog: Ee, Empty: Se, Loading: Ce });
function ye(r, c) {
  let n = r.nextElementSibling;
  for (; n; ) {
    if (n.matches(c))
      return n;
    n = n.nextElementSibling;
  }
}
function xe(r, c) {
  let n = r.previousElementSibling;
  for (; n; ) {
    if (n.matches(c))
      return n;
    n = n.previousElementSibling;
  }
}
function ue(r) {
  let c = t.useRef(r);
  return D2(() => {
    c.current = r;
  }), c;
}
var D2 = typeof window == "undefined" ? t.useEffect : t.useLayoutEffect;
function w(r) {
  let c = t.useRef();
  return c.current === void 0 && (c.current = r()), c;
}
function _(r) {
  return (c) => {
    r.forEach((n) => {
      typeof n == "function" ? n(c) : n != null && (n.current = c);
    });
  };
}
function L(r) {
  let c = J2(), n = () => r(c.snapshot());
  return t.useSyncExternalStore(c.subscribe, n, n);
}
function de(r, c, n) {
  let o = t.useRef(), l = A();
  return D2(() => {
    var f;
    let d = (() => {
      var g;
      for (let u2 of n) {
        if (typeof u2 == "string")
          return u2.trim().toLowerCase();
        if (typeof u2 == "object" && "current" in u2)
          return u2.current ? (g = u2.current.textContent) == null ? void 0 : g.trim().toLowerCase() : o.current;
      }
    })();
    l.value(r, d), (f = c.current) == null || f.setAttribute(S, d), o.current = d;
  }), o;
}
var Le = () => {
  let [r, c] = t.useState(), n = w(() => /* @__PURE__ */ new Map());
  return D2(() => {
    n.current.forEach((o) => o()), n.current = /* @__PURE__ */ new Map();
  }, [r]), (o, l) => {
    n.current.set(o, l), c({});
  };
};
var Te = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };

// src/components/Command/Command.tsx
import { forwardRef as forwardRef12 } from "react";

// src/components/Dialog/Dialog.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cva as cva7 } from "class-variance-authority";
import { forwardRef as forwardRef11 } from "react";
import { MdClose as MdClose2 } from "@teamworksdev/icons";
import { jsx as jsx20, jsxs as jsxs12 } from "react/jsx-runtime";
var dialogVariants = cva7("", {
  variants: {
    size: {
      xs: "sm:tw-max-w-[460px]",
      sm: "sm:tw-max-w-[600px]",
      md: "sm:tw-max-w-[900px]",
      lg: "sm:tw-max-w-[1200px]",
      xl: "sm:tw-max-w-[1536px]"
    }
  },
  defaultVariants: {
    size: "xs"
  }
});
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(DialogPrimitive.Portal, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx20("div", { className: "tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-start tw-justify-center sm:tw-items-center tw-backdrop-blur-sm tw-bg-black/25", children }) }));
};
DialogPortal.displayName = DialogPrimitive.Portal.displayName;
var DialogOverlay = forwardRef11((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx20(
    DialogPrimitive.Overlay,
    __spreadValues({
      ref,
      className: cn(
        "tw-fixed tw-inset-0 tw-z-50 tw-bg-black/25 tw-backdrop-blur-sm tw-transition-all tw-duration-100 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out data-[state=open]:tw-fade-in",
        className
      )
    }, props)
  );
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = forwardRef11((_a, ref) => {
  var _b = _a, { container, className, children, size } = _b, props = __objRest(_b, ["container", "className", "children", "size"]);
  return /* @__PURE__ */ jsxs12(DialogPortal, { container, children: [
    /* @__PURE__ */ jsx20(DialogOverlay, {}),
    /* @__PURE__ */ jsxs12(
      DialogPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          dialogVariants({
            size
          }),
          "tw-fixed tw-z-50 tw-grid tw-w-full tw-gap-6 tw-rounded-b-lg tw-border tw-bg-white tw-p-6 tw-shadow-lg tw-animate-in data-[state=open]:tw-fade-in-90 data-[state=open]:tw-slide-in-from-bottom-10 sm:tw-rounded-lg sm:tw-zoom-in-90 data-[state=open]:sm:tw-slide-in-from-bottom-0",
          className
        )
      }, props), {
        children: [
          children,
          /* @__PURE__ */ jsxs12(DialogPrimitive.Close, { className: "tw-absolute tw-cursor-pointer tw-right-4 tw-top-4 tw-p-2 tw-rounded-full tw-leading-none tw-bg-transparent tw-opacity-70 tw-ring-offset-white tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus-visible:tw-ring-2 focus:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none data-[state=open]:tw-bg-light-300 data-[state=open]:text-light-500 hover:tw-bg-light-200", children: [
            /* @__PURE__ */ jsx20(MdClose2, { className: "tw-h-6 tw-w-6" }),
            /* @__PURE__ */ jsx20("span", { className: "tw-sr-only", children: "Close" })
          ] })
        ]
      })
    )
  ] });
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx20(
    "div",
    __spreadValues({
      className: cn("tw-flex tw-flex-col tw-space-y-1.5 tw-text-left", className)
    }, props)
  );
};
DialogHeader.displayName = "DialogHeader";
var DialogBody = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx20(
    "div",
    __spreadValues({
      className: cn("tw-overflow-y-auto tw-max-h-96 tw-w-full", className)
    }, props)
  );
};
DialogBody.displayName = "DialogBody";
var DialogFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx20(
    "div",
    __spreadValues({
      className: cn(
        "tw-flex tw-border-t tw-border-light-200 tw-flex-col-reverse tw--mx-6 tw-px-6 tw-pt-6 sm:tw-flex-row sm:tw-justify-end sm:tw-space-x-2",
        className
      )
    }, props)
  );
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = forwardRef11((_a, ref) => {
  var _b = _a, { icon, className, children } = _b, props = __objRest(_b, ["icon", "className", "children"]);
  return /* @__PURE__ */ jsxs12(
    DialogPrimitive.Title,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-gap-2 tw-items-center tw-text-lg tw-font-semibold tw-leading-none tw-tracking-tight",
        className
      )
    }, props), {
      children: [
        icon && /* @__PURE__ */ jsx20("span", { style: { fontSize: 32 }, children: icon }),
        /* @__PURE__ */ jsx20("span", { children })
      ]
    })
  );
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = forwardRef11((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx20(
    DialogPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("tw-text-sm tw-text-light-500", className)
    }, props)
  );
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;

// src/components/Command/Command.tsx
import { jsx as jsx21, jsxs as jsxs13 } from "react/jsx-runtime";
var Command = forwardRef12((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    we,
    __spreadValues({
      className: cn(
        "tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-md tw-bg-white tw-text-black",
        className
      ),
      filter: (value, search) => {
        const exp = new RegExp(search.toLowerCase());
        const lowerCaseValue = value.toLowerCase();
        return exp.test(lowerCaseValue) ? 1 : 0;
      },
      ref
    }, props)
  );
});
Command.displayName = we.displayName;
var CommandDialog = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx21(Dialog, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx21(DialogContent, { className: "tw-overflow-hidden tw-p-0 tw-shadow-2xl", children: /* @__PURE__ */ jsx21(Command, { className: "[&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group-heading]]:tw-text-light-500 [&_[cmdk-group]:not([tw-hidden])_~[cmdk-group]]:tw-pt-0 [&_[cmdk-group]]:tw-px-2 [&_[cmdk-input-wrapper]_svg]:tw-h-5 [&_[cmdk-input-wrapper]_svg]:tw-w-5 [&_[cmdk-input]]:tw-h-12 [&_[cmdk-item]]:tw-px-2 [&_[cmdk-item]]:tw-py-3 [&_[cmdk-item]_svg]:tw-h-5 [&_[cmdk-item]_svg]:tw-w-5", children }) }) }));
};
var CommandInput = forwardRef12((_a, ref) => {
  var _b = _a, { className, leftIcon } = _b, props = __objRest(_b, ["className", "leftIcon"]);
  return /* @__PURE__ */ jsxs13(
    "div",
    {
      className: "tw-flex tw-grow tw-items-center tw-px-3",
      "cmdk-input-wrapper": "",
      children: [
        leftIcon,
        /* @__PURE__ */ jsx21(
          we.Input,
          __spreadValues({
            className: cn(
              "tw-w-full tw-bg-transparent tw-py-3 tw-text-sm tw-outline-none placeholder:tw-text-light-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 focus:tw-ring-0 focus:tw-ring-offset-0",
              className
            ),
            ref
          }, props)
        )
      ]
    }
  );
});
CommandInput.displayName = we.Input.displayName;
var CommandList = forwardRef12((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    we.List,
    __spreadValues({
      className: cn(
        "tw-max-h-[300px] tw-overflow-y-auto tw-overflow-x-hidden",
        className
      ),
      ref
    }, props)
  );
});
CommandList.displayName = we.List.displayName;
var CommandEmpty = forwardRef12((props, ref) => /* @__PURE__ */ jsx21(
  we.Empty,
  __spreadValues({
    className: "tw-py-6 tw-text-center tw-text-sm",
    ref
  }, props)
));
CommandEmpty.displayName = we.Empty.displayName;
var CommandGroup = forwardRef12((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    we.Group,
    __spreadValues({
      className: cn(
        "tw-overflow-hidden tw-p-1 tw-text-black [&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-py-1.5 [&_[cmdk-group-heading]]:tw-text-xs [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group-heading]]:tw-text-light-500",
        className
      ),
      ref
    }, props)
  );
});
CommandGroup.displayName = we.Group.displayName;
var CommandSeparator = forwardRef12((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    we.Separator,
    __spreadValues({
      className: cn("tw-mx-1 tw-h-px tw-bg-border", className),
      ref
    }, props)
  );
});
CommandSeparator.displayName = we.Separator.displayName;
var CommandItem = forwardRef12((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    we.Item,
    __spreadValues({
      className: cn(
        "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none aria-selected:tw-bg-light-200 aria-selected:tw-text-black data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        className
      ),
      ref
    }, props)
  );
});
CommandItem.displayName = we.Item.displayName;
var CommandShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx21(
    "span",
    __spreadValues({
      className: cn(
        "tw-ml-auto tw-text-xs tw-tracking-widest tw-text-light-500",
        className
      )
    }, props)
  );
};
CommandShortcut.displayName = "CommandShortcut";

// src/components/Popover/Popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { forwardRef as forwardRef13 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverClose = PopoverPrimitive.Close;
var PopoverContent = forwardRef13(
  (_a, ref) => {
    var _b = _a, { container, className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["container", "className", "align", "sideOffset"]);
    return /* @__PURE__ */ jsx22(PopoverPrimitive.Portal, { container, children: /* @__PURE__ */ jsx22(
      PopoverPrimitive.Content,
      __spreadValues({
        ref,
        align,
        sideOffset,
        className: cn(
          "tw-z-50 tw-w-72 tw-rounded-md tw-border tw-bg-white p-4 tw-text-black tw-shadow-md tw-outline-none data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
          className
        )
      }, props)
    ) });
  }
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/components/Translator/dictionaries/de.ts
var de2 = {
  accountSettings: "Einstellungen",
  apply: "Anwenden",
  cancel: "Abbrechen",
  changeTeam: "Team Wechseln",
  chatWithSupport: "Chatten Sie mit dem Support",
  clear: "L\xF6schen",
  clearSearch: "Suche l\xF6schen",
  checkSearchTerm: "\xDCberpr\xFCfen Sie Ihren Suchbegriff oder l\xF6schen Sie die Suche, um es erneut zu versuchen.",
  clearSelection: "Auswahl Aufheben",
  closeMenu: "Men\xFC Schlie\xDFen",
  datePicker: "Datumsauswahl",
  dateRangePicker: "Datumsbereichsauswahl",
  dateTimePicker: "Datum-Zeit-Auswahl",
  download: "Herunterladen",
  error: "Fehler",
  filter: "Filter",
  generating: "Generieren",
  helpCenter: "Hilfezentrum",
  learningPortal: "Lernportal",
  logout: "Ausloggen",
  myProfile: "Mein Profil",
  next: "N\xE4chste",
  noResults: "Keine passenden Ergebnisse",
  now: "Jetzt",
  previous: "Vorherige",
  openMenu: "Men\xFC \xD6ffnen",
  openCalendar: "Kalender \xD6ffnen",
  openTimePicker: "Zeitpicker \xD6ffnen",
  ready: "Bereit",
  requestError: "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es erneut. Wenn der Fehler weiterhin besteht, wenden Sie sich an Ihren Teamworks-Administrator.",
  search: "Suchen",
  searchForTeam: "Team suchen...",
  select: "Ausw\xE4hlen",
  selectAll: "Alle ausw\xE4hlen",
  selectDate: "Datum Ausw\xE4hlen",
  selectDateRange: "Datumsbereich Ausw\xE4hlen",
  selectTime: "Zeit Ausw\xE4hlen",
  settings: "Einstellungen",
  switchOrgs: "Organisationen Wechseln",
  teamworksApps: "Teamworks-Apps",
  teamworksHelp: "Teamworks-Hilfe",
  time: "Zeit",
  timePicker: "Zeitpicker",
  today: "Heute"
};
var de_default = de2;

// src/components/Translator/dictionaries/en.ts
var en = {
  accountSettings: "Account Settings",
  apply: "Apply",
  cancel: "Cancel",
  changeTeam: "Change Team",
  chatWithSupport: "Chat with Support",
  clear: "Clear",
  clearSearch: "Clear search",
  checkSearchTerm: "Check your search term or clear your search to try again.",
  clearSelection: "Clear Selection",
  closeMenu: "Close Menu",
  datePicker: "Date Picker",
  dateRangePicker: "Date Range Picker",
  dateTimePicker: "Date Time Picker",
  download: "Download",
  error: "Error",
  filter: "Filter",
  generating: "Generating",
  helpCenter: "Help Center",
  learningPortal: "Learning Portal",
  logout: "Logout",
  myProfile: "My Profile",
  next: "Next",
  noResults: "No matching results",
  now: "Now",
  previous: "Previous",
  openMenu: "Open Menu",
  openCalendar: "Open Calendar",
  openTimePicker: "Open Time Picker",
  ready: "Ready",
  requestError: "An error occurred processing your request. Try again and if the error persists please contact your Teamworks administrator.",
  search: "Search",
  searchForTeam: "Search for team...",
  select: "Select",
  selectAll: "Select all",
  selectDate: "Select Date",
  selectDateRange: "Select Date Range",
  selectTime: "Select Time",
  settings: "Settings",
  switchOrgs: "Switch Orgs",
  teamworksApps: "Teamworks Apps",
  teamworksHelp: "Teamworks Help",
  time: "Time",
  timePicker: "Time Picker",
  today: "Today"
};
var en_default = en;

// src/components/Translator/dictionaries/es.ts
var es = {
  accountSettings: "Configuraci\xF3n",
  apply: "Aplicar",
  cancel: "Cancelar",
  changeTeam: "Cambiar Equipo",
  chatWithSupport: "Chatear con Soporte",
  clear: "Borrar",
  clearSearch: "Borrar b\xFAsqueda",
  checkSearchTerm: "Verifique su t\xE9rmino de b\xFAsqueda o borre su b\xFAsqueda para volver a intentarlo.",
  clearSelection: "Borrar Selecci\xF3n",
  closeMenu: "Cerrar Men\xFA",
  datePicker: "Selector de Fecha",
  dateRangePicker: "Selector de Rango de Fechas",
  dateTimePicker: "Selector de Fecha y Hora",
  download: "Descargar",
  error: "Error",
  filter: "Filtrar",
  generating: "Generando",
  helpCenter: "Centro de Ayuda",
  learningPortal: "Portal de Aprendizaje",
  logout: "Cerrar Sesi\xF3n",
  myProfile: "Mi Perfil",
  next: "Siguiente",
  noResults: "No hay coincidencias",
  now: "Ahora",
  previous: "Anterior",
  openMenu: "Abrir Men\xFA",
  openCalendar: "Abrir Calendario",
  openTimePicker: "Abrir Selector de Hora",
  ready: "Listo",
  requestError: "Se produjo un error al procesar su solicitud. Intente nuevamente y, si el error persiste, comun\xEDquese con su administrador de Teamworks.",
  search: "Buscar",
  searchForTeam: "Buscar equipo...",
  select: "Seleccionar",
  selectAll: "Seleccionar todos",
  selectDate: "Seleccionar Fecha",
  selectDateRange: "Seleccionar Rango de Fechas",
  selectTime: "Seleccionar Hora",
  settings: "Configuraci\xF3n",
  switchOrgs: "Cambiar Organizaci\xF3n",
  teamworksApps: "Teamworks Aplicaciones",
  teamworksHelp: "Ayuda de Teamworks",
  time: "Hora",
  timePicker: "Selector de Hora",
  today: "Hoy"
};
var es_default = es;

// src/components/Translator/dictionaries/fr.ts
var fr = {
  accountSettings: "Param\xE8tres du Compte",
  apply: "Appliquer",
  cancel: "Annuler",
  changeTeam: "Changer d'\xC9quipe",
  chatWithSupport: "Discuter avec l'assistance",
  clear: "D\xE9gager",
  clearSearch: "Effacer la recherche",
  checkSearchTerm: "V\xE9rifiez votre terme de recherche ou effacez votre recherche pour r\xE9essayer.",
  clearSelection: "Effacer la S\xE9lection",
  closeMenu: "Fermer le menu",
  datePicker: "S\xE9lecteur de date",
  dateRangePicker: "S\xE9lecteur de plage de dates",
  dateTimePicker: "S\xE9lecteur de date et heure",
  download: "T\xE9l\xE9charger",
  error: "Erreur",
  filter: "Filtre",
  generating: "G\xE9n\xE9ration",
  helpCenter: "Centre d'aide",
  learningPortal: "Portail d'apprentissage",
  logout: "Se d\xE9connecter",
  myProfile: "Mon profil",
  next: "Suivant",
  noResults: "Aucun r\xE9sultat correspondant",
  now: "Maintenant",
  previous: "Pr\xE9c\xE9dent",
  openMenu: "Ouvrir le menu",
  openCalendar: "Ouvrir le calendrier",
  openTimePicker: "Ouvrir le s\xE9lecteur de temps",
  ready: "Pr\xEAt",
  requestError: "Une erreur s'est produite lors du traitement de votre demande. R\xE9essayez et si l'erreur persiste, contactez votre administrateur Teamworks.",
  search: "Recherche",
  searchForTeam: "Recherche d'\xE9quipe...",
  select: "S\xE9lectionner",
  selectAll: "Tout s\xE9lectionner",
  selectDate: "S\xE9lectionner la date",
  selectDateRange: "S\xE9lectionner la plage de dates",
  selectTime: "S\xE9lectionner l'heure",
  settings: "Param\xE8tres",
  switchOrgs: "Changer d'organisation",
  teamworksApps: "Applications de Teamworks",
  teamworksHelp: "Aide de Teamworks",
  time: "Heure",
  timePicker: "S\xE9lecteur de temps",
  today: "Aujourd'hui"
};
var fr_default = fr;

// src/components/Translator/dictionaries/it.ts
var it = {
  accountSettings: "Impostazioni dell'Account",
  apply: "Applica",
  cancel: "Annulla",
  changeTeam: "Cambia Squadra",
  chatWithSupport: "Chatta con il Supporto",
  clear: "Cancella",
  clearSearch: "Cancella ricerca",
  checkSearchTerm: "Controlla il termine di ricerca o cancella la ricerca e riprova.",
  clearSelection: "Annulla Selezione",
  closeMenu: "Chiudi Men\xF9",
  datePicker: "Selettore Data",
  dateRangePicker: "Selettore Intervallo Date",
  dateTimePicker: "Selettore Data e Ora",
  download: "Scarica",
  error: "Errore",
  filter: "Filtro",
  generating: "Generazione",
  helpCenter: "Centro Assistenza",
  learningPortal: "Portale di Apprendimento",
  logout: "Esci",
  myProfile: "Il mio profilo",
  next: "Prossimo",
  noResults: "Nessun risultato corrispondente",
  now: "Adesso",
  previous: "Precedente",
  openMenu: "Apri Men\xF9",
  openCalendar: "Apri Calendario",
  openTimePicker: "Apri Selettore Orario",
  ready: "Pronto",
  requestError: "Si \xE8 verificato un errore durante l'elaborazione della tua richiesta. Riprova e se l'errore persiste contatta il tuo amministratore di Teamworks.",
  search: "Ricerca",
  searchForTeam: "Ricerca...",
  select: "Seleziona",
  selectAll: "Seleziona tutto",
  selectDate: "Seleziona Data",
  selectDateRange: "Seleziona Intervallo Date",
  selectTime: "Seleziona Orario",
  settings: "Impostazioni",
  switchOrgs: "Cambia Organizzazione",
  teamworksApps: "App di Teamworks",
  teamworksHelp: "Aiuto di Teamworks",
  today: "Oggi",
  time: "Ora",
  timePicker: "Selettore Orario"
};
var it_default = it;

// src/components/Translator/dictionaries/nl.ts
var nl = {
  accountSettings: "Account instellingen",
  apply: "Toepassen",
  cancel: "Annuleren",
  changeTeam: "Verander van team",
  chatWithSupport: "Chatten met Ondersteuning",
  clear: "Duidelijk",
  clearSearch: "Duidelijke zoek",
  checkSearchTerm: "Controleer uw zoekterm of wis uw zoekopdracht om het opnieuw te proberen.",
  clearSelection: "Selectie wissen",
  closeMenu: "Menu sluiten",
  datePicker: "Datumkiezer",
  dateRangePicker: "Datumbereikkiezer",
  dateTimePicker: "Datum-tijdkiezer",
  download: "Downloaden",
  error: "Fout",
  filter: "Filter",
  generating: "Genereren",
  helpCenter: "Helpcentrum",
  learningPortal: "Leerportaal",
  logout: "Uitloggen",
  myProfile: "Mijn profiel",
  next: "Volgende",
  noResults: "Geen overeenkomende resultaten",
  now: "Nu",
  previous: "Vorig",
  openMenu: "Menu Openen",
  openCalendar: "Agenda Openen",
  openTimePicker: "Tijdkiezer Openen",
  ready: "Klaar",
  requestError: "Er is een fout opgetreden bij het verwerken van uw verzoek. Probeer het opnieuw en als de fout zich blijft voordoen, neem dan contact op met uw Teamworks-beheerder.",
  search: "Zoekopdracht",
  searchForTeam: "Zoek team...",
  select: "Selecteer",
  selectAll: "Selecteer Alles",
  selectDate: "Selecteer een datum",
  selectDateRange: "Selecteer Datumbereik",
  selectTime: "Selecteer Tijd",
  settings: "Instellingen",
  switchOrgs: "Van Organisatie Wisselen",
  teamworksApps: "Teamworks-applicaties",
  teamworksHelp: "Teamwork-hulp",
  time: "Tijd",
  timePicker: "Tijdkiezer",
  today: "Vandaag"
};
var nl_default = nl;

// src/components/Translator/dictionaries/pt.ts
var pt = {
  accountSettings: "Configura\xE7\xF5es de Conta",
  apply: "Aplicar",
  cancel: "Cancelar",
  changeTeam: "Alterar Equipe",
  chatWithSupport: "Converse com o Suporte",
  clear: "Apagar",
  clearSearch: "Limpar pesquisa",
  checkSearchTerm: "Verifique o termo de pesquisa ou limpe a pesquisa para tentar novamente.",
  clearSelection: "Limpar Sele\xE7\xE3o",
  closeMenu: "Fechar Menu",
  datePicker: "Seletor de Data",
  dateRangePicker: "Seletor de Intervalo de Datas",
  dateTimePicker: "Seletor de Data e Hora",
  download: "Baixar",
  error: "Erro",
  filter: "Filtro",
  generating: "Gerando",
  helpCenter: "Centro de Ajuda",
  learningPortal: "Portal de Aprendizagem",
  logout: "Sair",
  myProfile: "Meu perfil",
  next: "Pr\xF3ximo",
  noResults: "Nenhum resultado correspondente",
  now: "Agora",
  previous: "Anterior",
  openMenu: "Menu Aberto",
  openCalendar: "Abrir Calend\xE1rio",
  openTimePicker: "Abrir Seletor de Hor\xE1rio",
  ready: "Pronto",
  requestError: "Ocorreu um erro ao processar o pedido. Tente novamente e se o erro persistir, entre em contacto com o administrador do Teamworks.",
  search: "Procurar",
  searchForTeam: "Procurar equipa...",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  selectDate: "Selecionar Data",
  selectDateRange: "Selecionar Intervalo de Datas",
  selectTime: "Selecionar Hora",
  settings: "Configura\xE7\xF5es",
  switchOrgs: "Alternar Organiza\xE7\xF5es",
  teamworksApps: "Aplicativos do Teamworks",
  teamworksHelp: "Ajuda do Teamworks",
  today: "Hoje",
  time: "Hora",
  timePicker: "Seletor de Hor\xE1rio"
};
var pt_default = pt;

// src/components/Translator/Translator.tsx
var supportedLanguages = ["en", "es", "fr", "de", "it", "nl", "pt"];
var dictionary = {
  en: en_default,
  es: es_default,
  fr: fr_default,
  de: de_default,
  it: it_default,
  nl: nl_default,
  pt: pt_default
};
var _dictionary, _fallback;
var Translation = class {
  constructor() {
    __privateAdd(this, _dictionary, void 0);
    __privateAdd(this, _fallback, void 0);
    __privateSet(this, _dictionary, dictionary[getSupportedLanguage()]);
    __privateSet(this, _fallback, dictionary.en);
    this.locale = getLocale();
  }
  translate(key) {
    var _a, _b;
    return (_b = (_a = __privateGet(this, _dictionary)[key]) != null ? _a : __privateGet(this, _fallback)[key]) != null ? _b : key;
  }
};
_dictionary = new WeakMap();
_fallback = new WeakMap();
var translator = new Translation();
var getTranslation = (key) => {
  return translator.translate(key);
};
function getLocale() {
  var _a, _b, _c;
  if (typeof window === "undefined")
    return "en-US";
  const preferredLocales = (
    // @ts-expect-error
    (_b = window.navigator.languages) != null ? _b : (_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userLanguage
  );
  return (_c = preferredLocales == null ? void 0 : preferredLocales[0]) != null ? _c : "en-US";
}
function getSupportedLanguage() {
  var _a, _b, _c;
  if (typeof window === "undefined")
    return "en";
  const supportedMatches = (
    // @ts-expect-error
    ((_b = window.navigator.languages) != null ? _b : (_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userLanguage).filter((language) => {
      return supportedLanguages.includes(
        language.slice(0, 2)
      );
    }).map((language) => {
      return language.slice(0, 2);
    })
  );
  return (_c = supportedMatches == null ? void 0 : supportedMatches[0]) != null ? _c : "en";
}

// src/components/Combobox/Combobox.tsx
import { jsx as jsx23, jsxs as jsxs14 } from "react/jsx-runtime";
var Combobox = ({
  items,
  open,
  setOpen,
  value,
  setValue,
  emptyState,
  searchPlaceholder,
  buttonPlaceholder
}) => {
  var _a;
  return /* @__PURE__ */ jsxs14(Popover, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx23(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs14(
      Button,
      {
        role: "combobox",
        "aria-expanded": open,
        className: "tw-w-full tw-justify-between",
        children: [
          value ? (_a = items.find((item) => item.value === value)) == null ? void 0 : _a.label : buttonPlaceholder || getTranslation("select"),
          /* @__PURE__ */ jsx23(MdUnfoldMore, { className: "tw-ml-2 tw-h-4 tw-w-4" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx23(PopoverContent, { className: "tw-w-full", children: /* @__PURE__ */ jsxs14(Command, { children: [
      /* @__PURE__ */ jsx23(
        CommandInput,
        {
          placeholder: searchPlaceholder || getTranslation("search")
        }
      ),
      /* @__PURE__ */ jsx23("div", { className: "tw-border-b" }),
      /* @__PURE__ */ jsx23(CommandEmpty, { children: emptyState ? emptyState : getTranslation("noResults") }),
      /* @__PURE__ */ jsx23(CommandGroup, { children: items.map((item) => /* @__PURE__ */ jsxs14(
        CommandItem,
        {
          value: item.value,
          onSelect: (currentValue) => {
            setValue(currentValue === value ? "" : currentValue);
            setOpen(false);
          },
          className: "tw-flex tw-items-center tw-justify-between tw-cursor-pointer",
          children: [
            item.label,
            value === item.value && /* @__PURE__ */ jsx23(MdCheck, { className: "tw-mr-2 tw-h-4 tw-w-4" })
          ]
        },
        item.value
      )) })
    ] }) })
  ] });
};

// src/components/ContextMenu/ContextMenu.tsx
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";
import {
  forwardRef as forwardRef15
} from "react";
import { CheckIcon as CheckIcon5, MdCheck as MdCheck2, MdChevronRight as MdChevronRight2 } from "@teamworksdev/icons";

// src/components/Dropdown/Dropdown.tsx
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { cloneElement as cloneElement4, forwardRef as forwardRef14 } from "react";
import { CheckIcon as CheckIcon4, ChevronRightIcon as ChevronRightIcon2 } from "@teamworksdev/icons";
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = forwardRef14((_a, ref) => {
  var _b = _a, { className, inset, children } = _b, props = __objRest(_b, ["className", "inset", "children"]);
  return /* @__PURE__ */ jsxs15(
    DropdownMenuPrimitive.SubTrigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none focus:tw-bg-light-200 data-[state=open]:tw-light-100",
        inset && "tw-pl-8",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx24(ChevronRightIcon2, { className: "tw-ml-auto tw-h-4 tw-w-4" })
      ]
    })
  );
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = forwardRef14((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx24(
    DropdownMenuPrimitive.SubContent,
    __spreadValues({
      ref,
      className: cn(
        "tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-white tw-p-1 tw-text-black tw-shadow-md tw-animate-in data-[side=bottom]:tw-slide-in-from-top-1 data-[side=left]:tw-slide-in-from-right-1 data-[side=right]:tw-slide-in-from-left-1 data-[side=top]:tw-slide-in-from-bottom-1",
        className
      )
    }, props)
  );
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = forwardRef14((_a, ref) => {
  var _b = _a, { container, className, sideOffset = 4 } = _b, props = __objRest(_b, ["container", "className", "sideOffset"]);
  return /* @__PURE__ */ jsx24(DropdownMenuPrimitive.Portal, { container, children: /* @__PURE__ */ jsx24(
    DropdownMenuPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "tw-z-50 tw-min-w-[16rem] tw-rounded-md tw-border tw-bg-white tw-p-1 tw-text-black tw-shadow-md tw-animate-in data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = forwardRef14((_a, ref) => {
  var _b = _a, { className, danger, inset } = _b, props = __objRest(_b, ["className", "danger", "inset"]);
  return /* @__PURE__ */ jsx24(
    DropdownMenuPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-text-black tw-outline-none tw-transition-colors focus:tw-bg-light-200 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 tw-ring-0",
        inset && "tw-pl-8",
        danger && "tw-text-error-700",
        className
      )
    }, props)
  );
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = forwardRef14((_a, ref) => {
  var _b = _a, { className, children, checked } = _b, props = __objRest(_b, ["className", "children", "checked"]);
  return /* @__PURE__ */ jsxs15(
    DropdownMenuPrimitive.CheckboxItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-light-200 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        className
      ),
      checked
    }, props), {
      children: [
        /* @__PURE__ */ jsx24("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx24(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx24(CheckIcon4, { className: "tw-h-4 tw-w-4" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = forwardRef14((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs15(
    DropdownMenuPrimitive.RadioItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-4 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors hover:tw-bg-light-200 focus:tw-light-100 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx24("span", { className: "tw-absolute tw-right-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx24(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx24(CheckIcon4, { className: "tw-h-4 tw-w-4" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = forwardRef14((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx24(
    DropdownMenuPrimitive.Label,
    __spreadValues({
      ref,
      className: cn(
        "tw-px-2 tw-py-1.5 tw-text-xs tw-text-dark-300",
        inset && "tw-pl-8",
        className
      )
    }, props)
  );
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = forwardRef14((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx24(
    DropdownMenuPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("tw--mx-1 tw-my-1 tw-h-px tw-bg-light-200", className)
    }, props)
  );
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx24(
    "span",
    __spreadValues({
      className: cn(
        "tw-ml-auto tw-text-xs tw-tracking-widest tw-opacity-60",
        className
      )
    }, props)
  );
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";
var DropdownMenuIcon = (_a) => {
  var _b = _a, {
    icon,
    className,
    danger
  } = _b, props = __objRest(_b, [
    "icon",
    "className",
    "danger"
  ]);
  return cloneElement4(icon, __spreadValues({
    className: cn(
      `tw-mr-2 tw-h-4 tw-w-4 ${danger ? "tw-text-error-700" : "tw-text-dark-300"}`,
      className
    )
  }, props));
};
DropdownMenuIcon.displayName = "DropdownMenuIcon";

// src/components/ContextMenu/ContextMenu.tsx
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var ContextMenu = ContextMenuPrimitive.Root;
var ContextMenuTrigger = ContextMenuPrimitive.Trigger;
var ContextMenuGroup = ContextMenuPrimitive.Group;
var ContextMenuPortal = ContextMenuPrimitive.Portal;
var ContextMenuSub = ContextMenuPrimitive.Sub;
var ContextMenuRadioGroup = ContextMenuPrimitive.RadioGroup;
var ContextMenuIcon = DropdownMenuIcon;
ContextMenuIcon.displayName = "ContextMenuIcon";
var ContextMenuSubTrigger = forwardRef15((_a, ref) => {
  var _b = _a, { className, inset, children } = _b, props = __objRest(_b, ["className", "inset", "children"]);
  return /* @__PURE__ */ jsxs16(
    ContextMenuPrimitive.SubTrigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none focus:tw-bg-light-200 data-[state=open]:tw-light-100",
        inset && "tw-pl-8",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx25(MdChevronRight2, { className: "tw-ml-auto tw-h-4 tw-w-4" })
      ]
    })
  );
});
ContextMenuSubTrigger.displayName = ContextMenuPrimitive.SubTrigger.displayName;
var ContextMenuSubContent = forwardRef15((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    ContextMenuPrimitive.SubContent,
    __spreadValues({
      ref,
      className: cn(
        "tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-white tw-p-1 tw-text-black tw-shadow-md tw-animate-in data-[side=bottom]:tw-slide-in-from-top-1 data-[side=left]:tw-slide-in-from-right-1 data-[side=right]:tw-slide-in-from-left-1 data-[side=top]:tw-slide-in-from-bottom-1",
        className
      )
    }, props)
  );
});
ContextMenuSubContent.displayName = ContextMenuPrimitive.SubContent.displayName;
var ContextMenuContent = forwardRef15((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(ContextMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx25(
    ContextMenuPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "tw-z-50 tw-min-w-[16rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-white tw-p-1 tw-text-black tw-shadow-md tw-animate-in data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
ContextMenuContent.displayName = ContextMenuPrimitive.Content.displayName;
var ContextMenuItem = forwardRef15((_a, ref) => {
  var _b = _a, { className, danger, inset } = _b, props = __objRest(_b, ["className", "danger", "inset"]);
  return /* @__PURE__ */ jsx25(
    ContextMenuPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-text-black tw-outline-none tw-transition-colors focus:tw-bg-light-200 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 tw-ring-0",
        inset && "tw-pl-8",
        danger && "tw-text-error-700",
        className
      )
    }, props)
  );
});
ContextMenuItem.displayName = ContextMenuPrimitive.Item.displayName;
var ContextMenuCheckboxItem = forwardRef15((_a, ref) => {
  var _b = _a, { className, children, checked } = _b, props = __objRest(_b, ["className", "children", "checked"]);
  return /* @__PURE__ */ jsxs16(
    ContextMenuPrimitive.CheckboxItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-light-200 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        className
      ),
      checked
    }, props), {
      children: [
        /* @__PURE__ */ jsx25("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx25(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx25(MdCheck2, { className: "h-4 w-4" }) }) }),
        children
      ]
    })
  );
});
ContextMenuCheckboxItem.displayName = ContextMenuPrimitive.CheckboxItem.displayName;
var ContextMenuRadioItem = forwardRef15((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs16(
    ContextMenuPrimitive.RadioItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-4 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors hover:tw-bg-light-200 focus:tw-light-100 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx25("span", { className: "tw-absolute tw-right-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx25(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx25(CheckIcon5, { className: "tw-h-4 tw-w-4" }) }) }),
        children
      ]
    })
  );
});
ContextMenuRadioItem.displayName = ContextMenuPrimitive.RadioItem.displayName;
var ContextMenuLabel = forwardRef15((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx25(
    ContextMenuPrimitive.Label,
    __spreadValues({
      ref,
      className: cn(
        "tw-px-2 tw-py-1.5 tw-text-xs tw-text-dark-300",
        inset && "tw-pl-8",
        className
      )
    }, props)
  );
});
ContextMenuLabel.displayName = ContextMenuPrimitive.Label.displayName;
var ContextMenuSeparator = forwardRef15((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    ContextMenuPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("tw--mx-1 tw-my-1 tw-h-px tw-bg-light-200", className)
    }, props)
  );
});
ContextMenuSeparator.displayName = ContextMenuPrimitive.Separator.displayName;
var ContextMenuShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx25(
    "span",
    __spreadValues({
      className: cn(
        "tw-ml-auto tw-text-xs tw-tracking-widest tw-opacity-60",
        className
      )
    }, props)
  );
};
ContextMenuShortcut.displayName = "ContextMenuShortcut";

// src/components/DateField/DateField.tsx
import { createCalendar as createCalendar3 } from "@internationalized/date";
import { useDateField, useDateSegment } from "@react-aria/datepicker";
import { useDateFieldState } from "@react-stately/datepicker";
import clsx5 from "clsx";
import { useRef as useRef8 } from "react";
import { jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var getSegmentPlaceholderText = (text, locale) => {
  if (locale.startsWith("en")) {
    return text.toUpperCase();
  }
  return text;
};
var DateSegment = ({
  segment,
  state,
  locale
}) => {
  const ref = useRef8(null);
  const { segmentProps } = useDateSegment(segment, state, ref);
  return /* @__PURE__ */ jsxs17(
    "div",
    __spreadProps(__spreadValues({}, segmentProps), {
      ref,
      className: "tw-box-content tw-tabular-nums tw-text-right tw-outline-none tw-rounded-sm tw-group focus:tw-ring-2 focus:tw-ring-offset-2",
      children: [
        /* @__PURE__ */ jsx26(
          "span",
          {
            "aria-hidden": "true",
            className: clsx5("tw-w-full tw-text-center", {
              "tw-hidden": !segment.isPlaceholder,
              "tw-h-0": !segment.isPlaceholder,
              "tw-block": segment.isPlaceholder
            }),
            children: segment.isPlaceholder ? getSegmentPlaceholderText(segment.text, locale) : segment.placeholder
          }
        ),
        segment.isPlaceholder ? "" : segment.text
      ]
    })
  );
};
var DateField = (_a) => {
  var _b = _a, {
    locale = "en-US",
    shouldForceLeadingZeros = true
  } = _b, props = __objRest(_b, [
    "locale",
    "shouldForceLeadingZeros"
  ]);
  const state = useDateFieldState(__spreadValues({
    createCalendar: createCalendar3,
    locale,
    shouldForceLeadingZeros
  }, props));
  const ref = useRef8(null);
  const { labelProps, fieldProps } = useDateField(props, state, ref);
  return /* @__PURE__ */ jsxs17("div", { className: "tw-flex tw-flex-col tw-items-start", children: [
    /* @__PURE__ */ jsx26("span", __spreadProps(__spreadValues({}, labelProps), { className: "tw-text-sm", children: props.label })),
    /* @__PURE__ */ jsx26(
      "div",
      __spreadProps(__spreadValues({}, fieldProps), {
        ref,
        className: "tw-flex tw-transition-colors tw-rounded-md",
        onClick: (e) => e.preventDefault(),
        children: state.segments.map((segment, i) => /* @__PURE__ */ jsx26(
          DateSegment,
          {
            segment,
            state,
            locale
          },
          i
        ))
      })
    )
  ] });
};
var DateField_default = DateField;

// src/components/DatePicker/DatePicker.tsx
import { CalendarDate as CalendarDate2, getLocalTimeZone as getLocalTimeZone4, today as today2 } from "@internationalized/date";
import { useDatePicker } from "@react-aria/datepicker";
import { useDatePickerState } from "@react-stately/datepicker";
import { useRef as useRef9, useState as useState5 } from "react";
import { MdCalendarToday } from "@teamworksdev/icons";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var DatePicker = (_a) => {
  var _b = _a, {
    allowUserInput = true,
    closeOnSelect = true,
    dateFormat = { month: "long", day: "numeric", year: "numeric" },
    locale = "en-US",
    placeholder
  } = _b, props = __objRest(_b, [
    "allowUserInput",
    "closeOnSelect",
    "dateFormat",
    "locale",
    "placeholder"
  ]);
  var _a2, _b2, _c, _d, _e;
  const ref = useRef9(null);
  const [isFieldFocused, setIsFieldFocused] = useState5(false);
  const state = useDatePickerState(__spreadProps(__spreadValues({}, props), {
    shouldCloseOnSelect: closeOnSelect
  }));
  const { fieldProps, dialogProps, calendarProps } = useDatePicker(
    props,
    state,
    ref
  );
  const todayDate = today2(getLocalTimeZone4());
  const { month: todayMonth, year: todayYear } = todayDate;
  const [selectedMonth, setSelectedMonth] = useState5(
    (_b2 = (_a2 = state.value) == null ? void 0 : _a2.month) != null ? _b2 : todayMonth
  );
  const [selectedYear, setSelectedYear] = useState5(
    (_d = (_c = state.value) == null ? void 0 : _c.year) != null ? _d : todayYear
  );
  const date = fieldProps.value;
  const onDateChange = (value) => {
    const { day, month, year } = value;
    const date2 = new CalendarDate2(year, month, day);
    state.setDateValue(date2);
    if (date2) {
      setSelectedMonth(month);
      setSelectedYear(year);
    }
  };
  const onDateFieldChange = (value) => {
    if (value) {
      const { day, month, year } = value;
      const date2 = new CalendarDate2(year, month, day);
      state.setDateValue(date2);
      if (date2) {
        setSelectedMonth(month);
        setSelectedYear(year);
      }
    }
  };
  const onOpenChange = (open) => {
    if (!open) {
      if (state.value) {
        setSelectedMonth(state.value.month);
        setSelectedYear(state.value.year);
      } else {
        setSelectedMonth(todayMonth);
        setSelectedYear(todayYear);
      }
    }
    state.setOpen(open);
  };
  return /* @__PURE__ */ jsx27(
    "div",
    {
      onClick: (e) => e.preventDefault(),
      "aria-label": getTranslation("datePicker"),
      children: /* @__PURE__ */ jsxs18(Popover, __spreadProps(__spreadValues({}, dialogProps), { onOpenChange, open: state.isOpen, children: [
        /* @__PURE__ */ jsxs18(
          "div",
          {
            "aria-invalid": (_e = props["aria-invalid"]) != null ? _e : "false",
            className: cn(
              "tw-w-full tw-h-[44px] tw-justify-start tw-text-left tw-font-normal tw-overflow-hidden",
              "tw-flex tw-border tw-border-light-300 tw-border-r-6 tw-rounded-md tw-shadow-sm tw-shadow-[#E6EFFF]",
              !date && "tw-text-light-500",
              isFieldFocused && date && "tw-border-info-700",
              isFieldFocused && !date && "tw-border-error-700",
              state.isOpen && !date && "tw-border-info-700"
            ),
            children: [
              allowUserInput ? /* @__PURE__ */ jsx27(
                "div",
                {
                  className: "tw-w-[280px] tw-flex tw-justify-start tw-items-center tw-pl-4",
                  onFocus: () => setIsFieldFocused(true),
                  onBlur: () => setIsFieldFocused(false),
                  children: /* @__PURE__ */ jsx27(
                    DateField_default,
                    __spreadProps(__spreadValues({}, fieldProps), {
                      locale,
                      onChange: onDateFieldChange
                    })
                  )
                }
              ) : date ? /* @__PURE__ */ jsx27("span", { className: "tw-w-[280px] tw-flex tw-items-center tw-pl-4", children: new Intl.DateTimeFormat(locale, {
                month: dateFormat.month,
                day: dateFormat.day,
                year: dateFormat.year
              }).format(date.toDate(getLocalTimeZone4())) }) : /* @__PURE__ */ jsx27("span", { className: "tw-w-[280px] tw-flex tw-items-center tw-pl-4", children: placeholder || getTranslation("selectDate") }),
              /* @__PURE__ */ jsx27(
                PopoverTrigger,
                {
                  className: cn(
                    "tw-flex tw-items-center tw-justify-center",
                    "tw-h-full tw-w-[56px] tw-rounded-md tw-cursor-pointer",
                    "focus:tw-ring-1 focus:tw-ring-offset-1",
                    state.isOpen ? "tw-bg-light-300" : "tw-bg-light-50"
                  ),
                  "aria-label": getTranslation("openCalendar"),
                  children: /* @__PURE__ */ jsx27(
                    MdCalendarToday,
                    {
                      className: cn("tw-text-2xl", date && "tw-text-black")
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs18(
          PopoverContent,
          {
            className: "tw-w-auto tw-p-0 tw-bg-white tw-flex tw-flex-col",
            onMouseLeave: () => {
              if (!closeOnSelect)
                state.setOpen(false);
            },
            onKeyDown: (e) => {
              var _a3, _b3, _c2, _d2;
              if (e.key === "Escape") {
                if (state.isOpen) {
                  e.stopPropagation();
                  state.setOpen(false);
                  setSelectedMonth((_b3 = (_a3 = state.value) == null ? void 0 : _a3.month) != null ? _b3 : todayMonth);
                  setSelectedYear((_d2 = (_c2 = state.value) == null ? void 0 : _c2.year) != null ? _d2 : todayYear);
                }
              }
            },
            children: [
              /* @__PURE__ */ jsx27(
                Calendar_default,
                __spreadProps(__spreadValues({}, calendarProps), {
                  locale,
                  bordered: false,
                  onChange: onDateChange,
                  selectedMonth,
                  setSelectedMonth,
                  selectedYear,
                  setSelectedYear
                })
              ),
              /* @__PURE__ */ jsxs18("div", { className: "tw-flex tw-justify-center tw-pl-4 tw-pr-4 tw-pb-4", children: [
                /* @__PURE__ */ jsx27(
                  Button,
                  {
                    variant: "secondary",
                    size: "md",
                    className: "tw-w-1/2",
                    isDisabled: !date,
                    onClick: () => state.setValue(null),
                    children: getTranslation("clearSelection")
                  }
                ),
                /* @__PURE__ */ jsx27("div", { className: "tw-w-3" }),
                /* @__PURE__ */ jsx27(
                  Button,
                  {
                    variant: "secondary",
                    size: "md",
                    className: "tw-w-1/2 tw-border-info-700 tw-text-info-700 hover:tw-text-info-700",
                    onClick: () => {
                      setSelectedMonth(todayMonth);
                      setSelectedYear(todayYear);
                      state.setDateValue(todayDate);
                    },
                    children: getTranslation("today")
                  }
                )
              ] })
            ]
          }
        )
      ] }))
    }
  );
};
var DatePicker_default = DatePicker;

// src/components/DatePicker/DateRangePicker.tsx
import { getLocalTimeZone as getLocalTimeZone5 } from "@internationalized/date";
import { useDateRangePicker } from "@react-aria/datepicker";
import { useDateRangePickerState } from "@react-stately/datepicker";
import { useMemo as useMemo4, useRef as useRef10, useState as useState6 } from "react";
import { MdCalendarToday as MdCalendarToday2 } from "@teamworksdev/icons";
import { jsx as jsx28, jsxs as jsxs19 } from "react/jsx-runtime";
var DateRangePicker = (_a) => {
  var _b = _a, {
    allowUserInput = true,
    closeOnSelect = true,
    dateFormat = { month: "short", day: "numeric", year: "numeric" },
    locale = "en-US",
    placeholder
  } = _b, props = __objRest(_b, [
    "allowUserInput",
    "closeOnSelect",
    "dateFormat",
    "locale",
    "placeholder"
  ]);
  var _a2;
  const formatter = useDateFormatter(locale, dateFormat);
  const ref = useRef10(null);
  const [isFieldFocused, setIsFieldFocused] = useState6(false);
  const state = useDateRangePickerState(__spreadProps(__spreadValues({}, props), {
    shouldCloseOnSelect: closeOnSelect
  }));
  const { dialogProps, calendarProps, startFieldProps, endFieldProps } = useDateRangePicker(props, state, ref);
  const range = calendarProps.value;
  const makeReadableRange = (range2) => {
    const start = formatter.format(range2.start.toDate(getLocalTimeZone5()));
    const end = formatter.format(range2.end.toDate(getLocalTimeZone5()));
    return `${start} - ${end}`;
  };
  return /* @__PURE__ */ jsx28(
    "div",
    {
      onClick: (e) => e.preventDefault(),
      "aria-label": getTranslation("dateRangePicker"),
      children: /* @__PURE__ */ jsxs19(
        Popover,
        __spreadProps(__spreadValues({}, dialogProps), {
          onOpenChange: state.setOpen,
          open: state.isOpen,
          children: [
            /* @__PURE__ */ jsxs19(
              "div",
              {
                "aria-invalid": (_a2 = props["aria-invalid"]) != null ? _a2 : "false",
                className: cn(
                  "tw-w-full tw-h-[44px] tw-justify-start tw-text-left tw-font-normal tw-overflow-hidden",
                  "tw-flex tw-border tw-border-light-300 tw-border-r-6 tw-rounded-md",
                  {
                    "tw-border-info-700 tw-ring tw-ring-info-25 tw-ring-offset-info-25": (state.isOpen || isFieldFocused) && props["aria-invalid"] === false,
                    "tw-ring tw-ring-error-25 tw-ring-offset-error-25": (state.isOpen || isFieldFocused) && props["aria-invalid"] === true,
                    "tw-text-light-500": !range
                  },
                  "aria-invalid:tw-focus-error",
                  "tw-focus"
                ),
                children: [
                  allowUserInput ? /* @__PURE__ */ jsxs19(
                    "div",
                    {
                      className: "tw-w-[317px] tw-flex tw-justify-start tw-items-center tw-pl-4",
                      onFocus: () => setIsFieldFocused(true),
                      onBlur: () => setIsFieldFocused(false),
                      children: [
                        /* @__PURE__ */ jsx28(DateField_default, __spreadProps(__spreadValues({}, startFieldProps), { locale })),
                        /* @__PURE__ */ jsx28("div", { className: "tw-pl-[0.188rem] tw-pr-[0.188rem]", children: "-" }),
                        /* @__PURE__ */ jsx28(DateField_default, __spreadProps(__spreadValues({}, endFieldProps), { locale }))
                      ]
                    }
                  ) : range ? /* @__PURE__ */ jsx28("span", { className: "tw-w-[317px] tw-flex tw-items-center tw-pl-4", children: makeReadableRange(range) }) : /* @__PURE__ */ jsx28("span", { className: "tw-w-[317px] tw-flex tw-items-center tw-pl-4", children: placeholder || getTranslation("selectDateRange") }),
                  /* @__PURE__ */ jsx28(
                    PopoverTrigger,
                    {
                      className: cn(
                        "tw-flex tw-items-center tw-justify-center",
                        "tw-h-full tw-w-[56px] tw-rounded-md tw-cursor-pointer",
                        "focus:tw-ring-1 focus:tw-ring-offset-1",
                        state.isOpen ? "tw-bg-light-300" : "tw-bg-light-50"
                      ),
                      onFocus: () => setIsFieldFocused(true),
                      onBlur: () => setIsFieldFocused(false),
                      "aria-label": getTranslation("openCalendar"),
                      children: /* @__PURE__ */ jsx28(
                        MdCalendarToday2,
                        {
                          className: cn("tw-text-2xl", range && "tw-text-black")
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxs19(
              PopoverContent,
              {
                className: "tw-w-auto tw-p-0 tw-flex tw-flex-col tw-bg-white",
                onMouseLeave: () => {
                  if (!closeOnSelect)
                    state.setOpen(false);
                },
                children: [
                  /* @__PURE__ */ jsx28(CalendarRange_default, __spreadProps(__spreadValues({}, calendarProps), { locale, bordered: false })),
                  /* @__PURE__ */ jsx28("div", { className: "tw-border-t tw-border-light-200" }),
                  /* @__PURE__ */ jsx28("div", { className: "tw-flex tw-justify-start tw-w-full tw-p-2", children: /* @__PURE__ */ jsx28(
                    Button,
                    {
                      variant: "secondary",
                      size: "md",
                      isDisabled: !range,
                      onClick: () => state.setValue({ start: null, end: null }),
                      children: getTranslation("clearSelection")
                    }
                  ) })
                ]
              }
            )
          ]
        })
      )
    }
  );
};
function useDateFormatter(locale, dateFormat) {
  const formatter = useMemo4(
    () => new Intl.DateTimeFormat(locale, {
      month: dateFormat.month,
      day: dateFormat.day,
      year: dateFormat.year
    }),
    [locale, dateFormat]
  );
  return formatter;
}
var DateRangePicker_default = DateRangePicker;

// src/components/DatePicker/DateTimePicker.tsx
import {
  CalendarDateTime,
  getLocalTimeZone as getLocalTimeZone6,
  today as today3
} from "@internationalized/date";
import { useDatePicker as useDatePicker2 } from "@react-aria/datepicker";
import { useDatePickerState as useDatePickerState2 } from "@react-stately/datepicker";
import { useRef as useRef15, useState as useState8 } from "react";
import { MdCalendarToday as MdCalendarToday3 } from "@teamworksdev/icons";

// src/components/TimePicker/TimePicker.tsx
import { Time } from "@internationalized/date";
import { useRef as useRef14, useState as useState7 } from "react";
import { CheckIcon as CheckIcon6, MdAccessTime } from "@teamworksdev/icons";

// src/components/TimeField/TimeField.tsx
import { useDateSegment as useDateSegment2, useTimeField } from "@react-aria/datepicker";
import {
  useTimeFieldState
} from "@react-stately/datepicker";
import clsx6 from "clsx";
import { useRef as useRef11 } from "react";
import { jsx as jsx29, jsxs as jsxs20 } from "react/jsx-runtime";
var TimeSegment = ({
  segment,
  state
}) => {
  const ref = useRef11(null);
  const { segmentProps } = useDateSegment2(segment, state, ref);
  const isColon = segment.type === "literal" && segment.text === ":";
  const isSpace = segment.type === "literal" && segment.text === "\u202F";
  const isDecorator = isColon || isSpace;
  return /* @__PURE__ */ jsxs20(
    "div",
    __spreadProps(__spreadValues({}, segmentProps), {
      ref,
      onClick: (e) => {
        e.stopPropagation();
      },
      className: clsx6(
        "tw-box-content tw-tabular-nums tw-text-right tw-outline-none tw-rounded-sm tw-group focus:tw-ring-2 focus:tw-ring-offset-2",
        {
          "tw-border-none tw-bg-transparent tw-px-0 tw-py-0": isDecorator,
          "tw-hidden": isSpace,
          "tw-text-light-500": !segment.isEditable
        }
      ),
      children: [
        /* @__PURE__ */ jsx29(
          "span",
          {
            "aria-hidden": "true",
            className: clsx6("tw-pointer-events-none tw-w-full tw-text-left", {
              "tw-hidden": !segment.isPlaceholder,
              "tw-h-0": !segment.isPlaceholder,
              "tw-block": segment.isPlaceholder
            }),
            children: segment.placeholder
          }
        ),
        segment.isPlaceholder ? "" : segment.text
      ]
    })
  );
};
var TimeField = (_a) => {
  var _b = _a, {
    locale = "en-US",
    hourCycle
  } = _b, props = __objRest(_b, [
    "locale",
    "hourCycle"
  ]);
  const ref = useRef11(null);
  const state = useTimeFieldState(__spreadValues({
    hourCycle,
    locale,
    shouldForceLeadingZeros: true,
    autoFocus: true
  }, props));
  const { fieldProps } = useTimeField(
    __spreadProps(__spreadValues({}, props), {
      hourCycle,
      shouldForceLeadingZeros: true
    }),
    state,
    ref
  );
  return /* @__PURE__ */ jsx29("div", { className: "tw-flex tw-flex-col tw-items-start", children: /* @__PURE__ */ jsx29("div", __spreadProps(__spreadValues({}, fieldProps), { ref, className: "tw-flex tw-w-full tw-gap-x-1", children: state.segments.map((segment, i) => /* @__PURE__ */ jsx29(TimeSegment, { segment, state }, i)) })) });
};
var TimeField_default = TimeField;

// src/hooks/useOutsideClick.ts
import { useEffect as useEffect7, useRef as useRef13 } from "react";

// src/hooks/useCallbackRef.ts
import { useCallback as useCallback2, useEffect as useEffect6, useRef as useRef12 } from "react";
function useCallbackRef(callback, deps = []) {
  const callbackRef = useRef12(callback);
  useEffect6(() => {
    callbackRef.current = callback;
  });
  return useCallback2((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}

// src/hooks/useOutsideClick.ts
function useOutsideClick(props) {
  const { ref, handler, enabled = true } = props;
  const savedHandler = useCallbackRef(handler);
  const stateRef = useRef13({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  const state = stateRef.current;
  useEffect7(() => {
    if (!enabled)
      return;
    const onPointerDown = (e) => {
      if (isValidEvent(e, ref)) {
        state.isPointerDown = true;
      }
    };
    const onMouseUp = (event) => {
      if (state.ignoreEmulatedMouseEvents) {
        state.ignoreEmulatedMouseEvents = false;
        return;
      }
      if (state.isPointerDown && handler && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const onTouchEnd = (event) => {
      state.ignoreEmulatedMouseEvents = true;
      if (handler && state.isPointerDown && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const doc = getOwnerDocument(ref.current);
    doc.addEventListener("mousedown", onPointerDown, true);
    doc.addEventListener("mouseup", onMouseUp, true);
    doc.addEventListener("touchstart", onPointerDown, true);
    doc.addEventListener("touchend", onTouchEnd, true);
    return () => {
      doc.removeEventListener("mousedown", onPointerDown, true);
      doc.removeEventListener("mouseup", onMouseUp, true);
      doc.removeEventListener("touchstart", onPointerDown, true);
      doc.removeEventListener("touchend", onTouchEnd, true);
    };
  }, [handler, ref, savedHandler, state, enabled]);
}
function isValidEvent(event, ref) {
  var _a;
  const target = event.target;
  if (target) {
    const doc = getOwnerDocument(target);
    if (!doc.contains(target))
      return false;
  }
  return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function getOwnerDocument(node) {
  var _a;
  return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}

// src/components/TimePicker/TimePicker.tsx
import { jsx as jsx30, jsxs as jsxs21 } from "react/jsx-runtime";
var TimePicker = ({
  canTypeTime = true,
  locale = "en-US",
  interval = 15,
  isPastTimeDisabled = false,
  onChange,
  placeholder,
  value
}) => {
  const nowButton = useRef14(null);
  const applyButton = useRef14(null);
  const optionItem = useRef14(null);
  const dropdownContent = useRef14(null);
  const [isFieldFocused, setIsFieldFocused] = useState7(false);
  const [isMenuOpen, setIsMenuOpen] = useState7(false);
  const formatTime = (value2) => {
    if (!value2)
      return {
        selectedHour: void 0,
        selectedMinute: void 0
      };
    let hour = value2.hour;
    let minute = value2.minute;
    return {
      selectedHour: hour,
      selectedMinute: minute
    };
  };
  const resetToInitialValue = () => {
    setSelectedHour(initialTime.selectedHour);
    setSelectedMinute(initialTime.selectedMinute);
    setIsMenuOpen(false);
  };
  useOutsideClick({
    ref: dropdownContent,
    handler: () => {
      resetToInitialValue();
    }
  });
  const initialTime = formatTime(value);
  const options = getTimeOptions(locale, interval, isPastTimeDisabled);
  const currentTime = /* @__PURE__ */ new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();
  const [selectedHour, setSelectedHour] = useState7(
    initialTime.selectedHour
  );
  const [selectedMinute, setSelectedMinute] = useState7(
    initialTime.selectedMinute
  );
  const menuKeyDown = (e) => {
    var _a, _b, _c, _d, _e, _f;
    const { key, shiftKey } = e;
    switch (key) {
      case "Escape":
        if (isMenuOpen) {
          resetToInitialValue();
        }
        break;
      case "Tab":
        if (shiftKey) {
          if (nowButton.current === document.activeElement) {
            (_a = optionItem.current) == null ? void 0 : _a.focus();
          } else if (applyButton.current === document.activeElement) {
            (_b = nowButton.current) == null ? void 0 : _b.focus();
          } else {
            (_c = applyButton.current) == null ? void 0 : _c.focus();
          }
        } else {
          if (nowButton.current === document.activeElement) {
            (_d = applyButton.current) == null ? void 0 : _d.focus();
          } else if (applyButton.current === document.activeElement) {
            (_e = optionItem.current) == null ? void 0 : _e.focus();
          } else {
            (_f = nowButton.current) == null ? void 0 : _f.focus();
          }
        }
        break;
      default:
        break;
    }
  };
  return /* @__PURE__ */ jsx30(
    "div",
    {
      onClick: (e) => e.preventDefault(),
      "aria-label": getTranslation("timePicker"),
      children: /* @__PURE__ */ jsxs21(DropdownMenu, { open: isMenuOpen, children: [
        /* @__PURE__ */ jsxs21(
          "div",
          {
            className: cn(
              "tw-w-full tw-h-[44px] tw-justify-start tw-text-left tw-font-normal tw-overflow-hidden",
              "tw-flex tw-border tw-border-light-300 tw-border-r-6 tw-rounded-md tw-shadow-sm tw-shadow-[#E6EFFF]",
              !value && "tw-text-light-500",
              isFieldFocused && value && "tw-border-info-700",
              isFieldFocused && !value && "tw-border-error-700",
              isMenuOpen && !value && "tw-border-info-700"
            ),
            children: [
              canTypeTime ? /* @__PURE__ */ jsx30(
                "div",
                {
                  className: "tw-w-[120px] tw-flex tw-justify-start tw-items-center tw-pl-4",
                  onFocus: () => setIsFieldFocused(true),
                  onBlur: () => setIsFieldFocused(false),
                  children: /* @__PURE__ */ jsx30(
                    TimeField_default,
                    {
                      value,
                      onChange: (value2) => {
                        if (value2) {
                          const { hour, minute } = value2;
                          setSelectedHour(hour);
                          setSelectedMinute(minute);
                          onChange(value2);
                        }
                      },
                      locale
                    }
                  )
                }
              ) : value ? /* @__PURE__ */ jsx30("div", { className: "tw-w-[120px] tw-flex tw-justify-start tw-items-center tw-pl-4", children: /* @__PURE__ */ jsx30(TimeField_default, { value, locale, isDisabled: true }) }) : /* @__PURE__ */ jsx30("span", { className: "tw-w-[120px] tw-flex tw-items-center tw-pl-4", children: placeholder || getTranslation("selectTime") }),
              /* @__PURE__ */ jsx30(
                DropdownMenuTrigger,
                {
                  className: cn(
                    "tw-flex tw-items-center tw-justify-center",
                    "tw-h-full tw-w-[56px] tw-rounded-md tw-cursor-pointer",
                    "focus:tw-ring-1 focus:tw-ring-offset-1",
                    isMenuOpen ? "tw-bg-light-300" : "tw-bg-light-50"
                  ),
                  "aria-label": getTranslation("openTimePicker"),
                  onClick: () => setIsMenuOpen(true),
                  onKeyDown: (e) => {
                    if (e.key === "Enter")
                      setIsMenuOpen(true);
                  },
                  children: /* @__PURE__ */ jsx30(
                    MdAccessTime,
                    {
                      className: cn("tw-text-2xl", value && "tw-text-black")
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs21(
          DropdownMenuContent,
          {
            className: "tw-p-0 tw-bg-white tw-flex tw-flex-col tw-fixed tw-left-[-150px]",
            ref: dropdownContent,
            onKeyDown: menuKeyDown,
            children: [
              /* @__PURE__ */ jsx30("div", { className: "tw-flex tw-overflow-auto", children: /* @__PURE__ */ jsx30(
                TimeOptions,
                {
                  options,
                  optionItem,
                  selectedHour,
                  selectedMinute,
                  setSelectedHour,
                  setSelectedMinute,
                  setIsMenuOpen
                }
              ) }),
              /* @__PURE__ */ jsx30("div", { className: "tw-border-t tw-border-light-200 tw-pb-4" }),
              /* @__PURE__ */ jsxs21("div", { className: "tw-flex tw-justify-center tw-pl-4 tw-pr-4 tw-pb-4", children: [
                /* @__PURE__ */ jsx30(
                  Button,
                  {
                    variant: "secondary",
                    size: "md",
                    ref: nowButton,
                    className: "tw-w-1/2 tw-border-info-700 tw-text-info-700 hover:tw-text-info-700",
                    onClick: () => {
                      setSelectedHour(currentHour);
                      setSelectedMinute(currentMinute);
                      onChange(new Time(currentHour, currentMinute));
                      setIsMenuOpen(false);
                    },
                    children: getTranslation("now")
                  }
                ),
                /* @__PURE__ */ jsx30("div", { className: "tw-w-3" }),
                /* @__PURE__ */ jsx30(
                  Button,
                  {
                    variant: "primary",
                    size: "md",
                    ref: applyButton,
                    className: "tw-w-1/2",
                    onClick: () => {
                      onChange(new Time(selectedHour, selectedMinute));
                      setIsMenuOpen(false);
                    },
                    children: getTranslation("apply")
                  }
                )
              ] })
            ]
          }
        )
      ] })
    }
  );
};
var TimeOptions = ({
  options,
  optionItem,
  selectedHour,
  selectedMinute,
  setSelectedHour,
  setSelectedMinute,
  setIsMenuOpen
}) => {
  const onOptionClick = (hour, minute) => {
    setSelectedHour(hour);
    setSelectedMinute(minute);
    setIsMenuOpen(true);
  };
  return /* @__PURE__ */ jsx30(
    "div",
    {
      role: "list",
      className: "tw-flex tw-flex-col tw-grow tw-p-2 tw-overflow-y-auto tw-max-h-[200px]",
      children: options.map((option) => /* @__PURE__ */ jsx30(
        DropdownMenuItem,
        {
          ref: optionItem,
          disabled: option.disabled,
          role: "listitem",
          onClick: () => onOptionClick(option.hour, option.minute),
          children: /* @__PURE__ */ jsxs21("div", { className: "tw-flex tw-w-full tw-items-center tw-justify-between", children: [
            option.label,
            selectedHour === option.hour && selectedMinute === option.minute && /* @__PURE__ */ jsx30(CheckIcon6, { className: "tw-h-4 tw-w-4" })
          ] })
        },
        option.label
      ))
    }
  );
};
var TimePicker_default = TimePicker;

// src/components/TimePicker/index.tsx
var getTimeOptions = (timeFormat, interval, isPastTimeDisabled) => {
  const options = [];
  const currentTime = /* @__PURE__ */ new Date();
  const optionTime = /* @__PURE__ */ new Date();
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += interval) {
      let disabled = false;
      const formattedHour = timeFormat === "en-US" ? hour % 12 || 12 : hour;
      const meridiem = hour < 12 ? "AM" : "PM";
      const label = timeFormat === "en-US" ? `${formattedHour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${meridiem}` : `${formattedHour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
      if (isPastTimeDisabled) {
        optionTime.setHours(hour);
        optionTime.setMinutes(minute);
        optionTime.setSeconds(0);
        optionTime.setMilliseconds(0);
        if (optionTime < currentTime) {
          disabled = true;
        }
      }
      options.push({ label, hour, minute, disabled });
    }
  }
  return options;
};

// src/components/DatePicker/DateTimePicker.tsx
import { jsx as jsx31, jsxs as jsxs22 } from "react/jsx-runtime";
var DateTimePicker = (_a) => {
  var _b = _a, {
    allowUserInput = true,
    closeOnSelect = false,
    dateFormat = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    },
    locale = "en-US",
    placeholder,
    isPastTimeDisabled = false,
    interval = 15
  } = _b, props = __objRest(_b, [
    "allowUserInput",
    "closeOnSelect",
    "dateFormat",
    "locale",
    "placeholder",
    "isPastTimeDisabled",
    "interval"
  ]);
  var _a2, _b2, _c, _d, _e, _f;
  const ref = useRef15(null);
  const [isFieldFocused, setIsFieldFocused] = useState8(false);
  const state = useDatePickerState2(__spreadProps(__spreadValues({}, props), {
    shouldCloseOnSelect: closeOnSelect,
    granularity: "minute"
  }));
  const { fieldProps, dialogProps, calendarProps } = useDatePicker2(
    props,
    state,
    ref
  );
  const todayDate = today3(getLocalTimeZone6());
  const { month: todayMonth, year: todayYear, day: todayDay } = todayDate;
  const [selectedMonth, setSelectedMonth] = useState8(
    (_b2 = (_a2 = state.value) == null ? void 0 : _a2.month) != null ? _b2 : todayMonth
  );
  const [selectedYear, setSelectedYear] = useState8(
    (_d = (_c = state.value) == null ? void 0 : _c.year) != null ? _d : todayYear
  );
  const [selectedDay, setSelectedDay] = useState8(
    (_f = (_e = state.value) == null ? void 0 : _e.day) != null ? _f : todayDay
  );
  const [currentValue, setCurrentValue] = useState8({
    day: void 0,
    year: void 0,
    month: void 0,
    hour: void 0,
    minute: void 0
  });
  const date = fieldProps.value;
  const onDateTimeChange = (value) => {
    var _a3, _b3, _c2, _d2, _e2, _f2;
    const { hour, minute } = value;
    const calendarDateTime = new CalendarDateTime(
      (_b3 = (_a3 = state.value) == null ? void 0 : _a3.year) != null ? _b3 : todayYear,
      (_d2 = (_c2 = state.value) == null ? void 0 : _c2.month) != null ? _d2 : todayMonth,
      (_f2 = (_e2 = state.value) == null ? void 0 : _e2.day) != null ? _f2 : todayDay,
      hour,
      minute
    );
    state.setValue(calendarDateTime);
  };
  const onDateChange = (value) => {
    var _a3, _b3, _c2, _d2;
    const { day, month, year } = value;
    const calendarDateTime = new CalendarDateTime(
      year,
      month,
      day,
      (_b3 = (_a3 = state.timeValue) == null ? void 0 : _a3.hour) != null ? _b3 : 23,
      (_d2 = (_c2 = state.timeValue) == null ? void 0 : _c2.minute) != null ? _d2 : 59
    );
    setSelectedMonth(month);
    setSelectedYear(year);
    setSelectedDay(day);
    state.setValue(calendarDateTime);
  };
  const onDateFieldChange = (value) => {
    const dateTimeValue = value;
    if (dateTimeValue) {
      const { day, month, year, hour, minute } = dateTimeValue;
      const calendarDateTime = new CalendarDateTime(
        year,
        month,
        day,
        hour,
        minute
      );
      state.setValue(calendarDateTime);
      setCurrentValue({
        month,
        year,
        day,
        hour,
        minute
      });
    }
  };
  const onOpenChange = (open) => {
    if (!open) {
      if (state.value) {
        setSelectedMonth(state.value.month);
        setSelectedYear(state.value.year);
        setSelectedDay(state.value.day);
      } else {
        setSelectedMonth(todayMonth);
        setSelectedYear(todayYear);
        setSelectedDay(todayDay);
      }
    }
    state.setOpen(open);
  };
  const onClearClick = () => {
    setSelectedMonth(todayMonth);
    setSelectedYear(todayYear);
    setSelectedDay(todayDay);
    state.setValue(null);
  };
  const onTodayClick = () => {
    var _a3, _b3;
    setSelectedMonth(todayMonth);
    setSelectedYear(todayYear);
    setSelectedDay(todayDay);
    const calendarDateTime = new CalendarDateTime(
      todayYear,
      todayMonth,
      todayDay,
      (_a3 = state.timeValue) == null ? void 0 : _a3.hour,
      (_b3 = state.timeValue) == null ? void 0 : _b3.minute
    );
    state.setValue(calendarDateTime);
  };
  const onApplyClick = () => {
    var _a3, _b3;
    setCurrentValue({
      month: selectedMonth,
      year: selectedYear,
      day: selectedDay,
      hour: (_a3 = state.timeValue) == null ? void 0 : _a3.hour,
      minute: (_b3 = state.timeValue) == null ? void 0 : _b3.minute
    });
    state.setOpen(false);
  };
  const onCancelClick = () => {
    if (currentValue.day && currentValue.year && currentValue.month && currentValue.hour !== void 0 && currentValue.minute !== void 0) {
      const calendarDateTime = new CalendarDateTime(
        currentValue.year,
        currentValue.month,
        currentValue.day,
        currentValue.hour,
        currentValue.minute
      );
      state.setValue(calendarDateTime);
    } else {
      state.setValue(null);
    }
    state.setOpen(false);
  };
  return /* @__PURE__ */ jsx31(
    "div",
    {
      onClick: (e) => e.preventDefault(),
      "aria-label": getTranslation("dateTimePicker"),
      children: /* @__PURE__ */ jsxs22(Popover, __spreadProps(__spreadValues({}, dialogProps), { onOpenChange, open: state.isOpen, children: [
        /* @__PURE__ */ jsxs22(
          "div",
          {
            className: cn(
              "tw-w-full tw-h-[44px] tw-justify-start tw-text-left tw-font-normal tw-overflow-hidden",
              "tw-flex tw-border tw-border-light-300 tw-border-r-6 tw-rounded-md tw-shadow-sm tw-shadow-[#E6EFFF]",
              !date && "tw-text-light-500",
              isFieldFocused && date && "tw-border-info-700",
              isFieldFocused && !date && "tw-border-error-700",
              state.isOpen && !date && "tw-border-info-700"
            ),
            children: [
              allowUserInput ? /* @__PURE__ */ jsx31(
                "div",
                {
                  className: "tw-w-[280px] tw-flex tw-justify-start tw-items-center tw-pl-4",
                  onFocus: () => setIsFieldFocused(true),
                  onBlur: () => setIsFieldFocused(false),
                  children: /* @__PURE__ */ jsx31(
                    DateField_default,
                    __spreadProps(__spreadValues({}, fieldProps), {
                      locale,
                      onChange: onDateFieldChange,
                      granularity: "minute"
                    })
                  )
                }
              ) : date ? /* @__PURE__ */ jsx31("span", { className: "tw-w-[280px] tw-flex tw-items-center tw-pl-4", children: new Intl.DateTimeFormat(locale, {
                month: dateFormat.month,
                day: dateFormat.day,
                year: dateFormat.year,
                hour: dateFormat.hour,
                minute: dateFormat.minute
              }).format(date.toDate(getLocalTimeZone6())) }) : /* @__PURE__ */ jsx31("span", { className: "tw-w-[280px] tw-flex tw-items-center tw-pl-4", children: placeholder || getTranslation("selectDate") }),
              /* @__PURE__ */ jsx31(
                PopoverTrigger,
                {
                  className: cn(
                    "tw-flex tw-items-center tw-justify-center",
                    "tw-h-full tw-w-[56px] tw-rounded-md tw-cursor-pointer",
                    "focus:tw-ring-1 focus:tw-ring-offset-1",
                    state.isOpen ? "tw-bg-light-300" : "tw-bg-light-50"
                  ),
                  onKeyDown: (e) => {
                    var _a3, _b3, _c2, _d2, _e2, _f2;
                    if (e.key === "Enter") {
                      e.stopPropagation();
                      setSelectedMonth((_b3 = (_a3 = state.value) == null ? void 0 : _a3.month) != null ? _b3 : todayMonth);
                      setSelectedYear((_d2 = (_c2 = state.value) == null ? void 0 : _c2.year) != null ? _d2 : todayYear);
                      setSelectedDay((_f2 = (_e2 = state.value) == null ? void 0 : _e2.day) != null ? _f2 : todayDay);
                    }
                  },
                  "aria-label": getTranslation("openCalendar"),
                  children: /* @__PURE__ */ jsx31(
                    MdCalendarToday3,
                    {
                      className: cn("tw-text-2xl", date && "tw-text-black")
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs22(
          PopoverContent,
          {
            className: "tw-w-auto tw-p-0 tw-bg-white tw-flex tw-flex-col",
            onKeyDown: (e) => {
              var _a3, _b3, _c2, _d2, _e2, _f2;
              if (e.key === "Escape") {
                if (state.isOpen) {
                  e.stopPropagation();
                  state.setOpen(false);
                  setSelectedMonth((_b3 = (_a3 = state.value) == null ? void 0 : _a3.month) != null ? _b3 : todayMonth);
                  setSelectedYear((_d2 = (_c2 = state.value) == null ? void 0 : _c2.year) != null ? _d2 : todayYear);
                  setSelectedDay((_f2 = (_e2 = state.value) == null ? void 0 : _e2.day) != null ? _f2 : todayDay);
                }
              }
            },
            children: [
              /* @__PURE__ */ jsxs22("div", { className: "tw-flex", children: [
                /* @__PURE__ */ jsx31(
                  Calendar_default,
                  __spreadProps(__spreadValues({}, calendarProps), {
                    locale,
                    bordered: false,
                    onChange: onDateChange,
                    selectedMonth,
                    setSelectedMonth,
                    selectedYear,
                    setSelectedYear
                  })
                ),
                /* @__PURE__ */ jsxs22("div", { className: "tw-flex tw-flex-col tw-pt-[48px] tw-pr-4", children: [
                  /* @__PURE__ */ jsx31("span", { className: "tw-text-light-500 tw-text-xs tw-pb-1", children: getTranslation("time") }),
                  /* @__PURE__ */ jsx31(
                    TimePicker_default,
                    {
                      locale,
                      interval,
                      isPastTimeDisabled,
                      canTypeTime: true,
                      value: state.timeValue,
                      onChange: onDateTimeChange
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ jsxs22("div", { className: "tw-flex tw-justify-between tw-pl-4 tw-pr-4 tw-pb-4", children: [
                /* @__PURE__ */ jsxs22("div", { className: "tw-flex", children: [
                  /* @__PURE__ */ jsx31(
                    Button,
                    {
                      variant: "secondary",
                      size: "md",
                      className: "tw-w-1/2",
                      isDisabled: !date,
                      onClick: onClearClick,
                      children: getTranslation("clearSelection")
                    }
                  ),
                  /* @__PURE__ */ jsx31("div", { className: "tw-w-3" }),
                  /* @__PURE__ */ jsx31(
                    Button,
                    {
                      variant: "secondary",
                      size: "md",
                      className: "tw-w-1/2 tw-border-info-700 tw-text-info-700 hover:tw-text-info-700",
                      onClick: onTodayClick,
                      children: getTranslation("today")
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs22("div", { className: "tw-flex", children: [
                  /* @__PURE__ */ jsx31(
                    Button,
                    {
                      variant: "secondary",
                      size: "md",
                      className: "tw-w-1/2",
                      onClick: onCancelClick,
                      children: getTranslation("cancel")
                    }
                  ),
                  /* @__PURE__ */ jsx31("div", { className: "tw-w-3" }),
                  /* @__PURE__ */ jsx31(
                    Button,
                    {
                      variant: "primary",
                      size: "md",
                      className: "tw-w-1/2",
                      onClick: onApplyClick,
                      children: getTranslation("apply")
                    }
                  )
                ] })
              ] })
            ]
          }
        )
      ] }))
    }
  );
};
var DateTimePicker_default = DateTimePicker;

// src/components/DownloadableFileModal/DownloadableFileModal.tsx
import {
  MdCheckCircle as MdCheckCircle2,
  MdClose as MdClose3,
  MdDownloadForOffline,
  MdReport
} from "@teamworksdev/icons";

// src/components/ProgressBar/ProgressBar.tsx
import * as Progress from "@radix-ui/react-progress";
import { forwardRef as forwardRef16 } from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var ProgressBar = forwardRef16((_a, ref) => {
  var _b = _a, { className, indicatorClassName, value } = _b, props = __objRest(_b, ["className", "indicatorClassName", "value"]);
  return /* @__PURE__ */ jsx32(
    Progress.Root,
    __spreadProps(__spreadValues({
      ref
    }, props), {
      value,
      className: cn(
        "tw-w-full tw-h-3 tw-rounded-full tw-relative tw-overflow-hidden",
        className
      ),
      children: /* @__PURE__ */ jsx32(
        Progress.Indicator,
        {
          className: cn(
            `tw-w-full tw-h-3 tw-rounded-full tw-bg-blue-800`,
            indicatorClassName
          ),
          style: {
            transition: "transform 600ms cubic-bezier(0.65, 0, 0.35, 1",
            transform: `translateX(-${100 - (value != null ? value : 0)}%)`
          }
        }
      )
    })
  );
});
ProgressBar.displayName = "ProgressBar";

// src/components/Tooltip/Tooltip.tsx
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { forwardRef as forwardRef17 } from "react";
import { jsx as jsx33 } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = (_a) => {
  var _b = _a, {
    delayDuration = 0
  } = _b, props = __objRest(_b, [
    "delayDuration"
  ]);
  return /* @__PURE__ */ jsx33(TooltipPrimitive.Root, __spreadValues({ delayDuration }, props));
};
Tooltip.displayName = TooltipPrimitive.Root.displayName;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipPortal = TooltipPrimitive.Portal;
var TooltipArrow = TooltipPrimitive.Arrow;
var TooltipContent = forwardRef17((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx33(
    TooltipPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "tw-z-50 tw-overflow-hidden tw-rounded-md tw-bg-dark-900 tw-px-3 tw-py-1.5 tw-text-xs tw-text-white tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

// src/components/DownloadableFileModal/DownloadableFileModal.tsx
import { jsx as jsx34, jsxs as jsxs23 } from "react/jsx-runtime";
var downloadInNewTab = (event, link) => {
  event.preventDefault();
  window.open(link || void 0);
};
var DownloadableFile = (file, className) => {
  let fileInfo = { icon: null, text: "" };
  switch (file.status) {
    case "generating" /* Generating */:
      fileInfo = {
        icon: file.errorMessage ? /* @__PURE__ */ jsx34(MdReport, { size: 24, color: colors.error[700] }) : /* @__PURE__ */ jsx34(MdDownloadForOffline, { size: 24, color: colors.info[700] }),
        text: getTranslation("generating")
      };
      break;
    case "ready" /* Ready */:
      fileInfo = {
        icon: /* @__PURE__ */ jsx34(MdCheckCircle2, { size: 24, color: colors.success[700] }),
        text: getTranslation("ready")
      };
      break;
    case "error" /* Error */:
      fileInfo = {
        icon: /* @__PURE__ */ jsx34(MdReport, { size: 24, color: colors.error[700] }),
        text: getTranslation("error")
      };
      break;
    default:
      break;
  }
  return /* @__PURE__ */ jsxs23(
    "div",
    {
      className: cn(
        "tw-flex tw-py-4 tw-px-0 tw-mx-4 tw-border-b tw-border-solid tw-border-dark-600 dark:tw-border-light-300",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs23("div", { className: "tw-w-6", children: [
          " ",
          fileInfo.icon
        ] }),
        /* @__PURE__ */ jsxs23("div", { className: "tw-flex tw-flex-col tw-px-2", children: [
          /* @__PURE__ */ jsx34("div", { className: "tw-text-base tw-font-semibold", children: fileInfo.text }),
          /* @__PURE__ */ jsx34(TooltipProvider, { children: /* @__PURE__ */ jsxs23(Tooltip, { children: [
            /* @__PURE__ */ jsx34(TooltipTrigger, { className: "tw-text-sm tw-text-left tw-text-white/[.60] tw-px-0 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-w-60 tw-cursor-default", children: file.title }),
            /* @__PURE__ */ jsx34(TooltipPortal, { children: /* @__PURE__ */ jsxs23(TooltipContent, { children: [
              file.title,
              " ",
              /* @__PURE__ */ jsx34(TooltipArrow, {})
            ] }) })
          ] }) }),
          file.createdDate && /* @__PURE__ */ jsx34("div", { className: "tw-m-0 tw-mb-2 tw-text-xs tw-text-white/[.60]", children: file.createdDate }),
          file.status === "generating" /* Generating */ && file.progressPercentage && /* @__PURE__ */ jsx34(ProgressBar, { value: file.progressPercentage })
        ] }),
        file.status === "ready" /* Ready */ && file.url && /* @__PURE__ */ jsx34(
          "a",
          {
            href: file.url,
            onClick: (event) => downloadInNewTab(event, file.url),
            className: "tw-text-xs tw-font-semibold tw-text-white tw-text-right tw-cursor-pointer dark:tw-text-black",
            children: getTranslation("download")
          }
        )
      ]
    },
    file.downloadableFileId
  );
};
var DownloadableFileTitle = ({
  children,
  className
}) => {
  return /* @__PURE__ */ jsx34("div", { className: cn("tw-w-full", className), children: /* @__PURE__ */ jsx34(AccordionTrigger, { className: "tw-w-[340px] tw-p-4 tw-text-base tw-font-semibold", children }) });
};
var DownloadableFileContent = ({
  children,
  className
}) => {
  return /* @__PURE__ */ jsxs23(
    AccordionContent,
    {
      className: cn("tw-p-0 tw-flex tw-flex-col tw-max-h-60", className),
      children: [
        /* @__PURE__ */ jsx34("div", { className: "tw-border-b tw-border-solid tw-border-dark-300 tw-mx-4" }),
        /* @__PURE__ */ jsx34(
          "div",
          {
            className: "tw-p-0 tw-flex tw-flex-col tw-overflow-y-scroll",
            style: {
              scrollbarColor: `${colors.gray[300]} ${colors.dark[800]}`
            },
            children
          }
        )
      ]
    }
  );
};
var DownloadableFileModal = (_a) => {
  var _b = _a, {
    children,
    className,
    visible,
    onClose
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "visible",
    "onClose"
  ]);
  if (!visible)
    return null;
  return /* @__PURE__ */ jsxs23(
    AccordionRoot,
    __spreadProps(__spreadValues({
      type: "multiple",
      defaultValue: ["downloadable-file-modal"],
      className: cn(
        "tw-fixed tw-right-10 tw-bottom-10 tw-text-white tw-bg-dark-800 dark:tw-text-black dark:tw-bg-light-50 tw-w-96 tw-items-center tw-shadow-xl tw-rounded-md tw-p-0 z-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx34(
          MdClose3,
          {
            size: 24,
            color: colors.white,
            onClick: onClose,
            className: "tw-absolute tw-right-4 tw-top-4 tw-cursor-pointer"
          }
        ),
        /* @__PURE__ */ jsx34(AccordionItem, { value: "downloadable-file-modal", children })
      ]
    })
  );
};

// src/components/Drawer/Drawer.tsx
import * as DialogPrimitive2 from "@radix-ui/react-dialog";
import { cva as cva8 } from "class-variance-authority";
import { forwardRef as forwardRef18 } from "react";
import { MdClose as MdClose4 } from "@teamworksdev/icons";
import { jsx as jsx35, jsxs as jsxs24 } from "react/jsx-runtime";
var Drawer = DialogPrimitive2.Root;
var DrawerTrigger = DialogPrimitive2.Trigger;
var DrawerClose = DialogPrimitive2.Close;
var DrawerPortal = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx35(DialogPrimitive2.Portal, __spreadProps(__spreadValues({}, props), { children }));
};
DrawerPortal.displayName = DialogPrimitive2.Portal.displayName;
var DrawerOverlay = forwardRef18((_a, ref) => {
  var _b = _a, { className, children, overlay } = _b, props = __objRest(_b, ["className", "children", "overlay"]);
  return /* @__PURE__ */ jsx35(
    DialogPrimitive2.Overlay,
    __spreadProps(__spreadValues({
      className: cn(
        "tw-fixed tw-inset-0 tw-z-50 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-duration-300 data-[state=open]:tw-animate-in data-[state=open]:tw-fade-in",
        overlay && "tw-bg-black/25 tw-backdrop-blur-sm",
        className
      )
    }, props), {
      ref,
      children
    })
  );
});
DrawerOverlay.displayName = DialogPrimitive2.Overlay.displayName;
var DrawerBody = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx35(
    "div",
    __spreadValues({
      className: cn(
        "tw-flex tw-flex-1 tw-items-start tw-overflow-y-auto tw-full",
        className
      )
    }, props)
  );
};
DrawerBody.displayName = "DrawerBody";
var sheetVariants = cva8(
  "tw-fixed tw-flex tw-flex-col tw-z-50 tw-scale-100 tw-gap-4 tw-bg-white tw-p-6 tw-opacity-100 tw-shadow-lg tw-border tw-overflow-y-auto data-[state=closed]:tw-animate-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-animate-in data-[state=open]:tw-fade-in data-[state=open]:tw-duration-300",
  {
    variants: {
      position: {
        top: "tw-top-0 tw-inset-x-0 full data-[state=open]:tw-slide-in-from-top data-[state=closed]:tw-slide-out-to-top",
        bottom: "tw-bottom-0 tw-inset-x-0 data-[state=open]:tw-slide-in-from-bottom data-[state=closed]:tw-slide-out-to-bottom",
        left: "tw-left-0 tw-inset-y-0 data-[state=open]:tw-slide-in-from-left data-[state=closed]:tw-slide-out-to-left",
        right: "tw-right-0 tw-inset-y-0 data-[state=open]:tw-slide-in-from-right data-[state=closed]:tw-slide-out-to-right"
      },
      size: {
        content: "",
        sm: "",
        md: "",
        lg: "",
        xl: "",
        full: ""
      }
    },
    compoundVariants: [
      {
        position: ["top", "bottom"],
        size: "content",
        class: "tw-max-h-screen"
      },
      {
        position: ["top", "bottom"],
        size: "md",
        class: "tw-h-1/3"
      },
      {
        position: ["top", "bottom"],
        size: "sm",
        class: "tw-h-1/4"
      },
      {
        position: ["top", "bottom"],
        size: "lg",
        class: "tw-h-1/2"
      },
      {
        position: ["top", "bottom"],
        size: "xl",
        class: "tw-h-5/6"
      },
      {
        position: ["top", "bottom"],
        size: "full",
        class: "tw-h-screen"
      },
      {
        position: ["right", "left"],
        size: "content",
        class: "tw-max-w-screen"
      },
      {
        position: ["right", "left"],
        size: "md",
        class: "tw-w-1/3"
      },
      {
        position: ["right", "left"],
        size: "sm",
        class: "tw-w-1/4"
      },
      {
        position: ["right", "left"],
        size: "lg",
        class: "tw-w-1/2"
      },
      {
        position: ["right", "left"],
        size: "xl",
        class: "tw-w-5/6"
      },
      {
        position: ["right", "left"],
        size: "full",
        class: "tw-w-screen"
      }
    ],
    defaultVariants: {
      position: "right",
      size: "md"
    }
  }
);
var DrawerContent = forwardRef18(
  (_a, ref) => {
    var _b = _a, {
      showCloseButton = true,
      position,
      size,
      overlay = true,
      container,
      className,
      children
    } = _b, props = __objRest(_b, [
      "showCloseButton",
      "position",
      "size",
      "overlay",
      "container",
      "className",
      "children"
    ]);
    return /* @__PURE__ */ jsxs24(DrawerPortal, { container, children: [
      /* @__PURE__ */ jsx35(DrawerOverlay, { overlay }),
      /* @__PURE__ */ jsxs24(
        DialogPrimitive2.Content,
        __spreadProps(__spreadValues({
          ref,
          className: cn(sheetVariants({ position, size }), className)
        }, props), {
          children: [
            children,
            showCloseButton && /* @__PURE__ */ jsxs24(DialogPrimitive2.Close, { className: "tw-cursor-pointer tw-absolute tw-right-4 tw-top-4 tw-p-2 tw-rounded-full tw-leading-none tw-bg-transparent tw-opacity-70 tw-ring-offset-white tw-transition-opacity hover:tw-opacity-100 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none data-[state=open]:tw-bg-light-300 data-[state=open]:text-light-500 hover:tw-bg-light-200", children: [
              /* @__PURE__ */ jsx35(MdClose4, { className: "tw-h-6 tw-w-6" }),
              /* @__PURE__ */ jsx35("span", { className: "tw-sr-only", children: "Close" })
            ] })
          ]
        })
      )
    ] });
  }
);
DrawerContent.displayName = DialogPrimitive2.Content.displayName;
var DrawerHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx35(
    "div",
    __spreadValues({
      className: cn(
        "tw-flex tw-flex-col tw-flex-0 tw-space-y-2 tw-text-left",
        className
      )
    }, props)
  );
};
DrawerHeader.displayName = "DrawerHeader";
var DrawerFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx35(
    "div",
    __spreadValues({
      className: cn(
        "tw-flex tw-flex-0 sm:tw-flex-row tw-border-t tw-border-light-200 tw-flex-col-reverse tw--mx-6 tw-px-6 tw-pt-6 sm:tw-justify-end sm:tw-space-x-2",
        className
      )
    }, props)
  );
};
DrawerFooter.displayName = "DrawerFooter";
var DrawerTitle = forwardRef18((_a, ref) => {
  var _b = _a, { icon, className, children } = _b, props = __objRest(_b, ["icon", "className", "children"]);
  return /* @__PURE__ */ jsxs24(
    DialogPrimitive2.Title,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-flex tw-gap-2 tw-items-center tw-text-lg tw-font-semibold tw-text-black",
        className
      )
    }, props), {
      children: [
        icon && /* @__PURE__ */ jsx35("span", { style: { fontSize: 32 }, children: icon }),
        /* @__PURE__ */ jsx35("span", { children })
      ]
    })
  );
});
DrawerTitle.displayName = DialogPrimitive2.Title.displayName;
var DrawerDescription = forwardRef18((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx35(
    DialogPrimitive2.Description,
    __spreadValues({
      ref,
      className: cn("tw-text-sm tw-text-light-500", className)
    }, props)
  );
});
DrawerDescription.displayName = DialogPrimitive2.Description.displayName;

// src/components/Filter/Filter.tsx
import { useEffect as useEffect8, useMemo as useMemo5, useRef as useRef16, useState as useState9 } from "react";
import { MdClose as MdClose5, MdKeyboardArrowDown as MdKeyboardArrowDown3, MdSearch } from "@teamworksdev/icons";

// src/components/Label/Label.tsx
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva as cva9 } from "class-variance-authority";
import { forwardRef as forwardRef19 } from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var labelVariants2 = cva9(
  "tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70"
);
var Label4 = forwardRef19((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    LabelPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(labelVariants2(), className)
    }, props)
  );
});
Label4.displayName = LabelPrimitive.Root.displayName;

// src/components/TextField/TextField.tsx
import clsx7 from "clsx";
import { cloneElement as cloneElement5, createContext as createContext4, forwardRef as forwardRef20, useContext as useContext4 } from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var TextFieldContext = createContext4(false);
var TextFieldGroup = forwardRef20(
  (_a, ref) => {
    var _b = _a, {
      className,
      children,
      size = "md",
      isInvalid = false,
      disabled = false
    } = _b, props = __objRest(_b, [
      "className",
      "children",
      "size",
      "isInvalid",
      "disabled"
    ]);
    const isInsideTextFieldGroup = true;
    const validChildren = getValidChildren(children);
    const childElements = validChildren.map(
      (child, index) => cloneElement5(child, {
        isFirstChild: index === 0,
        isLastChild: index === validChildren.length - 1,
        className: child.props.className,
        childtype: child.type,
        size,
        isInvalid,
        disabled,
        key: index,
        "aria-invalid": props["aria-invalid"]
      })
    );
    return /* @__PURE__ */ jsx37(TextFieldContext.Provider, { value: isInsideTextFieldGroup, children: /* @__PURE__ */ jsx37(
      "div",
      __spreadProps(__spreadValues({
        "aria-label": "Text Field",
        ref,
        className: cn(
          clsx7(
            "tw-border tw-border-input tw-flex tw-w-full tw-content-center tw-items-center tw-space-x-2 tw-rounded-md tw-bg-transparent file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-text-light-400 tw-border-input data-[disabled]:tw-cursor-not-allowed data-[disabled]:tw-opacity-40 data-[disabled]:tw-bg-light-50",
            {
              "tw-text-sm tw-h-7": size === "sm",
              "tw-text-base tw-h-9": size === "md",
              "tw-text-base tw-h-11": size === "lg",
              "tw-ring-offset-white tw-ring-offset-0 tw-ring-1 tw-border-red-500 tw-ring-red-500": isInvalid,
              "tw-text-black/60 tw-opacity-60": disabled
            }
          ),
          "aria-invalid:tw-focus-error",
          "tw-focus",
          className
        )
      }, props), {
        children: childElements
      })
    ) });
  }
);
TextFieldGroup.displayName = "TextFieldGroup";
var TextField = forwardRef20(
  (_a, ref) => {
    var _b = _a, {
      className,
      size,
      disabled = false,
      isFirstChild,
      isLastChild,
      isInvalid,
      placeholder,
      type
    } = _b, props = __objRest(_b, [
      "className",
      "size",
      "disabled",
      "isFirstChild",
      "isLastChild",
      "isInvalid",
      "placeholder",
      "type"
    ]);
    const isInsideTextFieldGroup = useContext4(TextFieldContext);
    return /* @__PURE__ */ jsx37(
      "input",
      __spreadValues({
        "aria-label": "Text Field Input",
        className: cn(
          clsx7("disabled:tw-bg-transparent disabled:tw-cursor-not-allowed", {
            "tw-flex tw-w-full tw-grow tw-rounded-none tw-bg-transparent data-[disabled]:tw-cursor-not-allowed focus-visible:tw-outline-none tw-border-none tw-ring-transparent tw-ring-0 tw-outline-0 tw-outline-transparent focus-visible:tw-outline-none focus-visible:tw-ring-0 focus-visible:tw-ring-0 focus-visible:tw-ring-offset-0": isInsideTextFieldGroup,
            "tw-flex tw-w-full tw-grow tw-rounded-md tw-bg-transparent tw-py-2 tw-px-4 tw-text-sm tw-border tw-border-input file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-text-light-400 data-[disabled]:tw-cursor-not-allowed data-[disabled]:tw-opacity-50 data-[disabled]:tw-text-black/60": !isInsideTextFieldGroup,
            "tw-text-sm tw-h-7": size === "sm",
            "tw-text-base tw-h-9": size === "md",
            "tw-text-base tw-h-11": size === "lg",
            "tw-pl-4": isInsideTextFieldGroup && isFirstChild && !isLastChild,
            "tw-px-4": isInsideTextFieldGroup && isFirstChild && isLastChild || !isInsideTextFieldGroup,
            "tw-pr-4": isInsideTextFieldGroup && !isFirstChild && isLastChild
          }),
          className
        ),
        disabled,
        placeholder,
        ref,
        type
      }, props)
    );
  }
);
TextField.displayName = "TextField";

// src/components/TextField/TextFieldAddon.tsx
import clsx8 from "clsx";
import { cloneElement as cloneElement6, forwardRef as forwardRef21 } from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var TextFieldAddon = forwardRef21(
  ({ children, className, size }, ref) => {
    const validChildren = getValidChildren(children);
    const childrenStyled = validChildren.map(
      (child, index) => cloneElement6(child, {
        className: clsx8(child.props.className, {
          "tw-h-6 tw-w-auto tw-leading-6": size === "sm",
          "tw-h-6 tw-w-auto": size === "md" || size === "lg"
        }),
        key: index
      })
    );
    return /* @__PURE__ */ jsx38(
      "div",
      {
        className: cn(
          "tw-flex tw-w-auto tw-h-full tw-space-x-2 tw-whitespace-nowrap tw-items-center tw-justify-center tw-align-center tw-bg-light-50 tw-px-4",
          className
        ),
        ref,
        children: childrenStyled
      }
    );
  }
);
TextFieldAddon.displayName = "TextFieldAddon";
var TextFieldAddonLeft = forwardRef21(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx38(
      TextFieldAddon,
      {
        className: cn("tw-rounded-l-md", className),
        ref,
        placement: "left",
        size: props.size,
        children
      }
    );
  }
);
TextFieldAddonLeft.displayName = "TextFieldAddonLeft";
var TextFieldAddonRight = forwardRef21(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx38(
      TextFieldAddon,
      {
        className: cn("tw-rounded-r-md", className),
        ref,
        placement: "right",
        size: props.size,
        children
      }
    );
  }
);
TextFieldAddonRight.displayName = "TextFieldAddonRight";

// src/components/TextField/TextFieldElement.tsx
import clsx9 from "clsx";
import { cloneElement as cloneElement7, forwardRef as forwardRef22 } from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var TextFieldElement = forwardRef22(
  (_a, ref) => {
    var _b = _a, { children, className, disabled = false, placement, size } = _b, props = __objRest(_b, ["children", "className", "disabled", "placement", "size"]);
    const elementPlacement = placement || "right";
    const validChildren = getValidChildren(children);
    const childrenStyled = validChildren.map(
      (child, index) => {
        return cloneElement7(child, {
          className: clsx9(child.props.className, {
            "tw-h-6 tw-w-auto tw-leading-6": elementPlacement === "left",
            "tw-h-7 tw-w-auto": elementPlacement === "right" && (size === "lg" || size === "md") && child.type.displayName === "Button",
            "tw-h-5 tw-w-auto": elementPlacement === "right" && size === "sm"
          }),
          disabled,
          key: index
        });
      }
    );
    return /* @__PURE__ */ jsx39(
      "div",
      {
        className: cn(
          clsx9(
            "tw-flex tw-w-auto tw-h-full tw-space-x-2 tw-whitespace-nowrap tw-items-center tw-justify-center",
            {
              "tw-pl-2": elementPlacement === "left" && props.isFirstChild,
              "tw-pr-2": elementPlacement === "right" && props.isLastChild
            }
          ),
          className
        ),
        ref,
        children: childrenStyled
      }
    );
  }
);
TextFieldElement.displayName = "TextFieldElement";
var TextFieldElementLeft = forwardRef22(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx39(
      TextFieldElement,
      __spreadProps(__spreadValues({
        className,
        ref,
        placement: "left"
      }, props), {
        children
      })
    );
  }
);
TextFieldElementLeft.displayName = "TextFieldElementLeft";
var TextFieldElementRight = forwardRef22(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx39(
      TextFieldElement,
      __spreadProps(__spreadValues({
        className,
        ref,
        placement: "right"
      }, props), {
        children
      })
    );
  }
);
TextFieldElementRight.displayName = "TextFieldElementRight";

// src/components/Filter/Filter.tsx
import { Fragment as Fragment2, jsx as jsx40, jsxs as jsxs25 } from "react/jsx-runtime";
var FilterComponent = ({
  align = "start",
  colorScheme = "default",
  isDisabled = false,
  isLoading = false,
  locale = "en-US",
  options,
  size = "md",
  showCounts = false,
  showFooter = true,
  showLabel = true,
  showSearch = false,
  showSelectAll = false,
  title,
  defaultSelectedIds,
  selectedIds,
  variant = "ghost",
  onChange,
  handleSearch,
  popoverContainer,
  extra
}) => {
  var _a;
  const [searchValue, setSearchValue] = useState9("");
  const [currentSelections, setCurrentSelections] = useState9(
    (_a = options.filter(
      (opt) => {
        var _a2;
        return (_a2 = selectedIds != null ? selectedIds : defaultSelectedIds) == null ? void 0 : _a2.includes(opt.id);
      }
    )) != null ? _a : []
  );
  const prevSelections = useRef16(currentSelections);
  useEffect8(() => {
    var _a2;
    if (selectedIds) {
      setCurrentSelections(
        (_a2 = options.filter((opt) => selectedIds == null ? void 0 : selectedIds.includes(opt.id))) != null ? _a2 : []
      );
    }
  }, [options, selectedIds]);
  useEffect8(() => {
    if (areSelectionsEqual(currentSelections, prevSelections.current))
      return;
    onChange == null ? void 0 : onChange(currentSelections);
    prevSelections.current = currentSelections;
  }, [onChange, currentSelections]);
  const filterTitle = title != null ? title : getTranslation("filter");
  const onCheckedChange = (checked, option) => {
    if (checked) {
      setCurrentSelections((prev) => [...prev, option]);
    } else {
      setCurrentSelections((prev) => prev.filter((s) => s.id !== option.id));
    }
  };
  const filteredOptions = useMemo5(() => {
    if (!searchValue)
      return options;
    if (handleSearch) {
      return handleSearch(searchValue, options);
    }
    return options.filter(
      (option) => getOptionFilterValue(option).toLocaleLowerCase(locale).includes(searchValue.trim().toLocaleLowerCase(locale))
    ).map((option) => {
      return __spreadProps(__spreadValues({}, option), { label: option.label });
    });
  }, [handleSearch, locale, options, searchValue]);
  const countTotal = filteredOptions.reduce((acc, option) => {
    var _a2;
    return acc + ((_a2 = option.count) != null ? _a2 : 0);
  }, 0);
  const showEmptyState = () => {
    if (filteredOptions.length === 0) {
      return /* @__PURE__ */ jsxs25("div", { className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-2 tw-mt-5 tw-text-center tw-text-black/60", children: [
        /* @__PURE__ */ jsx40("div", { className: "tw-text-xl tw-bg-black tw-rounded-full tw-text-white tw-p-2 tw-mb-3", children: /* @__PURE__ */ jsx40(MdSearch, {}) }),
        /* @__PURE__ */ jsx40("div", { className: "tw-text-base tw-font-semibold tw-mb-1 tw-text-black/[.87]", children: getTranslation("noResults") }),
        /* @__PURE__ */ jsx40("div", { className: "tw-text-sm tw-px-2 tw-mb-2", children: getTranslation("checkSearchTerm") }),
        /* @__PURE__ */ jsx40(Button, { variant: "ghost", asChild: true, children: /* @__PURE__ */ jsx40("div", { onClick: () => setSearchValue(""), children: getTranslation("clearSearch") }) })
      ] });
    }
  };
  const allSelected = currentSelections.length === options.length || currentSelections.length === filteredOptions.length;
  return /* @__PURE__ */ jsxs25(Popover, { children: [
    /* @__PURE__ */ jsx40(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs25(
      Button,
      {
        className: "tw-px-2 [&>svg]:data-[state=open]:tw-rotate-180",
        colorScheme,
        isDisabled,
        isLoading,
        rightIcon: /* @__PURE__ */ jsx40(MdKeyboardArrowDown3, {}),
        size,
        variant,
        disableAnimation: true,
        children: [
          filterTitle,
          /* @__PURE__ */ jsx40(
            Badge,
            {
              colorScheme,
              value: currentSelections.length,
              className: "tw-ml-2"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs25(
      PopoverContent,
      {
        className: "tw-p-3",
        align,
        container: popoverContainer,
        children: [
          showSearch && /* @__PURE__ */ jsxs25(TextFieldGroup, { className: "tw-px-4 tw-py-2.5 tw-mb-1", children: [
            /* @__PURE__ */ jsx40(TextFieldElementLeft, { children: /* @__PURE__ */ jsx40(MdSearch, { className: "tw-opacity-40 tw-h-auto", size: 24 }) }),
            /* @__PURE__ */ jsx40(
              TextField,
              {
                placeholder: getTranslation("search"),
                className: "tw-text-xs tw-px-0",
                value: searchValue,
                onChange: (e) => setSearchValue(e.target.value)
              }
            ),
            /* @__PURE__ */ jsx40(TextFieldElementRight, { children: searchValue && /* @__PURE__ */ jsx40(
              IconButton,
              {
                "aria-label": getTranslation("clearSearch"),
                variant: "ghost",
                size: "sm",
                className: "tw-rounded-full",
                icon: /* @__PURE__ */ jsx40(MdClose5, { className: "tw-h-4 tw-w-4" }),
                onClick: () => setSearchValue("")
              }
            ) })
          ] }),
          showSelectAll && filteredOptions.length > 0 && /* @__PURE__ */ jsxs25("div", { className: "tw-flex tw-items-center tw-gap-2 tw-p-2", children: [
            /* @__PURE__ */ jsx40(
              Checkbox,
              {
                className: "tw-cursor-pointer",
                id: "select-all",
                size: "lg",
                checked: allSelected,
                onCheckedChange: (checked) => setCurrentSelections(checked ? filteredOptions : [])
              }
            ),
            /* @__PURE__ */ jsx40(Label4, { className: "tw-flex-1 tw-cursor-pointer", htmlFor: "select-all", children: getTranslation("selectAll") }),
            /* @__PURE__ */ jsx40(
              Badge,
              {
                colorScheme: "count",
                value: showCounts ? countTotal : filteredOptions.length,
                className: "tw-ml-2 tw-text-info-700"
              }
            )
          ] }),
          (showSearch || showSelectAll) && /* @__PURE__ */ jsx40(Divider, {}),
          /* @__PURE__ */ jsxs25(
            Label4,
            {
              className: `tw-block tw-text-black/60 ${showLabel ? "tw-p-2" : "tw-sr-only"}`,
              children: [
                getTranslation("select"),
                " ",
                filterTitle
              ]
            }
          ),
          /* @__PURE__ */ jsx40("div", { className: "tw-block tw-w-full tw-overflow-auto tw-max-h-[300px]", children: filteredOptions.length > 0 ? filteredOptions.map((option) => {
            const label = typeof option.label === "string" ? option.label : option.label(option.value);
            const isChecked = typeof option.value === "string" ? currentSelections.some((s) => s.value === option.value) : currentSelections.some((s) => s.id === option.id);
            return /* @__PURE__ */ jsxs25(
              "div",
              {
                className: "tw-flex tw-items-center tw-justify-between hover:tw-bg-light-200 tw-rounded-md tw-p-2 tw-cursor-pointer",
                onClick: (e) => {
                  e.preventDefault();
                  onCheckedChange(!isChecked, option);
                },
                children: [
                  /* @__PURE__ */ jsxs25("div", { className: "tw-flex tw-grow tw-space-x-2 tw-items-center", children: [
                    /* @__PURE__ */ jsx40(
                      Checkbox,
                      {
                        className: "tw-cursor-pointer",
                        id: `${option.id}`,
                        size: "lg",
                        checked: isChecked,
                        onCheckedChange: (checked) => onCheckedChange(!!checked, option),
                        onClick: (e) => (
                          // Prevent click from triggering parent div onClick
                          e.stopPropagation()
                        )
                      }
                    ),
                    /* @__PURE__ */ jsxs25(
                      Label4,
                      {
                        className: "tw-flex tw-grow tw-items-center tw-cursor-pointer",
                        htmlFor: `${option.id}`,
                        children: [
                          option.icon,
                          label
                        ]
                      }
                    )
                  ] }),
                  showCounts && /* @__PURE__ */ jsx40(
                    Badge,
                    {
                      value: option.count,
                      colorScheme: "count",
                      className: "tw-ml-2 tw-text-info-700"
                    }
                  )
                ]
              },
              option.id
            );
          }) : showEmptyState() }),
          showFooter && currentSelections.length > 0 && /* @__PURE__ */ jsxs25(Fragment2, { children: [
            /* @__PURE__ */ jsx40(Divider, {}),
            /* @__PURE__ */ jsxs25("div", { className: "tw-flex tw-justify-between tw-items-center tw-mt-1", children: [
              /* @__PURE__ */ jsx40(
                Button,
                {
                  variant: "ghost",
                  colorScheme: "info",
                  size: "sm",
                  onClick: () => setCurrentSelections([]),
                  children: getTranslation("clear")
                }
              ),
              currentSelections.length > 0 && /* @__PURE__ */ jsx40("span", { className: "tw-text-black/60 tw-text-xs", children: `${currentSelections.length} of ${options.length}` })
            ] })
          ] }),
          extra
        ]
      }
    )
  ] });
};
FilterComponent.displayName = "Filter";
var Divider = () => /* @__PURE__ */ jsx40("div", { className: "tw-w-full tw-border-t tw-border-light-200 tw-mt-1 tw-mb-1" });
var areSelectionsEqual = (newSelections, prevSelections) => {
  if (newSelections.length !== prevSelections.length)
    return false;
  return newSelections.every(
    (newSelection) => prevSelections.some((prevSelection) => prevSelection.id === newSelection.id)
  );
};
var getOptionFilterValue = (option) => {
  if (option.filterKey) {
    return option.filterKey;
  }
  if (typeof option.value === "string") {
    return option.value;
  }
  return "";
};
var Filter_default = FilterComponent;

// src/components/Form/Form.tsx
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { createContext as createContext5, forwardRef as forwardRef23, useContext as useContext5, useId as useId2 } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { jsx as jsx41 } from "react/jsx-runtime";
var Form = FormProvider;
var FormFieldContext = createContext5(
  {}
);
var FormField = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ jsx41(FormFieldContext.Provider, { value: { name: props.name }, children: /* @__PURE__ */ jsx41(Controller, __spreadValues({}, props)) });
};
var useFormField = () => {
  const fieldContext = useContext5(FormFieldContext);
  const itemContext = useContext5(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }
  const { id } = itemContext;
  return __spreadValues({
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`
  }, fieldState);
};
var FormItemContext = createContext5(
  {}
);
var FormItem = forwardRef23(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    const id = useId2();
    return /* @__PURE__ */ jsx41(FormItemContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx41("div", __spreadValues({ className: cn("tw-space-y-1", className), ref }, props)) });
  }
);
FormItem.displayName = "FormItem";
var FormLabel = forwardRef23((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { error, formItemId } = useFormField();
  return /* @__PURE__ */ jsx41(
    Label4,
    __spreadValues({
      className: cn(
        error ? "tw-text-error-700" : "tw-text-black/60",
        "tw-font-semibold",
        className
      ),
      htmlFor: formItemId,
      ref
    }, props)
  );
});
FormLabel.displayName = "FormLabel";
var FormControl = forwardRef23((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
  return /* @__PURE__ */ jsx41(
    Slot2,
    __spreadValues({
      "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
      "aria-invalid": !!error,
      id: formItemId,
      ref
    }, props)
  );
});
FormControl.displayName = "FormControl";
var FormDescription = forwardRef23((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { formDescriptionId } = useFormField();
  return /* @__PURE__ */ jsx41(
    "p",
    __spreadValues({
      className: cn("tw-text-sm tw-text-light-500", className),
      id: formDescriptionId,
      ref
    }, props)
  );
});
FormDescription.displayName = "FormDescription";
var FormMessage = forwardRef23((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  const { error, formMessageId } = useFormField();
  const body = error ? String(error == null ? void 0 : error.message) : children;
  if (!body) {
    return null;
  }
  return /* @__PURE__ */ jsx41(
    "p",
    __spreadProps(__spreadValues({
      className: cn("tw-text-sm tw-font-medium tw-text-error-700", className),
      id: formMessageId,
      ref
    }, props), {
      children: body
    })
  );
});
FormMessage.displayName = "FormMessage";

// src/components/Heading/Heading.tsx
import { cva as cva10 } from "class-variance-authority";
import { forwardRef as forwardRef24 } from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var headingVariants = cva10("tw-text-black tw-font-semibold tracking-tight", {
  variants: {
    size: {
      display: "md:tw-text-5xl tw-text-4xl",
      h1: "md:tw-text-4xl tw-text-3xl",
      h2: "md:tw-text-2xl tw-text-xl",
      h3: "md:tw-text-xl tw-text-base",
      h4: "md:tw-text-base tw-text-sm"
    },
    noOfLines: {
      1: "tw-line-clamp-1",
      2: "tw-line-clamp-2",
      3: "tw-line-clamp-3",
      4: "tw-line-clamp-4",
      5: "tw-line-clamp-5",
      6: "tw-line-clamp-6",
      7: "tw-line-clamp-7",
      8: "tw-line-clamp-8",
      9: "tw-line-clamp-9",
      10: "tw-line-clamp-10"
    }
  },
  defaultVariants: {
    size: "h2"
  }
});
var Heading = forwardRef24(
  (_a, ref) => {
    var _b = _a, { as = "h2", className, noOfLines, size, children } = _b, props = __objRest(_b, ["as", "className", "noOfLines", "size", "children"]);
    const Component = as;
    return /* @__PURE__ */ jsx42(
      Component,
      __spreadProps(__spreadValues({
        className: cn(
          headingVariants({
            size,
            noOfLines,
            className
          })
        ),
        ref
      }, props), {
        children
      })
    );
  }
);
Heading.displayName = "Heading";

// src/components/HorizontalNav/HorizontalNav.tsx
import { clsx as clsx10 } from "clsx";
import { forwardRef as forwardRef25 } from "react";
import { NavLink } from "react-router-dom";

// src/components/HorizontalNav/useHorizontalNav.tsx
import { useContext as useContext6 } from "react";
import { createContext as createContext6 } from "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var HorizontalNavContext = createContext6(false);
var HorizontalNavProvider = ({
  children,
  useReactRouter = false
}) => {
  return /* @__PURE__ */ jsx43(HorizontalNavContext.Provider, { value: useReactRouter, children });
};
var useHorizontalNav = () => {
  const useReactRouter = useContext6(HorizontalNavContext);
  return useReactRouter;
};

// src/components/HorizontalNav/HorizontalNav.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var HorizontalNav = forwardRef25((_a, ref) => {
  var _b = _a, { className, children, useReactRouter = true } = _b, props = __objRest(_b, ["className", "children", "useReactRouter"]);
  const validChildren = getValidChildren(children);
  return /* @__PURE__ */ jsx44("nav", __spreadProps(__spreadValues({ ref, className: cn("tw-reset tw-w-full", className) }, props), { children: /* @__PURE__ */ jsx44("ul", { className: "tw-flex tw-items-center tw-border-b tw-border-light-300 tw-list-none", children: /* @__PURE__ */ jsx44(HorizontalNavProvider, { useReactRouter, children: validChildren }) }) }));
});
HorizontalNav.displayName = "HorizontalNav";
var HorizontalNavItem = forwardRef25(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ jsx44("li", __spreadProps(__spreadValues({ ref, className }, props), { children }));
  }
);
HorizontalNavItem.displayName = "HorizontalNavItem";
var HorizontalNavLink = forwardRef25((_a, ref) => {
  var _b = _a, { active, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  const useReactRouter = useHorizontalNav();
  return !useReactRouter ? /* @__PURE__ */ jsx44(
    "a",
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      href: props.to,
      className: cn(
        clsx10(
          "tw-block tw-px-2 tw-py-4 tw-border-b-2 tw-text-black/60 tw-border-transparent hover:tw-text-black tw-transition-colors tw-rounded-none",
          {
            "tw-text-black tw-border-black hover:tw-text-black/90 tw-font-semibold": !!active
          }
        ),
        className
      )
    }, props), {
      children
    })
  ) : /* @__PURE__ */ jsx44(
    NavLink,
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      className: ({ isActive }) => cn(
        clsx10(
          "tw-block tw-px-2 tw-py-4 tw-border-b-2 tw-text-black/60 tw-border-transparent hover:tw-text-black tw-transition-colors tw-rounded-none",
          {
            "tw-text-black tw-border-black hover:tw-text-black/90 tw-font-semibold": active != null ? active : isActive
          }
        ),
        className
      )
    }, props), {
      children
    })
  );
});
HorizontalNavLink.displayName = "HorizontalNavLink";

// src/components/Input/Input.tsx
import { forwardRef as forwardRef26 } from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
var Input = forwardRef26(
  (_a, ref) => {
    var _b = _a, { className, type } = _b, props = __objRest(_b, ["className", "type"]);
    return /* @__PURE__ */ jsx45(
      "input",
      __spreadValues({
        type,
        className: cn(
          "tw-flex tw-h-10 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-text-light-400 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
          "aria-invalid:tw-focus-error",
          "tw-focus",
          className
        ),
        ref
      }, props)
    );
  }
);
Input.displayName = "Input";

// src/components/Menu/Menu.tsx
import { createContext as createContext7, forwardRef as forwardRef27, useContext as useContext7 } from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var MenuTypeContext = createContext7("dropdown");
var MenuTypeProvider = MenuTypeContext.Provider;
var Menu = (_a) => {
  var _b = _a, {
    type = "dropdown"
  } = _b, props = __objRest(_b, [
    "type"
  ]);
  const MenuComponent = type === "context" ? ContextMenu : DropdownMenu;
  return /* @__PURE__ */ jsx46(MenuTypeProvider, { value: type, children: /* @__PURE__ */ jsx46(MenuComponent, __spreadValues({}, props)) });
};
Menu.displayName = "Menu";
var useMenuType = () => {
  const type = useContext7(MenuTypeContext);
  return type;
};
var MenuTrigger = forwardRef27((props, ref) => {
  const menuType = useMenuType();
  if (menuType === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuTrigger, __spreadValues({ ref }, props));
  }
  return /* @__PURE__ */ jsx46(
    DropdownMenuTrigger,
    __spreadValues({
      ref
    }, props)
  );
});
MenuTrigger.displayName = "MenuTrigger";
var MenuSubTrigger = forwardRef27((props, ref) => {
  const menuType = useMenuType();
  if (menuType === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuSubTrigger, __spreadValues({ ref }, props));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuSubTrigger, __spreadValues({ ref }, props));
});
MenuSubTrigger.displayName = "MenuSubTrigger";
var MenuContent = forwardRef27((props, ref) => {
  const menuType = useMenuType();
  if (menuType === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuContent, __spreadValues({ ref }, props));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuContent, __spreadValues({ ref }, props));
});
MenuContent.displayName = "MenuContent";
var MenuCheckboxItem = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuCheckboxItem, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuCheckboxItem, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuCheckboxItem.displayName = "MenuCheckboxItem";
var MenuGroup = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuGroup, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuGroup, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuGroup.displayName = "MenuGroup";
var MenuIcon = forwardRef27((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx46(DropdownMenuIcon, __spreadValues({ ref }, props));
});
MenuIcon.displayName = "MenuIcon";
var MenuItem = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuItem, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuItem, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuItem.displayName = "MenuItem";
var MenuLabel = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuLabel, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuLabel, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuLabel.displayName = "MenuLabel";
var MenuRadioGroup = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuRadioGroup, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuRadioGroup, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuRadioGroup.displayName = "MenuRadioGroup";
var MenuRadioItem = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuRadioItem, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuRadioItem, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuRadioItem.displayName = "MenuRadioItem";
var MenuSeparator = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuSeparator, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuSeparator, __spreadValues({}, props));
});
MenuSeparator.displayName = "MenuSeparator";
var MenuShortcut = (props) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuShortcut, __spreadValues({}, props));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuShortcut, __spreadValues({}, props));
};
var MenuSub = (props) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuSub, __spreadValues({}, props));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuSub, __spreadValues({}, props));
};
var MenuSubContent = forwardRef27((props, ref) => {
  const type = useMenuType();
  if (type === "context") {
    return /* @__PURE__ */ jsx46(ContextMenuSubContent, __spreadProps(__spreadValues({}, props), { ref }));
  }
  return /* @__PURE__ */ jsx46(DropdownMenuSubContent, __spreadProps(__spreadValues({}, props), { ref }));
});
MenuSubContent.displayName = "MenuSubContent";

// src/components/MultiSelect/MultiSelect.tsx
import { cva as cva12 } from "class-variance-authority";
import { forwardRef as forwardRef29, useId as useId3, useState as useState10 } from "react";

// ../../node_modules/react-icons/lib/esm/iconBase.js
import React3 from "react";

// ../../node_modules/react-icons/lib/esm/iconContext.js
import React2 from "react";
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React2.createContext && React2.createContext(DefaultContext);

// ../../node_modules/react-icons/lib/esm/iconBase.js
var __assign = function() {
  __assign = Object.assign || function(t2) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p2 = Object.getOwnPropertySymbols(s); i < p2.length; i++) {
      if (e.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i]))
        t2[p2[i]] = s[p2[i]];
    }
  return t2;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return React3.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React3.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React3.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React3.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React3.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// ../../node_modules/react-icons/rx/index.esm.js
function RxCheck(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 15 15", "fill": "none" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z", "fill": "currentColor" } }] })(props);
}
function RxMagnifyingGlass(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 15 15", "fill": "none" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z", "fill": "currentColor" } }] })(props);
}

// src/components/Tag/Tag.tsx
import { cva as cva11 } from "class-variance-authority";
import { cloneElement as cloneElement8, forwardRef as forwardRef28 } from "react";
import { MdClose as MdClose6 } from "@teamworksdev/icons";
import { jsx as jsx47, jsxs as jsxs26 } from "react/jsx-runtime";
var tagVariants = cva11(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-font-semibold tw-rounded tw-border tw-border-light-200 tw-bg-light-50",
  {
    variants: {
      size: {
        sm: "tw-px-1 tw-py-0.5 tw-text-[11px]",
        md: "tw-px-1.5 tw-py-1 tw-text-xs",
        lg: "tw-px-1.5 tw-py-1 tw-text-sm"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
var tagIconVariants = cva11("", {
  variants: {
    size: {
      sm: "tw-h-3 tw-w-3",
      md: "tw-h-3 tw-w-3",
      lg: "tw-h-4 tw-w-4"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var tagCountVariants = cva11(
  "tw-flex tw-items-center tw-justify-center tw-text-center tw-bg-white tw-rounded-sm",
  {
    variants: {
      size: {
        sm: "tw-h-3 tw-p-0.5",
        md: "tw-h-3 tw-p-1",
        lg: "tw-h-4 tw-p-1"
      }
    }
  }
);
var Tag = forwardRef28(
  ({ count: count2, children, className, leftIcon, rightIcon, size, onClose }, ref) => {
    var _a, _b;
    return /* @__PURE__ */ jsxs26(
      "span",
      {
        className: cn(
          tagVariants({
            size
          }),
          className
        ),
        ref,
        children: [
          leftIcon && cloneElement8(leftIcon, {
            className: !((_a = leftIcon.props) == null ? void 0 : _a.size) ? cn(
              tagIconVariants({ size }),
              "tw-mr-1",
              leftIcon.props.className
            ) : cn("tw-mr-1", leftIcon.props.className)
          }),
          count2 && /* @__PURE__ */ jsx47(TagCount, { count: count2, size }),
          children,
          rightIcon && cloneElement8(rightIcon, {
            className: !((_b = rightIcon.props) == null ? void 0 : _b.size) ? cn(
              tagIconVariants({ size }),
              "tw-ml-1",
              rightIcon.props.className
            ) : cn("tw-ml-1", rightIcon.props.className)
          }),
          typeof onClose === "function" && /* @__PURE__ */ jsx47(
            MdClose6,
            {
              className: cn(
                tagIconVariants({ size }),
                "tw-ml-1 tw-cursor-pointer"
              ),
              onClick: onClose
            }
          )
        ]
      }
    );
  }
);
Tag.displayName = "Tag";
var TagCloseButton = forwardRef28((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx47(
    "button",
    __spreadProps(__spreadValues({
      className: cn(
        "tw-flex tw-bg-transparent tw-ml-1 tw-ring-offset-background tw-rounded-full tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx47(MdClose6, { className: "tw-h-3 tw-w-3 tw-text-black/60 hover:text-black" })
    })
  );
});
TagCloseButton.displayName = "TagCloseButton";
var TagCount = ({
  count: count2,
  size
}) => {
  return /* @__PURE__ */ jsx47("span", { className: cn(tagCountVariants({ size }), "tw-mr-1"), children: count2 });
};

// src/components/MultiSelect/MultiSelect.tsx
import { jsx as jsx48, jsxs as jsxs27 } from "react/jsx-runtime";
var base3 = [
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap",
  // layout
  "tw-font-semibold tw-transition-all tw-cursor-pointer tw-rounded-md",
  // appearance
  "disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
  // disabled
].join(" ");
var sizeVariants = cva12(base3, {
  variants: {
    size: {
      sm: "tw-h-7 tw-rounded-md tw-text-xs",
      md: "tw-h-9 tw-text-sm",
      lg: "tw-h-11 tw-rounded-md tw-text-base"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var MultiSelect = forwardRef29(
  (_a, ref) => {
    var _b = _a, {
      className,
      size,
      value,
      options,
      isReadOnly,
      placeholder,
      onChange,
      container
    } = _b, props = __objRest(_b, [
      "className",
      "size",
      "value",
      "options",
      "isReadOnly",
      "placeholder",
      "onChange",
      "container"
    ]);
    const [open, setOpen] = useState10(false);
    const id = useId3();
    const handleUnselect = (item) => {
      onChange(value.filter((i) => i !== item));
    };
    const hasSelections = value.length > 0;
    return /* @__PURE__ */ jsxs27(Popover, { open, onOpenChange: setOpen, children: [
      /* @__PURE__ */ jsx48(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs27(
        "div",
        {
          "aria-controls": id,
          "aria-expanded": open,
          "aria-invalid": props["aria-invalid"],
          role: "combobox",
          tabIndex: 0,
          className: cn(
            sizeVariants({ size }),
            multiSelectTriggerVariants({ size, hasSelections }),
            "tw-border px-2",
            "tw-focus",
            "aria-invalid:tw-focus-error focus-visible:aria-invalid:tw-focus-error focus-visible:tw-focus focus-visible:tw-outline-none tw-transition-none",
            className
          ),
          onClick: () => setOpen((prevState) => !prevState),
          onKeyDown: (e) => {
            console.log(e.code);
            if (e.code === "Space") {
              setOpen((prevState) => !prevState);
              e.preventDefault();
              e.stopPropagation();
            }
          },
          children: [
            hasSelections ? /* @__PURE__ */ jsx48("div", { className: "tw-flex tw-gap-2 tw-flex-wrap", children: value.map((item) => {
              var _a2;
              return /* @__PURE__ */ jsxs27(Tag, { onClick: () => handleUnselect(item), children: [
                /* @__PURE__ */ jsx48("span", { className: "tw-font-medium", children: (_a2 = options.find((option) => option.value === item)) == null ? void 0 : _a2.label }),
                /* @__PURE__ */ jsx48(
                  TagCloseButton,
                  {
                    onKeyDown: (e) => {
                      if (e.key === "Enter") {
                        handleUnselect(item);
                      }
                    },
                    onMouseDown: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    },
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleUnselect(item);
                    }
                  }
                )
              ] }, item);
            }) }) : /* @__PURE__ */ jsx48("span", { className: "tw-text-light-500 tw-text-sm", children: placeholder != null ? placeholder : getTranslation("select") }),
            /* @__PURE__ */ jsx48(RxMagnifyingGlass, { className: "tw-h-4 tw-w-4 tw-shrink-0 tw-opacity-50" })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx48(
        PopoverContent,
        {
          container,
          className: "tw-min-w-[200px] tw-w-[--radix-popover-trigger-width] tw-p-0",
          children: /* @__PURE__ */ jsxs27(Command, { id, children: [
            /* @__PURE__ */ jsx48(
              CommandInput,
              {
                placeholder: getTranslation("search"),
                className: "h-9"
              }
            ),
            /* @__PURE__ */ jsx48(CommandEmpty, { children: getTranslation("noResults") }),
            /* @__PURE__ */ jsx48(CommandGroup, { className: "tw-max-h-64 tw-overflow-auto", children: options.map((option) => /* @__PURE__ */ jsxs27(
              CommandItem,
              {
                className: "tw-cursor-pointer tw-gap-2",
                onSelect: () => {
                  onChange(
                    value.includes(option.value) ? value.filter((item) => item !== option.value) : [...value, option.value]
                  );
                  setOpen(true);
                },
                children: [
                  /* @__PURE__ */ jsx48(
                    RxCheck,
                    {
                      className: cn(
                        "tw-h-4 tw-w-4",
                        value.includes(option.value) ? "tw-opacity-100" : "tw-opacity-0"
                      )
                    }
                  ),
                  option.label
                ]
              },
              option.value
            )) })
          ] })
        }
      )
    ] });
  }
);
MultiSelect.displayName = "MultiSelect";
var multiSelectTriggerVariants = cva12(
  "tw-w-full tw-justify-between tw-font-normal",
  {
    variants: {
      size: {
        lg: "tw-text-base",
        md: "tw-text-base",
        sm: "tw-text-sm"
      },
      hasSelections: {
        true: "tw-h-full",
        false: ""
      }
    },
    compoundVariants: [
      {
        size: "lg",
        hasSelections: true,
        class: "tw-py-3 tw-px-4"
      },
      {
        size: "lg",
        hasSelections: false,
        class: "tw-h-12"
      },
      {
        size: "md",
        hasSelections: true,
        class: "tw-py-2 tw-px-3"
      },
      {
        size: "md",
        hasSelections: false,
        class: "tw-h-10"
      },
      {
        size: "sm",
        hasSelections: true,
        class: "tw-py-1 tw-px-2"
      },
      {
        size: "sm",
        hasSelections: false,
        class: "tw-h-8"
      }
    ],
    defaultVariants: {
      size: "md",
      hasSelections: false
    }
  }
);

// src/components/NavProvider/NavProvider.tsx
import {
  createContext as createContext8,
  useCallback as useCallback3,
  useContext as useContext8,
  useEffect as useEffect9,
  useState as useState11
} from "react";

// src/utils/styles.ts
var getColorGradientCSS = (colors2) => {
  var _a;
  const gradient = `url("data:image/svg+xml,${encodeURIComponent(
    getBackgroundSvg(colors2.bottom)
  )}")`;
  const background = `${gradient} ${(_a = colors2.top) != null ? _a : "#000000"} no-repeat bottom left/470px 329px`;
  return {
    background
  };
};
var getBackgroundSvg = (fill) => `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 470 329"><g filter="url(#a)"><ellipse cx="88.1083" cy="332.133" fill="${fill}" rx="200.953" ry="119.038" transform="rotate(25 88.1083 332.133)"/></g><g filter="url(#b)"><path fill="${fill}" d="M230.6 121.045-22.7215 243.377l.0001 11.156L230.6 121.045Z"/></g><g filter="url(#c)"><ellipse cx="16.9442" cy="328.846" fill="${fill}" rx="87.7375" ry="85.4141" transform="rotate(25 16.9442 328.846)"/></g><defs><filter id="a" width="764.946" height="663.671" x="-294.365" y=".297455" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="96.9609"/></filter><filter id="b" width="328.554" height="208.72" x="-60.3376" y="83.4292" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="18.8081"/></filter><filter id="c" width="347.561" height="344.63" x="-156.836" y="156.531" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="43.2235"/></filter></defs></svg>`;

// src/components/NavProvider/NavProvider.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var defaultNavState = {
  navState: { expanded: true },
  updateNavState: () => {
  }
};
var SharedNavContext = createContext8(defaultNavState);
var useSharedNav = () => useContext8(SharedNavContext);
function NavProvider(props) {
  const { children, colors: colors2, defaultOpen, onNavStateChanged } = props;
  const [navState, setNavState] = useState11({
    expanded: defaultOpen != null ? defaultOpen : defaultNavState.navState.expanded
  });
  useEffect9(() => {
    onNavStateChanged == null ? void 0 : onNavStateChanged(navState);
  }, [onNavStateChanged, navState]);
  const updateNavState = useCallback3((toUpdate) => {
    setNavState((prevState) => {
      const nextState = __spreadValues(__spreadValues({}, prevState), toUpdate);
      return nextState;
    });
  }, []);
  return /* @__PURE__ */ jsx49(SharedNavContext.Provider, { value: { colors: colors2, navState, updateNavState }, children: /* @__PURE__ */ jsx49(
    "div",
    {
      id: "tw-shared-nav-provider",
      className: "tw-flex tw-h-screen",
      style: getColorGradientCSS(colors2),
      children
    }
  ) });
}
var NavProvider_default = NavProvider;

// src/components/PhoneInput/PhoneInput.tsx
import { forwardRef as forwardRef30 } from "react";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput
} from "react-international-phone";
import { jsx as jsx50, jsxs as jsxs28 } from "react/jsx-runtime";
var PhoneInput = forwardRef30(
  (_a, ref) => {
    var _b = _a, {
      className,
      value,
      onChange,
      isInvalid,
      placeholder = "+1 (555) 555 5555",
      size = "md"
    } = _b, props = __objRest(_b, [
      "className",
      "value",
      "onChange",
      "isInvalid",
      "placeholder",
      "size"
    ]);
    const phoneInput = usePhoneInput({
      defaultCountry: "us",
      value: value == null ? void 0 : value.toString(),
      onChange: (data) => {
        onChange(data);
      }
    });
    return /* @__PURE__ */ jsxs28(
      TextFieldGroup,
      __spreadProps(__spreadValues({}, props), {
        size,
        ref,
        className,
        isInvalid,
        children: [
          /* @__PURE__ */ jsxs28(
            Select,
            {
              value: phoneInput.country.iso2,
              onValueChange: (country) => phoneInput.setCountry(country),
              children: [
                /* @__PURE__ */ jsx50(SelectTrigger, { className: "tw-box-content aria-invalid:tw-ml-[-1px] tw-w-20 tw-h-full tw-rounded-r-none tw-bg-light-50 tw-border-0 tw-py-0", children: /* @__PURE__ */ jsx50(SelectValue, { children: /* @__PURE__ */ jsx50("span", { children: /* @__PURE__ */ jsx50(
                  FlagImage,
                  {
                    className: "tw-flex tw-w-5",
                    iso2: phoneInput.country.iso2
                  }
                ) }) }) }),
                /* @__PURE__ */ jsx50(SelectContent, { children: /* @__PURE__ */ jsx50(SelectGroup, { className: "tw-h-[300px] tw-p-3", children: defaultCountries.map((c) => {
                  const country = parseCountry(c);
                  return /* @__PURE__ */ jsx50(
                    SelectItem,
                    {
                      value: country.iso2,
                      className: "tw-py-3",
                      children: /* @__PURE__ */ jsxs28("div", { className: "tw-flex tw-flex-row tw-gap-2", children: [
                        /* @__PURE__ */ jsx50(
                          FlagImage,
                          {
                            iso2: country.iso2,
                            className: "tw-flex tw-w-5"
                          }
                        ),
                        /* @__PURE__ */ jsx50("span", { children: `${country.name} (+${country.dialCode})` })
                      ] })
                    },
                    country.iso2
                  );
                }) }) })
              ]
            }
          ),
          /* @__PURE__ */ jsx50(
            TextField,
            {
              type: "tel",
              ref: phoneInput.inputRef,
              value: phoneInput.inputValue,
              onChange: phoneInput.handlePhoneValueChange,
              placeholder
            }
          )
        ]
      })
    );
  }
);
PhoneInput.displayName = "PhoneInput";

// src/components/Pill/Pill.tsx
import { cva as cva13 } from "class-variance-authority";
import { cloneElement as cloneElement9, forwardRef as forwardRef31 } from "react";
import { jsxs as jsxs29 } from "react/jsx-runtime";
var pillVariants = cva13(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-font-semibold tw-rounded-full",
  {
    variants: {
      size: {
        sm: "tw-px-1.5 tw-py-0.5 tw-text-[11px]",
        md: "tw-px-2 tw-py-1 tw-text-xs",
        lg: "tw-px-2 tw-py-1 tw-text-sm"
      },
      type: {
        default: "tw-text-black tw-bg-light-200",
        success: "tw-text-success-700 tw-bg-success-25",
        warning: "tw-text-warning-700 tw-bg-warning-25",
        error: "tw-text-error-700 tw-bg-error-25",
        info: "tw-text-info-700 tw-bg-info-25"
      }
    },
    defaultVariants: {
      size: "md",
      type: "default"
    }
  }
);
var pillIconVariants = cva13("", {
  variants: {
    size: {
      sm: "tw-h-3 tw-w-3",
      md: "tw-h-3 tw-w-3",
      lg: "tw-h-4 tw-w-4"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var Pill = forwardRef31(
  (_a, ref) => {
    var _b = _a, { children, className, leftIcon, rightIcon, size, type } = _b, props = __objRest(_b, ["children", "className", "leftIcon", "rightIcon", "size", "type"]);
    var _a2, _b2;
    return /* @__PURE__ */ jsxs29(
      "span",
      __spreadProps(__spreadValues({
        className: cn(
          pillVariants({
            size,
            type
          }),
          className
        ),
        ref
      }, props), {
        children: [
          leftIcon && cloneElement9(leftIcon, {
            className: !((_a2 = leftIcon.props) == null ? void 0 : _a2.size) ? cn(
              pillIconVariants({ size }),
              "tw-mr-1",
              leftIcon.props.className
            ) : cn("tw-mr-1", leftIcon.props.className)
          }),
          children,
          rightIcon && cloneElement9(rightIcon, {
            className: !((_b2 = rightIcon.props) == null ? void 0 : _b2.size) ? cn(
              pillIconVariants({ size }),
              "tw-ml-1",
              rightIcon.props.className
            ) : cn("tw-ml-1", rightIcon.props.className)
          })
        ]
      })
    );
  }
);
Pill.displayName = "Pill";

// node_modules/react-error-boundary/dist/react-error-boundary.module.js
import { isValidElement as $hgUW1$isValidElement, createElement as $hgUW1$createElement, Component as $hgUW1$Component, createContext as $hgUW1$createContext, useContext as $hgUW1$useContext, useState as $hgUW1$useState, useMemo as $hgUW1$useMemo, forwardRef as $hgUW1$forwardRef } from "react";
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, { get: v, set: s, enumerable: true, configurable: true });
}
var $44d7e150ebc754d2$exports = {};
$parcel$export($44d7e150ebc754d2$exports, "ErrorBoundary", () => $44d7e150ebc754d2$export$e926676385687eaf);
var $ebb31c7feaa4405e$exports = {};
$parcel$export($ebb31c7feaa4405e$exports, "ErrorBoundaryContext", () => $ebb31c7feaa4405e$export$b16d9fb1a22de840);
var $ebb31c7feaa4405e$export$b16d9fb1a22de840 = (0, $hgUW1$createContext)(null);
var $44d7e150ebc754d2$var$initialState = {
  didCatch: false,
  error: null
};
var $44d7e150ebc754d2$export$e926676385687eaf = class extends (0, $hgUW1$Component) {
  constructor() {
    super(...arguments);
    __publicField(this, "state", $44d7e150ebc754d2$var$initialState);
    __publicField(this, "resetErrorBoundary", (...args) => {
      var _a, _b;
      const { error } = this.state;
      if (error !== null) {
        (_b = (_a = this.props).onReset) == null ? void 0 : _b.call(_a, {
          args,
          reason: "imperative-api"
        });
        this.setState($44d7e150ebc754d2$var$initialState);
      }
    });
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  componentDidCatch(error, info) {
    var _a, _b;
    (_b = (_a = this.props).onError) == null ? void 0 : _b.call(_a, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    var _a, _b;
    const { didCatch } = this.state;
    const { resetKeys } = this.props;
    if (didCatch && prevState.error !== null && $44d7e150ebc754d2$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      (_b = (_a = this.props).onReset) == null ? void 0 : _b.call(_a, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState($44d7e150ebc754d2$var$initialState);
    }
  }
  render() {
    const { children, fallbackRender, FallbackComponent, fallback } = this.props;
    const { didCatch, error } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if ((0, $hgUW1$isValidElement)(fallback))
        childToRender = fallback;
      else if (typeof fallbackRender === "function")
        childToRender = fallbackRender(props);
      else if (FallbackComponent)
        childToRender = (0, $hgUW1$createElement)(FallbackComponent, props);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return (0, $hgUW1$createElement)((0, $ebb31c7feaa4405e$export$b16d9fb1a22de840).Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
};
function $44d7e150ebc754d2$var$hasArrayChanged(a2 = [], b = []) {
  return a2.length !== b.length || a2.some((item, index) => !Object.is(item, b[index]));
}
var $7c3c25b3f398a9d6$exports = {};
$parcel$export($7c3c25b3f398a9d6$exports, "useErrorBoundary", () => $7c3c25b3f398a9d6$export$c052f6604b7d51fe);
function $75c9d331f9c1ed1a$export$f20aa86254872370(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function")
    throw new Error("ErrorBoundaryContext not found");
  return true;
}
function $7c3c25b3f398a9d6$export$c052f6604b7d51fe() {
  const context = (0, $hgUW1$useContext)((0, $ebb31c7feaa4405e$export$b16d9fb1a22de840));
  (0, $75c9d331f9c1ed1a$export$f20aa86254872370)(context);
  const [state, setState] = (0, $hgUW1$useState)({
    error: null,
    hasError: false
  });
  const memoized = (0, $hgUW1$useMemo)(() => ({
    resetBoundary: () => {
      context == null ? void 0 : context.resetErrorBoundary();
      setState({
        error: null,
        hasError: false
      });
    },
    showBoundary: (error) => setState({
      error,
      hasError: true
    })
  }), [
    context == null ? void 0 : context.resetErrorBoundary
  ]);
  if (state.hasError)
    throw state.error;
  return memoized;
}
var $62ff477d53f02a5b$exports = {};
$parcel$export($62ff477d53f02a5b$exports, "withErrorBoundary", () => $62ff477d53f02a5b$export$f0c7a449e0cfaec7);
function $62ff477d53f02a5b$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
  const Wrapped = (0, $hgUW1$forwardRef)((props, ref) => (0, $hgUW1$createElement)((0, $44d7e150ebc754d2$export$e926676385687eaf), errorBoundaryProps, (0, $hgUW1$createElement)(component, __spreadProps(__spreadValues({}, props), {
    ref
  }))));
  const name = component.displayName || component.name || "Unknown";
  Wrapped.displayName = `withErrorBoundary(${name})`;
  return Wrapped;
}

// src/components/PrimaryNav/index.tsx
import { useLocation } from "react-router-dom";

// src/utils/errorHandler.ts
var codeStyle = "color:#82AAFF; font-weight: bold";
function handleReactRouterError(e) {
  console.warn(
    "It appears you called this component outside the context of %creact-router%c. To suppress this message and ensure proper functionality, call this component with %cuseReactRouter={false}",
    codeStyle,
    "",
    codeStyle
  );
}
function handleError(e) {
  if (e.message.includes("context of a <Router> component")) {
    return handleReactRouterError(e);
  }
}

// src/components/PrimaryNav/components/FriendlyError.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
function FriendlyError() {
  return /* @__PURE__ */ jsx51("div", { className: "tw-flex tw-h-screen tw-bg-gray-700 tw-items-center tw-justify-center tw-text-center tw-px-4", children: /* @__PURE__ */ jsx51("div", { className: "tw-text-red-400", children: getTranslation("requestError") }) });
}

// src/components/PrimaryNav/PrimaryNav.tsx
import { clsx as clsx16 } from "clsx";
import { useCallback as useCallback4, useEffect as useEffect10, useMemo as useMemo9, useRef as useRef20, useState as useState14 } from "react";
import { CloseMenuIcon, DefaultIcon, OpenMenuIcon } from "@teamworksdev/icons";

// src/components/PrimaryNav/components/AbstractLink.tsx
import { Link as Link2 } from "react-router-dom";
import { jsx as jsx52 } from "react/jsx-runtime";
function AbstractLink(_a) {
  var _b = _a, {
    children,
    linkId,
    to,
    useReactRouter = true
  } = _b, linkProps = __objRest(_b, [
    "children",
    "linkId",
    "to",
    "useReactRouter"
  ]);
  if (useReactRouter) {
    return /* @__PURE__ */ jsx52(Link2, __spreadProps(__spreadValues({ to }, linkProps), { "data-testid": `react-router-link::${linkId}`, children }));
  }
  return /* @__PURE__ */ jsx52("a", __spreadProps(__spreadValues({ href: to }, linkProps), { "data-testid": `plain-link::${linkId}`, children }));
}

// src/components/PrimaryNav/components/AppSwitcher.tsx
import * as Popover2 from "@radix-ui/react-popover";
import { clsx as clsx11 } from "clsx";
import { useMemo as useMemo6 } from "react";
import { AppSwitcherIcon, CheckIcon as CheckIcon7 } from "@teamworksdev/icons";

// src/components/PrimaryNav/components/MenuItem.tsx
import { jsx as jsx53, jsxs as jsxs30 } from "react/jsx-runtime";
var MenuItem2 = ({
  children,
  isExpanded,
  tooltip,
  onClick
}) => {
  return isExpanded || !tooltip ? /* @__PURE__ */ jsx53("div", { onClick, children }) : /* @__PURE__ */ jsxs30(Tooltip, { delayDuration: 0, children: [
    /* @__PURE__ */ jsx53(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx53("div", { onClick, children }) }),
    /* @__PURE__ */ jsx53(TooltipPortal, { children: /* @__PURE__ */ jsxs30(TooltipContent, { className: "tw-bg-dark-700", side: "right", children: [
      /* @__PURE__ */ jsx53(TooltipArrow, { className: "tw-fill-dark-700" }),
      /* @__PURE__ */ jsx53("span", { children: tooltip })
    ] }) })
  ] });
};
var MenuItem_default = MenuItem2;

// src/components/PrimaryNav/components/AppSwitcher.tsx
import { jsx as jsx54, jsxs as jsxs31 } from "react/jsx-runtime";
var APP_ORDER = [
  "hub" /* hub */,
  "camps" /* camps */,
  "inventory" /* inventory */,
  "arms" /* arms */,
  "inflcr" /* inflcr */,
  "collectives" /* collectives */,
  "ams" /* ams */,
  "nutrition" /* nutrition */,
  "strength" /* strength */,
  "academics" /* academics */,
  "pathways" /* pathways */,
  "pulse" /* pulse */
];
var AppSwitcher = ({
  app,
  apps,
  isAnimatedOut,
  isExpanded,
  onAppChange
}) => {
  const availableAppsOrdered = useMemo6(() => {
    return APP_ORDER.reduce((acc, key) => {
      if (apps && key in apps) {
        const app2 = {
          slug: key,
          name: appMetadata[key].name,
          icon: appMetadata[key].icon,
          url: apps[key]
        };
        return acc.concat(app2);
      }
      return acc;
    }, []);
  }, [apps]);
  if (availableAppsOrdered.length <= 1)
    return null;
  return /* @__PURE__ */ jsx54(MenuItem_default, { tooltip: "Teamworks Apps", isExpanded, children: /* @__PURE__ */ jsxs31(Popover2.Root, { children: [
    /* @__PURE__ */ jsx54(Popover2.Trigger, { asChild: true, children: /* @__PURE__ */ jsxs31(
      "button",
      {
        "data-testid": "app-switcher",
        className: clsx11(
          "apps-popover-trigger",
          "tw-group tw-flex tw-justify-start tw-items-center",
          "tw-rounded-md tw-p-2 tw-text-lg tw-font-medium",
          "tw-text-white hover:tw-bg-white/[0.15]",
          "tw-h-9 tw-w-full tw-cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ jsx54(AppSwitcherIcon, { color: colors.white }),
          isAnimatedOut && /* @__PURE__ */ jsx54("span", { className: "tw-ml-2 tw-text-sm", children: getTranslation("teamworksApps") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx54(Popover2.Portal, { children: /* @__PURE__ */ jsx54(
      Popover2.Content,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[240px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx54("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx54("div", { className: "tw-relative tw-bg-white tw-space-y-2 tw-py-2", children: /* @__PURE__ */ jsx54("div", { className: "tw-max-h-[calc(100vh-147px)] tw-overflow-y-auto tw-py-1 tw-px-2", children: availableAppsOrdered.map(({ icon, name, url, slug }) => {
          const isSelected = app === slug || window.location.href.includes(url);
          return /* @__PURE__ */ jsxs31(
            "div",
            {
              onClick: isSelected ? void 0 : () => onAppChange(slug, url),
              className: "tw-flex tw-space-x-3 tw-items-center tw-px-3 tw-py-2 tw-rounded-md hover:tw-bg-black/10 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent tw-w-full",
              children: [
                /* @__PURE__ */ jsx54("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: icon }),
                /* @__PURE__ */ jsx54("div", { className: "tw-flex-auto tw-text-sm tw-font-semibold tw-text-black tw-text-left", children: name }),
                isSelected && /* @__PURE__ */ jsx54("div", { className: "tw-flex-none tw-text-xl tw-font-medium tw-text-black tw-text-right", children: /* @__PURE__ */ jsx54(CheckIcon7, {}) })
              ]
            },
            url
          );
        }) }) }) })
      }
    ) })
  ] }) });
};
var AppSwitcher_default = AppSwitcher;

// src/components/PrimaryNav/components/AvatarMenu.tsx
import * as Popover3 from "@radix-ui/react-popover";
import { clsx as clsx13 } from "clsx";
import { useRef as useRef17 } from "react";
import { ChevronRightIcon as ChevronRightIcon3, LogoutIcon } from "@teamworksdev/icons";

// src/components/VerticalNav/VerticalNav.tsx
import { clsx as clsx12 } from "clsx";
import { cloneElement as cloneElement10, forwardRef as forwardRef32, useState as useState12 } from "react";
import { NavLink as NavLink2 } from "react-router-dom";
import { MdExpandMore } from "@teamworksdev/icons";

// src/components/Collapsible/Collapsible.tsx
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger2 = CollapsiblePrimitive.CollapsibleTrigger;
var CollapsibleContent2 = CollapsiblePrimitive.CollapsibleContent;

// src/components/VerticalNav/useVerticalNav.tsx
import { useContext as useContext9 } from "react";
import { createContext as createContext9 } from "react";
import { jsx as jsx55 } from "react/jsx-runtime";
var VerticalNavContext = createContext9(false);
var VerticalNavProvider = ({
  children,
  useReactRouter = false
}) => {
  return /* @__PURE__ */ jsx55(VerticalNavContext.Provider, { value: useReactRouter, children });
};
var useVerticalNav = () => {
  const useReactRouter = useContext9(VerticalNavContext);
  return useReactRouter;
};

// src/components/VerticalNav/VerticalNav.tsx
import { jsx as jsx56, jsxs as jsxs32 } from "react/jsx-runtime";
var VerticalNav = forwardRef32((_a, ref) => {
  var _b = _a, { className, children, useReactRouter = true } = _b, props = __objRest(_b, ["className", "children", "useReactRouter"]);
  const validChildren = getValidChildren(children);
  return /* @__PURE__ */ jsx56("nav", __spreadProps(__spreadValues({ ref, className: cn(" tw-w-full", className) }, props), { children: /* @__PURE__ */ jsx56("ul", { className: "tw-flex-row tw-items-left tw-list-none tw-text-sm tw-space-y-1", children: /* @__PURE__ */ jsx56(VerticalNavProvider, { useReactRouter, children: validChildren }) }) }));
});
VerticalNav.displayName = "VerticalNav";
var VerticalNavGroup = forwardRef32(
  (_a, ref) => {
    var _b = _a, {
      title = "",
      isCollapsible = false,
      isDefaultOpen = true,
      className,
      children
    } = _b, props = __objRest(_b, [
      "title",
      "isCollapsible",
      "isDefaultOpen",
      "className",
      "children"
    ]);
    return isCollapsible ? /* @__PURE__ */ jsx56(
      CollapsibleNavGroup,
      {
        title,
        className,
        isDefaultOpen,
        children
      }
    ) : /* @__PURE__ */ jsxs32("li", { className: "tw-w-full", children: [
      /* @__PURE__ */ jsx56("span", { className: "tw-font-semibold tw-text-black dark:tw-text-white tw-p-2 tw-select-none tw-line-clamp-1", children: title }),
      /* @__PURE__ */ jsx56(
        "ul",
        __spreadProps(__spreadValues({
          ref,
          className: cn("tw-pl-1 tw-list-none tw-space-y-1", className)
        }, props), {
          children
        })
      )
    ] });
  }
);
VerticalNavGroup.displayName = "VerticalNavGroup";
var CollapsibleNavGroup = forwardRef32(
  (_a, ref) => {
    var _b = _a, { title = "", className, isDefaultOpen = true, children } = _b, props = __objRest(_b, ["title", "className", "isDefaultOpen", "children"]);
    const [isOpen, setIsOpen] = useState12(isDefaultOpen);
    return /* @__PURE__ */ jsxs32(Collapsible, { open: isOpen, onOpenChange: setIsOpen, className: "tw-w-full", children: [
      /* @__PURE__ */ jsx56(CollapsibleTrigger2, { asChild: true, children: /* @__PURE__ */ jsxs32("div", { className: "tw-cursor-pointer tw-flex tw-items-center tw-justify-between tw-text-black dark:tw-text-white tw-p-2 select-none", children: [
        /* @__PURE__ */ jsx56("span", { className: "tw-font-semibold tw-line-clamp-1", children: title }),
        /* @__PURE__ */ jsx56(
          MdExpandMore,
          {
            className: clsx12("tw-text-xl", {
              "tw-rotate-180": isOpen
            })
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx56(CollapsibleContent2, { children: /* @__PURE__ */ jsx56(
        "ul",
        __spreadProps(__spreadValues({
          ref,
          className: cn("tw-list-none tw-pl-1 tw-space-y-1", className)
        }, props), {
          children
        })
      ) })
    ] });
  }
);
CollapsibleNavGroup.displayName = "CollapsibleNavGroup";
var VerticalNavItem = forwardRef32(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ jsx56("li", __spreadProps(__spreadValues({ ref, className }, props), { children }));
  }
);
VerticalNavItem.displayName = "VerticalNavItem";
var VerticalNavSeparator = forwardRef32(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx56(
      "li",
      __spreadValues({
        ref,
        className: cn(
          "tw--mx-1 tw-my-1 tw-h-px tw-bg-light-200 dark:tw-bg-white/10",
          className
        )
      }, props)
    );
  }
);
VerticalNavSeparator.displayName = "VerticalNavSeparator";
var VerticalNavButton = forwardRef32((_a, ref) => {
  var _b = _a, { active = false, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  return /* @__PURE__ */ jsx56(
    "span",
    __spreadProps(__spreadValues({
      role: "button",
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.currentTarget.click();
        }
      },
      ref,
      className: cn(
        clsx12(
          "tw-flex tw-items-center tw-cursor-pointer tw-rounded-md tw-p-2 tw-border-b-2 tw-border-transparent tw-transition-colors tw-select-none tw-line-clamp-1",
          "hover:tw-bg-light-200 hover:tw-text-black tw-text-black",
          "dark:hover:tw-bg-white/10 dark:hover:tw-text-white dark:tw-text-white",
          {
            "tw-bg-light-200 dark:tw-bg-white/10": active
          }
        ),
        className
      )
    }, props), {
      children
    })
  );
});
VerticalNavButton.displayName = "VerticalNavButton";
var VerticalNavIcon = (_a) => {
  var _b = _a, {
    icon,
    className
  } = _b, props = __objRest(_b, [
    "icon",
    "className"
  ]);
  return cloneElement10(icon, {
    className: cn("tw-mr-2 tw-h-4 tw-w-4 tw-text-dark-300", className)
  });
};
VerticalNavIcon.displayName = "VerticalNavIcon";
var VerticalNavLink = forwardRef32((_a, ref) => {
  var _b = _a, { active, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  const useReactRouter = useVerticalNav();
  return !useReactRouter ? /* @__PURE__ */ jsx56(
    "a",
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      href: props.to,
      className: cn(
        clsx12(
          "tw-flex tw-items-center tw-rounded-md tw-p-2 tw-border-b-2 tw-border-transparent tw-transition-colors tw-select-none tw-line-clamp-1",
          "hover:tw-bg-light-200 hover:tw-text-black tw-text-black",
          "dark:hover:tw-bg-white/10 dark:hover:tw-text-white dark:tw-text-white",
          {
            "tw-font-semibold tw-bg-light-200 dark:tw-bg-white/10": !!active
          }
        ),
        className
      )
    }, props), {
      children
    })
  ) : /* @__PURE__ */ jsx56(
    NavLink2,
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      className: ({ isActive }) => cn(
        clsx12(
          "tw-flex tw-items-center tw-rounded-md tw-p-2 tw-border-b-2 tw-border-transparent tw-transition-colors tw-select-none tw-line-clamp-1",
          "hover:tw-bg-light-200 hover:tw-text-black tw-text-black",
          "dark:hover:tw-bg-white/10 dark:hover:tw-text-white dark:tw-text-white",
          {
            "tw-bg-light-200 dark:tw-bg-white/10": active != null ? active : isActive
          }
        ),
        className
      )
    }, props), {
      children
    })
  );
});
VerticalNavLink.displayName = "VerticalNavLink";

// src/components/PrimaryNav/components/AvatarMenu.tsx
import { Fragment as Fragment3, jsx as jsx57, jsxs as jsxs33 } from "react/jsx-runtime";
var AvatarMenu = ({
  collapseOnItemClick = true,
  isAnimatedOut,
  isExpanded,
  additionalSettingsLinks = [],
  toggleMenu,
  innerProps
}) => {
  const { urlAccount, urlSettings, onLogout, user, useReactRouter } = innerProps;
  const closeButtonRef = useRef17(null);
  const innerCloseButtonRef = useRef17(null);
  const onClick = () => {
    var _a, _b;
    (_a = closeButtonRef.current) == null ? void 0 : _a.click();
    (_b = innerCloseButtonRef.current) == null ? void 0 : _b.click();
    if (isExpanded && collapseOnItemClick)
      toggleMenu();
  };
  const links = [...additionalSettingsLinks];
  if (urlAccount) {
    links.push({ name: getTranslation("myProfile"), to: urlAccount });
  }
  if (urlSettings) {
    links.push({ name: getTranslation("accountSettings"), to: urlSettings });
  }
  return /* @__PURE__ */ jsxs33(Popover3.Root, { modal: false, children: [
    /* @__PURE__ */ jsx57(Popover3.Trigger, { asChild: true, children: /* @__PURE__ */ jsx57("button", { className: "tw-group tw-block tw-flex-shrink-0 tw--mx-4 tw-px-0 tw-w-[calc(100%+1rem)]", children: /* @__PURE__ */ jsx57(
      "div",
      {
        className: clsx13(
          "teams-popover-trigger",
          "tw-rounded-md tw-p-2 hover:tw-bg-white/[0.15]",
          "tw-transition-all tw-duration-300 tw-ease-in-out tw-cursor-pointer"
        ),
        children: /* @__PURE__ */ jsxs33("div", { className: "tw-flex tw-items-center", children: [
          /* @__PURE__ */ jsx57("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx57(Avatar, { name: user.name, src: user.avatar, size: "md" }) }),
          isAnimatedOut && /* @__PURE__ */ jsx57(Fragment3, { children: /* @__PURE__ */ jsxs33("div", { className: "tw-text-left tw-ml-3 tw-flex-auto tw-font-medium tw-truncate", children: [
            /* @__PURE__ */ jsx57("div", { className: "tw-text-white tw-text-sm tw-truncate", children: user.name }),
            user.title && /* @__PURE__ */ jsx57("div", { className: "tw-text-white/60 tw-text-[11px] tw-truncate", children: user.title })
          ] }) })
        ] })
      }
    ) }) }),
    /* @__PURE__ */ jsx57(
      Popover3.Close,
      {
        ref: closeButtonRef,
        tabIndex: -1,
        className: "tw-sr-only"
      }
    ),
    /* @__PURE__ */ jsx57(Popover3.Portal, { children: /* @__PURE__ */ jsx57(
      Popover3.Content,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[256px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx57("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx57("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsxs33(
          VerticalNav,
          {
            useReactRouter,
            className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1",
            children: [
              links.length > 0 && /* @__PURE__ */ jsxs33(Fragment3, { children: [
                /* @__PURE__ */ jsx57("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: getTranslation("settings") }),
                links.map(({ name, to, children }, index) => {
                  if (children) {
                    return /* @__PURE__ */ jsxs33(Popover3.Root, { children: [
                      /* @__PURE__ */ jsx57(Popover3.Trigger, { asChild: true, children: /* @__PURE__ */ jsxs33(
                        "button",
                        {
                          className: "tw-flex tw-text-sm tw-font-sans tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer focus-visible:tw-outline-offset-[-1px] tw-w-full tw-justify-between",
                          children: [
                            /* @__PURE__ */ jsx57("span", { children: name }),
                            /* @__PURE__ */ jsx57(ChevronRightIcon3, { className: "tw-h-4" })
                          ]
                        },
                        index
                      ) }),
                      /* @__PURE__ */ jsx57(
                        Popover3.Close,
                        {
                          ref: innerCloseButtonRef,
                          tabIndex: -1,
                          className: "tw-sr-only"
                        }
                      ),
                      /* @__PURE__ */ jsx57(Popover3.Portal, { children: /* @__PURE__ */ jsx57(
                        Popover3.Content,
                        {
                          align: "start",
                          side: "right",
                          sideOffset: 2,
                          className: "tw-reset tw-min-w-[256px]",
                          children: /* @__PURE__ */ jsx57("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx57("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsx57("div", { className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1", children: children.map(({ name: name2, to: to2 }, index2) => /* @__PURE__ */ jsx57(
                            VerticalNavLink,
                            {
                              to: to2,
                              onClick,
                              className: "tw-flex tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus-visible:tw-outline-offset-[-1px] tw-w-full",
                              children: name2
                            },
                            index2
                          )) }) }) })
                        }
                      ) })
                    ] }, index);
                  } else {
                    return /* @__PURE__ */ jsx57(
                      VerticalNavLink,
                      {
                        to,
                        onClick,
                        className: "tw-flex tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus-visible:tw-outline-offset-[-1px] tw-w-full",
                        children: name
                      },
                      index
                    );
                  }
                }),
                /* @__PURE__ */ jsx57("div", { className: "tw-border-b" })
              ] }),
              /* @__PURE__ */ jsxs33(
                "button",
                {
                  type: "button",
                  onClick: onLogout,
                  className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-items-center tw-px-5 tw-py-2 tw-text-error-700 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                  children: [
                    /* @__PURE__ */ jsx57("span", { children: getTranslation("logout") }),
                    /* @__PURE__ */ jsx57("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx57(LogoutIcon, {}) })
                  ]
                }
              )
            ]
          }
        ) }) })
      }
    ) })
  ] });
};
var AvatarMenu_default = AvatarMenu;

// src/components/PrimaryNav/components/HelpLinks.tsx
import * as Popover4 from "@radix-ui/react-popover";
import { clsx as clsx14 } from "clsx";
import { useMemo as useMemo7, useRef as useRef18 } from "react";
import { ExternalLinkIcon, SupportIcon } from "@teamworksdev/icons";
import { Fragment as Fragment4, jsx as jsx58, jsxs as jsxs34 } from "react/jsx-runtime";
var helpLinks = {
  academics: "https://twretain.zendesk.com/hc/en-us",
  arms: "http://help.armssoftware.com/en/",
  camps: "https://armscamps.zendesk.com/hc/en-us",
  hub: "https://teamworks.zendesk.com/hc/en-us",
  inflcr: "https://inflcr.zendesk.com/hc/en-us",
  inventory: "https://helpdesk.frontrush.com/fr-trac-inventory-management",
  notemeal: "https://notemeal.zendesk.com/hc/en-us",
  nutrition: "https://notemeal.zendesk.com/hc/en-us",
  pathways: "https://twpathways.zendesk.com/hc/en-us",
  pulse: "https://twpulse.zendesk.com/hc/en-us",
  retain: "https://twretain.zendesk.com/hc/en-us",
  whistle: "https://twwhistle.zendesk.com/hc/en-us",
  smartabase: "https://smartabase.zendesk.com/hc/en-us"
};
var HelpLinks = ({
  app,
  useReactRouter = true,
  appSpecificHelpSubmenu,
  hasHelpCenter,
  hasLearningPortal,
  isAnimatedOut,
  isExpanded,
  onChatWithSupport
}) => {
  const closeButtonRef = useRef18(null);
  const onClick = () => {
    var _a;
    (_a = closeButtonRef.current) == null ? void 0 : _a.click();
  };
  const externalLinks = useMemo7(() => {
    const result = [];
    if (hasHelpCenter) {
      result.push({
        name: getTranslation("helpCenter"),
        to: app && app in helpLinks ? helpLinks[app] : helpLinks["hub"]
      });
    }
    if (hasLearningPortal) {
      result.push({
        name: getTranslation("learningPortal"),
        to: "https://learn.teamworks.com/"
      });
    }
    return result;
  }, [app, hasHelpCenter, hasLearningPortal]);
  return /* @__PURE__ */ jsx58(MenuItem_default, { tooltip: getTranslation("teamworksHelp"), isExpanded, children: /* @__PURE__ */ jsxs34(Popover4.Root, { children: [
    /* @__PURE__ */ jsx58(Popover4.Trigger, { asChild: true, children: /* @__PURE__ */ jsxs34(
      "button",
      {
        className: clsx14(
          "apps-popover-trigger",
          "tw-group tw-flex tw-justify-start tw-items-center",
          "tw-rounded-md tw-p-2 tw-text-lg tw-font-medium",
          "tw-text-white hover:tw-bg-white/[0.15]",
          "tw-h-9 tw-w-full tw-cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ jsx58(SupportIcon, {}),
          isAnimatedOut && /* @__PURE__ */ jsx58("span", { className: "tw-ml-2 tw-text-sm", children: getTranslation("teamworksHelp") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx58(Popover4.Portal, { children: /* @__PURE__ */ jsxs34(
      Popover4.Content,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-reset tw-w-[240px]",
        children: [
          /* @__PURE__ */ jsx58(
            Popover4.Close,
            {
              ref: closeButtonRef,
              className: "tw-sr-only",
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ jsx58("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx58("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsxs34("div", { className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1", children: [
            /* @__PURE__ */ jsx58("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: "Teamworks Help" }),
            onChatWithSupport && /* @__PURE__ */ jsx58(
              "button",
              {
                onClick: () => {
                  onChatWithSupport();
                  onClick();
                },
                className: "tw-flex tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                children: getTranslation("chatWithSupport")
              }
            ),
            externalLinks.map((link) => {
              return /* @__PURE__ */ jsxs34(
                "a",
                {
                  href: link.to,
                  target: "_blank",
                  onClick,
                  className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                  rel: "noreferrer",
                  children: [
                    /* @__PURE__ */ jsx58("span", { children: link.name }),
                    /* @__PURE__ */ jsx58("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx58(ExternalLinkIcon, {}) })
                  ]
                },
                link.to
              );
            }),
            appSpecificHelpSubmenu && /* @__PURE__ */ jsxs34(Fragment4, { children: [
              /* @__PURE__ */ jsx58("div", { className: "tw-mx-3 tw-my-1 tw-h-px tw-bg-light-200" }),
              appSpecificHelpSubmenu.label && /* @__PURE__ */ jsx58("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: appSpecificHelpSubmenu.label }),
              appSpecificHelpSubmenu.links.map((link) => {
                return link.to ? /* @__PURE__ */ jsxs34(
                  AbstractLink,
                  {
                    useReactRouter,
                    to: link.to,
                    target: link.target,
                    onClick: () => {
                      var _a;
                      (_a = link.onClick) == null ? void 0 : _a.call(link);
                      onClick();
                    },
                    className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                    rel: "noreferrer",
                    children: [
                      link.icon && /* @__PURE__ */ jsx58("span", { className: "tw-mr-2 tw-text-lg", children: link.icon }),
                      /* @__PURE__ */ jsx58("span", { className: "tw-flex-1", children: link.name }),
                      !link.icon && /* @__PURE__ */ jsx58("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx58(ExternalLinkIcon, {}) })
                    ]
                  },
                  link.to
                ) : /* @__PURE__ */ jsxs34(
                  "button",
                  {
                    onClick: () => {
                      var _a;
                      (_a = link.onClick) == null ? void 0 : _a.call(link);
                      onClick();
                    },
                    className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                    children: [
                      link.icon && /* @__PURE__ */ jsx58("span", { className: "tw-mr-2 tw-text-lg", children: link.icon }),
                      /* @__PURE__ */ jsx58("span", { className: cn(link.icon && "tw-flex-1"), children: link.name })
                    ]
                  },
                  link.name
                );
              })
            ] })
          ] }) }) })
        ]
      }
    ) })
  ] }) });
};
var HelpLinks_default = HelpLinks;

// src/components/PrimaryNav/components/Logo.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
var Logo = ({ src, alt }) => {
  return /* @__PURE__ */ jsx59(
    "img",
    {
      alt,
      src,
      className: "tw-inline-flex tw-overflow-hidden tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-text-xl tw-object-contain"
    }
  );
};
var Logo_default = Logo;

// src/components/PrimaryNav/components/TeamSwitcher.tsx
import * as Popover5 from "@radix-ui/react-popover";
import { clsx as clsx15 } from "clsx";
import { useMemo as useMemo8, useRef as useRef19, useState as useState13 } from "react";
import { SwitchIcon } from "@teamworksdev/icons";
import { Fragment as Fragment5, jsx as jsx60, jsxs as jsxs35 } from "react/jsx-runtime";
var TeamSwitcher = ({
  innerProps,
  isAnimatedOut,
  isExpanded
}) => {
  const [search, setSearch] = useState13("");
  const closeButtonRef = useRef19(null);
  const {
    team: {
      avatar: currentAvatar,
      name: currentTeamName,
      organization: currentOrganization
    },
    teams,
    onTeamChange,
    onOrgChange
  } = innerProps;
  const requiresSearch = !!teams && teams.length >= 10;
  const filteredTeams = useMemo8(() => {
    if (!teams)
      return [];
    if (!requiresSearch || !search)
      return teams != null ? teams : [];
    return teams.filter(
      (team) => {
        var _a;
        return (_a = team.name) == null ? void 0 : _a.toLowerCase().includes(search.toLowerCase());
      }
    );
  }, [requiresSearch, search, teams]);
  const showTeamSwitcher = teams && teams.length > 1 || typeof onOrgChange === "function";
  return /* @__PURE__ */ jsxs35(Popover5.Root, { children: [
    /* @__PURE__ */ jsx60(Popover5.Trigger, { asChild: true, children: /* @__PURE__ */ jsx60("button", { className: "tw-group tw-block tw-flex-shrink-0 tw--mx-4 tw-px-0 tw-w-[calc(100%+1.25rem)]", children: /* @__PURE__ */ jsx60(MenuItem_default, { tooltip: currentTeamName, isExpanded, children: /* @__PURE__ */ jsx60(
      "div",
      {
        className: clsx15(
          "teams-popover-trigger",
          "tw-rounded-md tw-p-2 hover:tw-bg-white/[0.15] hover:tw-border-white/10",
          "tw-transition-all tw-duration-300 tw-ease-in-out tw-border",
          {
            "tw-bg-white/[0.15] tw-border-white/10": isExpanded,
            "tw-border-opacity-0 tw-border-black": !isExpanded,
            "tw-cursor-pointer": teams && teams.length > 1
          }
        ),
        children: /* @__PURE__ */ jsxs35("div", { className: "tw-flex tw-items-center", children: [
          /* @__PURE__ */ jsx60("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: currentAvatar ? /* @__PURE__ */ jsx60(Logo_default, { alt: currentTeamName != null ? currentTeamName : "Logo", src: currentAvatar }) : /* @__PURE__ */ jsx60(Avatar, { size: "lg", name: currentTeamName }) }),
          isAnimatedOut && /* @__PURE__ */ jsxs35(Fragment5, { children: [
            /* @__PURE__ */ jsxs35("div", { className: "tw-text-left tw-ml-3 tw-flex-auto tw-font-medium tw-truncate", children: [
              /* @__PURE__ */ jsx60("div", { className: "tw-text-white tw-text-sm tw-truncate", children: currentTeamName }),
              currentOrganization && /* @__PURE__ */ jsx60("div", { className: "tw-text-white/60 tw-text-[11px] tw-leading-[11px] tw-truncate", children: currentOrganization })
            ] }),
            /* @__PURE__ */ jsx60("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: showTeamSwitcher && /* @__PURE__ */ jsxs35("div", { className: "tw-text-white tw-p-2 tw-font-medium tw-rounded-md", children: [
              /* @__PURE__ */ jsx60("span", { className: "tw-sr-only", children: getTranslation("changeTeam") }),
              /* @__PURE__ */ jsx60(SwitchIcon, {})
            ] }) })
          ] })
        ] })
      }
    ) }) }) }),
    /* @__PURE__ */ jsx60(Popover5.Close, { ref: closeButtonRef, tabIndex: -1 }),
    /* @__PURE__ */ jsx60(Popover5.Portal, { children: showTeamSwitcher && /* @__PURE__ */ jsx60(
      Popover5.Content,
      {
        align: "start",
        side: "bottom",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[256px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx60("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg tw-border tw-border-light-200", children: /* @__PURE__ */ jsxs35("div", { className: "tw-relative tw-bg-white tw-space-y-2 tw-py-2", children: [
          onOrgChange && typeof onOrgChange === "function" && /* @__PURE__ */ jsx60("div", { className: "tw-flex tw-items-center tw-justify-end tw-px-2 ", children: /* @__PURE__ */ jsxs35(
            "button",
            {
              className: "tw-flex tw-space-x-2 tw-py-1 tw-text-blue-500 tw-font-semibold tw-text-sm tw-rounded-sm tw-border-none",
              onClick: () => {
                var _a;
                (_a = closeButtonRef.current) == null ? void 0 : _a.click();
                onOrgChange == null ? void 0 : onOrgChange();
                setSearch("");
              },
              children: [
                /* @__PURE__ */ jsx60("span", { children: getTranslation("switchOrgs") }),
                /* @__PURE__ */ jsx60("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx60(SwitchIcon, {}) })
              ]
            }
          ) }),
          requiresSearch && /* @__PURE__ */ jsxs35("div", { className: "tw-px-2", children: [
            /* @__PURE__ */ jsx60("label", { htmlFor: "team-search", className: "tw-sr-only", children: getTranslation("search") }),
            /* @__PURE__ */ jsx60(
              "input",
              {
                type: "text",
                name: "team-search",
                id: "team-search",
                className: "tw-block tw-w-full tw-rounded-md tw-border-0 tw-py-2 tw-px-4 tw-text-gray-900 tw-text-sm tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-light-300 tw-placeholder:text-light-400 focus:tw-ring-inset tw-sm:leading-6",
                placeholder: getTranslation("searchForTeam"),
                value: search,
                onChange: (e) => setSearch(e.target.value)
              }
            )
          ] }),
          /* @__PURE__ */ jsx60("div", { className: "tw-space-y-1 tw-max-h-[350px] tw-overflow-y-auto tw-py-1 tw-px-2", children: filteredTeams.map((team) => /* @__PURE__ */ jsxs35(
            "button",
            {
              "aria-label": team.name,
              type: "button",
              className: "tw-flex tw-items-center tw-px-3 tw-py-2 tw-rounded-md tw-bg-white hover:tw-bg-light-50 focus:tw-bg-light-50 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent tw-w-full",
              onClick: () => {
                var _a;
                (_a = closeButtonRef.current) == null ? void 0 : _a.click();
                onTeamChange == null ? void 0 : onTeamChange(team.id);
                setSearch("");
              },
              children: [
                /* @__PURE__ */ jsx60("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx60(Avatar, { src: team.avatar, name: team.name, size: "lg" }) }),
                /* @__PURE__ */ jsx60("div", { className: "tw-ml-3", children: /* @__PURE__ */ jsx60("span", { className: "tw-text-sm tw-font-medium tw-text-gray-900 tw-text-left tw-truncate", children: team.name }) })
              ]
            },
            team.id
          )) })
        ] }) })
      }
    ) })
  ] });
};
var TeamSwitcher_default = TeamSwitcher;

// src/components/PrimaryNav/PrimaryNav.tsx
import { Fragment as Fragment6, jsx as jsx61, jsxs as jsxs36 } from "react/jsx-runtime";
var PRIMARY_NAV_COLLAPSED_WIDTH = 80;
var PRIMARY_NAV_EXPANDED_WIDTH = 270;
var PRIMARY_NAV_TRANSITION_DURATION = 300;
var defaultComponents = {
  TeamSwitcher: TeamSwitcher_default
};
var PrimaryNav = (_a) => {
  var _b = _a, { components } = _b, innerProps = __objRest(_b, ["components"]);
  var _a2;
  const {
    additionalSettingsLinks,
    appSpecificHelpSubmenu,
    app,
    apps,
    collapseOnItemClick = true,
    colors: colors2,
    defaultOpen = true,
    hasAppSwitcher = true,
    hasTeamSwitcher = true,
    hasHelpCenter = true,
    hasLearningPortal = true,
    location = window == null ? void 0 : window.location,
    logo,
    links,
    team,
    useReactRouter = true,
    onAppChange,
    onChatWithSupport
  } = innerProps;
  const currentPath = (_a2 = location == null ? void 0 : location.pathname) != null ? _a2 : "";
  const [isExpanded, setIsExpanded] = useState14(defaultOpen);
  const {
    colors: sharedNavColors,
    navState: sharedNavState,
    updateNavState
  } = useSharedNav();
  const finalColors = useMemo9(
    () => colors2 != null ? colors2 : sharedNavColors,
    [colors2, sharedNavColors]
  );
  const gradient = useMemo9(
    () => finalColors ? getColorGradientCSS(finalColors) : {},
    [finalColors]
  );
  useEffect10(() => {
    if (sharedNavState.expanded !== isExpanded)
      updateNavState({ expanded: isExpanded });
  }, [isExpanded, sharedNavState, updateNavState]);
  const [isAnimatedOut, setIsAnimatedOut] = useState14(defaultOpen);
  const animationOutTimer = useRef20();
  const toggleMenu = useCallback4(() => {
    if (!isExpanded) {
      setIsExpanded(true);
      animationOutTimer.current = setTimeout(() => {
        setIsAnimatedOut(true);
      }, PRIMARY_NAV_TRANSITION_DURATION);
    } else {
      setIsExpanded(false);
      setIsAnimatedOut(false);
      clearTimeout(animationOutTimer.current);
    }
    updateNavState({ expanded: !isExpanded });
  }, [isExpanded, updateNavState]);
  const closeMenu = useCallback4(() => {
    isExpanded && toggleMenu();
  }, [isExpanded, toggleMenu]);
  const onItemClick = useCallback4(
    (_onClick) => (event) => {
      _onClick == null ? void 0 : _onClick(event);
      if (!event.defaultPrevented && collapseOnItemClick) {
        closeMenu();
      }
    },
    [closeMenu, collapseOnItemClick]
  );
  const account = {
    id: team.id,
    avatar: team.avatar
  };
  if (team.name) {
    account.name = team.name;
    account.organization = team.organization;
  } else {
    account.name = team.organization;
  }
  const { TeamSwitcher: TeamSwitcher2 } = __spreadValues(__spreadValues({}, defaultComponents), components);
  return /* @__PURE__ */ jsx61(TooltipProvider, { children: /* @__PURE__ */ jsx61(
    "div",
    {
      id: "tw-shared-nav",
      className: "tw-reset tw-flex tw-h-screen",
      style: gradient,
      children: /* @__PURE__ */ jsx61(
        "div",
        {
          className: clsx16(
            `tw-inset-y-0 tw-flex tw-flex-col tw-transition-all tw-ease-in-out`,
            {
              "tw-collapsed": !isExpanded,
              "tw-expanded": isExpanded
            }
          ),
          style: {
            width: isExpanded ? PRIMARY_NAV_EXPANDED_WIDTH : PRIMARY_NAV_COLLAPSED_WIDTH,
            transitionDuration: `${PRIMARY_NAV_TRANSITION_DURATION}ms`
          },
          children: /* @__PURE__ */ jsxs36("div", { className: "tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-relative", children: [
            /* @__PURE__ */ jsx61("div", { className: "tw-flex tw-flex-shrink-0 tw-flex-col tw-pt-4 tw-mb-4", children: /* @__PURE__ */ jsxs36("div", { className: "tw-flex tw-flex-col tw-flex-shrink-0 tw-items-center tw-px-[1.375rem] tw-space-y-1", children: [
              /* @__PURE__ */ jsx61("div", { className: "tw-flex tw-w-full tw-items-start", children: /* @__PURE__ */ jsx61("div", { className: "tw-flex tw-flex-col tw-w-18 tw-h-[60px] tw-items-center tw-justify-center tw-logo-wrapper", children: logo }) }),
              hasTeamSwitcher && /* @__PURE__ */ jsx61(
                TeamSwitcher2,
                {
                  isAnimatedOut,
                  isExpanded,
                  innerProps: __spreadProps(__spreadValues({}, innerProps), {
                    team: account
                  })
                }
              )
            ] }) }),
            /* @__PURE__ */ jsxs36("div", { className: "tw-flex tw-flex-1 tw-flex-col tw-justify-between tw-overflow-y-auto", children: [
              /* @__PURE__ */ jsxs36("nav", { className: "tw-flex tw-flex-col tw-space-y-1 tw-px-[1.375rem]", children: [
                /* @__PURE__ */ jsx61(
                  MenuItem_default,
                  {
                    tooltip: isExpanded ? getTranslation("closeMenu") : getTranslation("openMenu"),
                    isExpanded,
                    children: /* @__PURE__ */ jsx61(
                      "button",
                      {
                        type: "button",
                        className: "tw-text-white hover:tw-bg-white/[0.15] tw-group tw-flex tw-justify-start tw-items-center tw-rounded-md tw-p-2 tw-text-lg tw-font-medium tw-w-full tw-h-9",
                        onClick: toggleMenu,
                        children: isExpanded ? /* @__PURE__ */ jsxs36(
                          "div",
                          {
                            id: "tw-collapse-nav",
                            className: "tw-flex tw-items-center",
                            children: [
                              /* @__PURE__ */ jsx61(CloseMenuIcon, {}),
                              isAnimatedOut && /* @__PURE__ */ jsx61("span", { className: "tw-ml-2 tw-text-sm", children: getTranslation("closeMenu") })
                            ]
                          }
                        ) : /* @__PURE__ */ jsxs36(Fragment6, { children: [
                          /* @__PURE__ */ jsx61(OpenMenuIcon, {}),
                          /* @__PURE__ */ jsx61("span", { className: "tw-sr-only", children: getTranslation("openMenu") })
                        ] })
                      }
                    )
                  }
                ),
                links.map((link, index) => {
                  var _a3;
                  let isActive = link.isActive || (link.exact ? currentPath === link.to : currentPath.startsWith(link.to));
                  return /* @__PURE__ */ jsx61(
                    MenuItem_default,
                    {
                      tooltip: link.name,
                      isExpanded,
                      children: /* @__PURE__ */ jsx61(
                        AbstractLink,
                        {
                          useReactRouter,
                          target: link.target,
                          to: link.to,
                          onClick: onItemClick(link.onClick),
                          className: clsx16(
                            "tw-cursor-pointer tw-text-white hover:tw-text-white tw-group tw-flex tw-justify-start tw-items-center tw-rounded-md tw-p-2 tw-text-lg tw-font-medium tw-h-9",
                            {
                              "tw-bg-white/[0.15]": isActive,
                              "hover:tw-bg-white/[0.15]": !isActive,
                              "tw-border tw-border-white/[0.15] tw-mx-[-1px]": link.isHighlighted
                            }
                          ),
                          linkId: index,
                          children: /* @__PURE__ */ jsxs36("div", { className: "tw-flex tw-flex-row tw-items-center tw-w-full", children: [
                            (_a3 = link.icon) != null ? _a3 : /* @__PURE__ */ jsx61(DefaultIcon, {}),
                            /* @__PURE__ */ jsx61(
                              "span",
                              {
                                className: clsx16(
                                  "tw-flex-1",
                                  isAnimatedOut ? "tw-ml-2 tw-text-sm tw-truncate" : "tw-sr-only"
                                ),
                                children: link.name
                              }
                            ),
                            /* @__PURE__ */ jsx61(
                              "span",
                              {
                                className: clsx16({
                                  "tw-sr-only": !isAnimatedOut
                                }),
                                children: link.badgeValue ? /* @__PURE__ */ jsx61(Badge, { value: link.badgeValue }) : null
                              }
                            )
                          ] })
                        }
                      )
                    },
                    link.name
                  );
                })
              ] }),
              /* @__PURE__ */ jsxs36("nav", { className: "tw-flex tw-flex-col tw-space-y-1 tw-px-[1.375rem] tw-pt-1 tw-pb-4", children: [
                (onChatWithSupport || hasHelpCenter || hasLearningPortal || appSpecificHelpSubmenu) && /* @__PURE__ */ jsx61(
                  HelpLinks_default,
                  {
                    app,
                    hasHelpCenter,
                    hasLearningPortal,
                    isAnimatedOut,
                    isExpanded,
                    onChatWithSupport,
                    appSpecificHelpSubmenu,
                    useReactRouter
                  }
                ),
                hasAppSwitcher && typeof onAppChange === "function" && /* @__PURE__ */ jsx61(
                  AppSwitcher_default,
                  {
                    app,
                    apps,
                    isExpanded,
                    isAnimatedOut,
                    onAppChange
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ jsx61("div", { className: "tw-flex tw-flex-shrink-0 tw-flex-col tw-pt-4 tw-mb-4", children: /* @__PURE__ */ jsx61("div", { className: "tw-flex tw-flex-col tw-flex-shrink-0 tw-items-center tw-px-[1.375rem] tw-space-y-1", children: /* @__PURE__ */ jsx61(
              AvatarMenu_default,
              {
                collapseOnItemClick,
                isAnimatedOut,
                isExpanded,
                additionalSettingsLinks,
                innerProps,
                toggleMenu
              }
            ) }) })
          ] })
        }
      )
    }
  ) });
};
var PrimaryNav_default = PrimaryNav;

// src/components/PrimaryNav/index.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
function PrimaryNavWithRouter(props) {
  const location = useLocation();
  return /* @__PURE__ */ jsx62(PrimaryNav_default, __spreadProps(__spreadValues({}, props), { location, useReactRouter: true }));
}
function AbstractPrimaryNav(props) {
  const { useReactRouter = true } = props;
  const Component = useReactRouter ? PrimaryNavWithRouter : PrimaryNav_default;
  return /* @__PURE__ */ jsx62("div", { style: { maxWidth: PRIMARY_NAV_EXPANDED_WIDTH }, children: /* @__PURE__ */ jsx62($44d7e150ebc754d2$export$e926676385687eaf, { FallbackComponent: FriendlyError, onError: handleError, children: /* @__PURE__ */ jsx62(Component, __spreadProps(__spreadValues({}, props), { useReactRouter })) }) });
}

// src/components/Radio/Radio.tsx
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cva as cva14 } from "class-variance-authority";
import { forwardRef as forwardRef33 } from "react";
import { CheckIcon as CheckIcon8 } from "@teamworksdev/icons";
import { jsx as jsx63 } from "react/jsx-runtime";
var radioItemClassDefaults = [
  "tw-peer",
  "tw-p-0",
  "tw-shrink-0",
  "tw-border",
  "tw-border-light-300",
  "tw-rounded-full",
  "tw-ring-offset-white",
  "active:tw-border-dark-400",
  "disabled:hover:tw-border-light-300",
  "disabled:tw-bg-light-100",
  "disabled:tw-border-light-300",
  "disabled:tw-cursor-not-allowed",
  "data-[state=checked]:disabled:tw-opacity-40",
  "data-[state=checked]:disabled:tw-border-dark-700",
  "data-[state=checked]:disabled:tw-bg-gray-700",
  "data-[state=checked]:tw-bg-info-700",
  "data-[state=checked]:tw-border-info-700",
  "data-[state=checked]:active:tw-border-info-700",
  "hover:tw-border-dark-400",
  "focus-visible:tw-outline-none",
  "focus-visible:tw-ring-2",
  "focus-visible:tw-ring-ring",
  "focus-visible:tw-ring-offset-2"
];
var radioItemVariants = cva14(radioItemClassDefaults.join(" "), {
  variants: {
    size: {
      sm: "tw-w-3.5 tw-h-3.5",
      md: "tw-w-4 tw-h-4",
      lg: "tw-w-[1.125rem] tw-h-[1.125rem]",
      xl: "tw-w-6 tw-h-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var radioIconVariants = cva14("", {
  variants: {
    size: {
      sm: "tw-w-3.5 tw-h-3.5",
      md: "tw-w-4 tw-h-4",
      lg: "tw-w-[1.125rem] tw-h-[1.125rem]",
      xl: "tw-w-6 tw-h-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var RadioGroup3 = forwardRef33((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx63(
    RadioGroupPrimitive.Root,
    __spreadValues({
      ref,
      className: cn("tw-radioGroup", className)
    }, props)
  );
});
RadioGroup3.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = forwardRef33((_a, ref) => {
  var _b = _a, { className, size } = _b, props = __objRest(_b, ["className", "size"]);
  return /* @__PURE__ */ jsx63(
    RadioGroupPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        radioItemVariants({
          size
        }),
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx63(
        RadioGroupPrimitive.Indicator,
        {
          className: cn(
            "tw-flex tw-items-center tw-justify-center tw-text-white tw-mt-[-1px]"
          ),
          children: /* @__PURE__ */ jsx63(CheckIcon8, { className: cn(radioIconVariants({ size })) })
        }
      )
    })
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// src/components/Radio/RadioButton.tsx
import * as RadioGroupPrimitive2 from "@radix-ui/react-radio-group";
import { cva as cva15 } from "class-variance-authority";
import { forwardRef as forwardRef34 } from "react";
import { CheckIcon as CheckIcon9 } from "@teamworksdev/icons";
import { jsx as jsx64, jsxs as jsxs37 } from "react/jsx-runtime";
var checkboxButtonBaseClasses2 = [
  "tw-peer",
  "tw-flex",
  "tw-flex-1",
  "tw-items-start",
  "tw-justify-start",
  "tw-m-1",
  "tw-min-w-[130px]",
  "focus-visible:tw-outline-none",
  "focus-visible:tw-ring-2",
  "focus-visible:tw-ring-offset-2",
  "focus-visible:tw-ring-ring",
  "disabled:tw-cursor-not-allowed",
  "hover:tw-border-dark-400",
  "[&:active>span]:tw-border-dark-400",
  "[&:hover>span]:tw-border-dark-400",
  "[&:hover>span]:disabled:tw-border-light-300",
  "[&>div]:tw-cursor-pointer",
  "[&>div]:disabled:tw-cursor-not-allowed",
  "[&>div]:disabled:tw-opacity-40",
  "[&>span]:tw-border-light-300",
  "[&>span]:tw-ring-offset-white",
  "[&>span]:data-[state=checked]:tw-bg-info-700",
  "[&>span]:data-[state=checked]:tw-border-info-700",
  "[&>span]:data-[state=checked]:tw-text-white",
  "[&>span]:data-[state=checked]:active:tw-border-info-700",
  "[&>span]:data-[state=checked]:disabled:tw-bg-dark-800",
  "[&>span]:data-[state=checked]:disabled:tw-border-dark-700",
  "[&>span]:data-[state=checked]:disabled:tw-opacity-40",
  "[&>span]:data-[state=unchecked]:tw-border"
];
var checkboxButtonBorderedClasses = [
  "tw-bg-white",
  "tw-border",
  "tw-border-light-300",
  "tw-rounded-md",
  "disabled:tw-bg-light-200",
  "disabled:tw-border-light-300",
  "hover:tw-border-dark-400",
  "data-[state=checked]:enabled:tw-border-info-700",
  "data-[state=checked]:enabled:tw-bg-info-25"
];
var radioButtonVariants = cva15(checkboxButtonBaseClasses2.join(" "), {
  variants: {
    size: {
      sm: "tw-space-x-[0.375rem] [&>span]:data-[state=unchecked]:tw-p-[6px]",
      md: "tw-space-x-[0.5rem] [&>span]:data-[state=unchecked]:tw-p-[7px]",
      lg: "tw-space-x-[0.625rem] [&>span]:data-[state=unchecked]:tw-p-[8px]",
      xl: "tw-space-x-[0.75rem] [&>span]:data-[state=unchecked]:tw-p-[11px]"
    },
    bordered: {
      true: checkboxButtonBorderedClasses.join(" "),
      false: ""
    }
  },
  compoundVariants: [
    {
      size: "sm",
      bordered: true,
      class: "tw-py-2 tw-px-[6px]"
    },
    {
      size: "md",
      bordered: true,
      class: "tw-p-3 "
    },
    {
      size: "lg",
      bordered: true,
      class: "tw-p-3 "
    },
    {
      size: "xl",
      bordered: true,
      class: "tw-p-3 "
    }
  ],
  defaultVariants: {
    size: "md",
    bordered: true
  }
});
var radioIconVariants2 = cva15("", {
  variants: {
    size: {
      sm: "tw-w-3.5 tw-h-3.5",
      md: "tw-w-4 tw-h-4",
      lg: "tw-w-[1.125rem] tw-h-[1.125rem]",
      xl: "tw-w-6 tw-h-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var textVariants = cva15("", {
  variants: {
    size: {
      sm: "tw-text-xs",
      md: "tw-text-base",
      lg: "tw-text-lg",
      xl: "tw-text-xl"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var RadioButton = forwardRef34(
  (_a, ref) => {
    var _b = _a, { className, bordered, id, label, labelClassName, size, subText } = _b, props = __objRest(_b, ["className", "bordered", "id", "label", "labelClassName", "size", "subText"]);
    return /* @__PURE__ */ jsxs37(
      RadioGroupPrimitive2.Item,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          radioButtonVariants({
            bordered,
            size
          }),
          "tw-radioGroup",
          // provides border and blur
          className
        ),
        id
      }, props), {
        children: [
          /* @__PURE__ */ jsx64(
            "span",
            {
              className: cn(
                "tw-flex tw-items-center tw-justify-center tw-text-white tw-mt-[-1px] tw-rounded-full"
              ),
              children: /* @__PURE__ */ jsx64(RadioGroupPrimitive2.Indicator, { asChild: true, children: /* @__PURE__ */ jsx64(CheckIcon9, { className: cn(radioIconVariants2({ size })) }) })
            }
          ),
          /* @__PURE__ */ jsxs37("div", { className: "tw-flex tw-flex-col tw-text-left", children: [
            /* @__PURE__ */ jsx64(
              "label",
              {
                htmlFor: id,
                className: cn(
                  "tw-font-semibold tw-leading-[1]",
                  textVariants({
                    size
                  }),
                  labelClassName
                ),
                children: label
              }
            ),
            subText && /* @__PURE__ */ jsx64("span", { className: cn("tw-font-normal", textVariants({ size })), children: subText })
          ] })
        ]
      })
    );
  }
);
RadioButton.displayName = RadioGroupPrimitive2.Item.displayName;

// src/components/SecondaryNav/SecondaryNav.tsx
import { forwardRef as forwardRef35, useMemo as useMemo10 } from "react";
import { jsx as jsx65, jsxs as jsxs38 } from "react/jsx-runtime";
var SecondaryNavContent = forwardRef35(
  ({ children, className }, ref) => /* @__PURE__ */ jsx65(
    "div",
    {
      className: cn(
        "tw-flex tw-flex-1 tw-flex-col tw-overflow-y-auto tw-pr-4 tw-mb-4 -tw-mr-4",
        className
      ),
      ref,
      children
    }
  )
);
SecondaryNavContent.displayName = "SecondaryNavContent";
var SecondaryNav = forwardRef35((_a, ref) => {
  var _b = _a, { className, children, colors: colors2, width = 200 } = _b, props = __objRest(_b, ["className", "children", "colors", "width"]);
  var _a2;
  const validChildren = getValidChildren(children);
  const { colors: sharedNavColors, navState: sharedNavState } = useSharedNav();
  const finalColors = useMemo10(
    () => colors2 != null ? colors2 : sharedNavColors,
    [colors2, sharedNavColors]
  );
  const gradient = useMemo10(
    () => finalColors ? getColorGradientCSS(finalColors) : {},
    [finalColors]
  );
  const leftEdgeX = sharedNavState.expanded ? PRIMARY_NAV_EXPANDED_WIDTH : PRIMARY_NAV_COLLAPSED_WIDTH;
  return /* @__PURE__ */ jsx65(
    "div",
    {
      id: "tw-secondary-nav",
      className: cn("tw-reset tw-flex tw-h-full tw-dark", className),
      children: /* @__PURE__ */ jsx65(
        "div",
        {
          className: "tw-inset-y-0 tw-flex tw-flex-col",
          style: {
            width,
            background: (_a2 = finalColors == null ? void 0 : finalColors.top) != null ? _a2 : "transparent"
          },
          children: /* @__PURE__ */ jsx65(
            "div",
            {
              className: "tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-relative tw-px-4 tw-border tw-border-b-0 tw-border-r-0 tw-border-white/[0.24] tw-rounded-tl-2xl tw-transition-all tw-ease-in-out",
              style: __spreadProps(__spreadValues({}, gradient), {
                transitionDuration: `${PRIMARY_NAV_TRANSITION_DURATION}ms`,
                backgroundPositionX: -leftEdgeX
              }),
              children: validChildren
            }
          )
        }
      )
    }
  );
});
SecondaryNav.displayName = "SecondaryNav";
var SecondaryNavTitle = forwardRef35(({ className, children, icon }, ref) => {
  return /* @__PURE__ */ jsx65("div", { className: "tw-mb-4 tw-pt-8 tw-pb-4 tw-border-b tw-border-white/[0.24]", children: /* @__PURE__ */ jsxs38(
    Heading,
    {
      size: "h4",
      as: "h2",
      noOfLines: 1,
      className: cn(
        "tw-flex tw-items-center tw-justify-start tw-text-white",
        className
      ),
      ref,
      children: [
        icon && /* @__PURE__ */ jsx65("span", { className: "tw-text-xl tw-mr-2", children: icon }),
        children
      ]
    }
  ) });
});
SecondaryNavTitle.displayName = "SecondaryNavTitle";

// src/components/Skeleton/Skeleton.tsx
import { jsx as jsx66 } from "react/jsx-runtime";
var Skeleton = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx66(
    "div",
    __spreadValues({
      className: cn(
        "tw-animate-pulse tw-rounded-md tw-bg-light-300 dark:tw-bg-dark-700 tw-w-full tw-h-5",
        className
      )
    }, props)
  );
};
var SkeletonCircle = (_a) => {
  var _b = _a, { size, className } = _b, props = __objRest(_b, ["size", "className"]);
  return /* @__PURE__ */ jsx66(
    "div",
    __spreadValues({
      className: cn(
        avatarVariants({ size }),
        "tw-animate-pulse tw-rounded-full tw-bg-light-300 dark:tw-bg-dark-700",
        className
      )
    }, props)
  );
};

// src/components/Spinner/Spinner.tsx
import { cva as cva16 } from "class-variance-authority";
import { forwardRef as forwardRef36 } from "react";
import { jsx as jsx67 } from "react/jsx-runtime";
var spinnerVariants = cva16("tw-animate-spin", {
  variants: {
    size: {
      xl: "tw-h-24 tw-w-24",
      lg: "tw-h-16 tw-w-16",
      md: "tw-h-12 tw-w-12",
      sm: "tw-h-8 tw-w-8",
      xs: "tw-h-6 tw-w-6",
      xxs: "tw-h-4 tw-w-4",
      xxxs: "tw-h-3 tw-w-3"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var Spinner = forwardRef36(
  (_a, ref) => {
    var _b = _a, { className, color, size } = _b, props = __objRest(_b, ["className", "color", "size"]);
    return /* @__PURE__ */ jsx67(
      "svg",
      __spreadProps(__spreadValues({
        ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color != null ? color : "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: cn(spinnerVariants({ size }), className)
      }, props), {
        children: /* @__PURE__ */ jsx67("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
      })
    );
  }
);
Spinner.displayName = "Spinner";

// src/components/Table/Table.tsx
import { forwardRef as forwardRef37 } from "react";
import { jsx as jsx68 } from "react/jsx-runtime";
var Table = forwardRef37(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx68("div", { className: "tw-w-full tw-overflow-auto", children: /* @__PURE__ */ jsx68(
      "table",
      __spreadValues({
        ref,
        className: cn("tw-w-full tw-caption-bottom tw-text-sm", className)
      }, props)
    ) });
  }
);
Table.displayName = "Table";
var TableHeader = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "thead",
    __spreadValues({
      ref,
      className: cn("[&_tr]:tw-border-b tw-border-light-200", className)
    }, props)
  );
});
TableHeader.displayName = "TableHeader";
var TableBody = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "tbody",
    __spreadValues({
      ref,
      className: cn("[&_tr:last-child]:tw-border-0", className)
    }, props)
  );
});
TableBody.displayName = "TableBody";
var TableFooter = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "tfoot",
    __spreadValues({
      ref,
      className: cn("tw-bg-light-300 tw-font-medium tw-text-black", className)
    }, props)
  );
});
TableFooter.displayName = "TableFooter";
var TableRow = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "tr",
    __spreadValues({
      ref,
      className: cn(
        "tw-border-b tw-transition-colors hover:tw-bg-light-100 data-[state=selected]:bg-light-100",
        className
      )
    }, props)
  );
});
TableRow.displayName = "TableRow";
var TableHead = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "th",
    __spreadValues({
      ref,
      className: cn(
        "tw-bg-light-50 tw-h-11 tw-px-6 tw-text-left tw-align-middle tw-font-semibold tw-text-black/60 [&:has([role=checkbox])]:tw-pr-0",
        className
      )
    }, props)
  );
});
TableHead.displayName = "TableHead";
var TableCell = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "td",
    __spreadValues({
      ref,
      className: cn(
        "tw-py-4 tw-px-6 tw-align-middle [&:has([role=checkbox])]:tw-pr-0",
        className
      )
    }, props)
  );
});
TableCell.displayName = "TableCell";
var TableCaption = forwardRef37((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx68(
    "caption",
    __spreadValues({
      ref,
      className: cn("tw-mt-4 tw-text-sm text-light-400", className)
    }, props)
  );
});
TableCaption.displayName = "TableCaption";

// src/components/Tabs/Tabs.tsx
import * as TabsPrimitive from "@radix-ui/react-tabs";
import clsx17 from "clsx";
import { forwardRef as forwardRef38 } from "react";

// src/components/Tabs/useTabs.tsx
import { createContext as createContext10, useContext as useContext10 } from "react";
import { jsx as jsx69 } from "react/jsx-runtime";
var TabsContext = createContext10({
  variant: "underlined"
});
var TabsProvider = ({
  children,
  variant = "underlined"
}) => {
  return /* @__PURE__ */ jsx69(TabsContext.Provider, { value: { variant }, children });
};
var useTabs = () => {
  const useTabs2 = useContext10(TabsContext);
  return useTabs2;
};

// src/components/Tabs/Tabs.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
var Tabs = (_a) => {
  var _b = _a, {
    variant
  } = _b, props = __objRest(_b, [
    "variant"
  ]);
  return /* @__PURE__ */ jsx70(TabsProvider, { variant, children: /* @__PURE__ */ jsx70(TabsPrimitive.Root, __spreadValues({}, props)) });
};
Tabs.displayName = TabsPrimitive.Root.displayName;
var TabsList = forwardRef38((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { variant } = useTabs();
  return /* @__PURE__ */ jsx70(
    TabsPrimitive.List,
    __spreadValues({
      ref,
      className: cn(
        clsx17("tw-inline-flex tw-items-center tw-text-black", {
          "tw-h-10 tw-justify-center tw-rounded-md tw-bg-light-100 tw-p-1 ": variant === "contained",
          "tw-w-full tw-justify-start tw-border-b tw-border-light-300": variant === "underlined"
        }),
        className
      )
    }, props)
  );
});
TabsList.displayName = TabsPrimitive.List.displayName;
var TabsTrigger = forwardRef38((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { variant } = useTabs();
  return /* @__PURE__ */ jsx70(
    TabsPrimitive.Trigger,
    __spreadValues({
      ref,
      className: cn(
        clsx17(
          "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-cursor-pointer tw-bg-inherit ",
          {
            "tw-rounded-sm tw-px-4 tw-py-1.5 tw-text-sm tw-font-semibold tw-ring-offset-background tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 data-[state=active]:tw-bg-white data-[state=active]:tw-text-black data-[state=active]:tw-shadow-sm tw-text-black/60": variant === "contained",
            "tw-px-2 tw-py-4 tw-border-b-2 tw-text-black/60 tw-border-transparent hover:tw-text-black tw-transition-colors tw-rounded-none data-[state=active]:tw-text-black data-[state=active]:tw-border-black data-[state=active]:hover:tw-text-black/90 data-[state=active]:tw-font-semibold": variant === "underlined"
          }
        ),
        className
      )
    }, props)
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = forwardRef38((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx70(
    TabsPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "tw-w-full tw-mt-2 tw-ring-offset-white focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2",
        className
      )
    }, props)
  );
});
TabsContent.displayName = TabsPrimitive.Content.displayName;

// src/components/Toast/Toast.tsx
import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva as cva17 } from "class-variance-authority";
import clsx18 from "clsx";
import * as React4 from "react";
import { MdClose as MdClose7 } from "@teamworksdev/icons";
import { jsx as jsx71 } from "react/jsx-runtime";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Viewport,
    __spreadValues({
      ref,
      className: cn(
        "tw-fixed tw-top-0 tw-z-[100] tw-flex max-h-screen tw-w-full tw-flex-col-reverse tw-p-4 sm:tw-bottom-0 sm:tw-right-0 sm:tw-top-auto sm:tw-flex-col md:tw-max-w-[420px]",
        className
      )
    }, props)
  );
});
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var sharedClassNames = "tw-bg-dark-800 tw-text-white";
var toastVariants = cva17(
  clsx18(
    "tw-group tw-pointer-events-auto tw-relative tw-flex tw-w-full tw-items-center tw-justify-between tw-space-x-4 tw-overflow-hidden tw-rounded-md tw-border tw-p-4 tw-pr-10 tw-shadow-lg tw-transition-all data-[swipe=cancel]:tw-translate-x-0 data-[swipe=end]:tw-translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:tw-translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:tw-transition-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[swipe=end]:tw-animate-out data-[state=closed]:tw-fade-out-80 data-[state=closed]:tw-slide-out-to-right-full data-[state=open]:tw-slide-in-from-top-full data-[state=open]:sm:tw-slide-in-from-bottom-full",
    sharedClassNames
  ),
  {
    variants: {
      variant: {
        default: "",
        info: "",
        destructive: "",
        warning: "",
        success: "",
        question: ""
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Toast = React4.forwardRef((_a, ref) => {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Root,
    __spreadValues({
      ref,
      className: cn(toastVariants({ variant }), className)
    }, props)
  );
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Action,
    __spreadValues({
      ref,
      className: cn(
        "tw-inline-flex tw-h-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-bg-transparent tw-px-3 tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors hover:tw-bg-dark-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
        className
      )
    }, props)
  );
});
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastClose = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Close,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "tw-absolute tw-right-2 tw-top-2 tw-rounded-md tw-p-1 tw-bg-dark-800 tw-text-white/60 tw-transition-color hover:tw-text-white active:tw-text-white focus:tw-outline-none focus:tw-ring-2",
        className
      ),
      "toast-close": ""
    }, props), {
      children: /* @__PURE__ */ jsx71(MdClose7, { className: "tw-h-6 tw-w-6 tw-text-light-500" })
    })
  );
});
ToastClose.displayName = ToastPrimitives.Close.displayName;
var ToastTitle = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Title,
    __spreadValues({
      ref,
      className: cn("tw-text-md tw-font-semibold", className)
    }, props)
  );
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;
var ToastDescription = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx71(
    ToastPrimitives.Description,
    __spreadValues({
      ref,
      className: cn("tw-text-sm tw-text-white/60 tw-font-medium", className)
    }, props)
  );
});
ToastDescription.displayName = ToastPrimitives.Description.displayName;

// src/components/Toast/Toaster.tsx
import {
  ErrorIcon,
  MdHelp,
  MdInfo as MdInfo2,
  MdWarning as MdWarning2,
  SuccessIcon
} from "@teamworksdev/icons";

// src/components/Toast/useToast.ts
import { useEffect as useEffect11, useState as useState15 } from "react";
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var count = 0;
function genId() {
  count = (count + 1) % Number.MAX_VALUE;
  return count.toString();
}
var toastTimeouts = /* @__PURE__ */ new Map();
var addToRemoveQueue = (toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
var reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT)
      });
    case "UPDATE_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t2) => t2.id === action.toast.id ? __spreadValues(__spreadValues({}, t2), action.toast) : t2
        )
      });
    case "DISMISS_TOAST": {
      const { toastId } = action;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast2) => {
          addToRemoveQueue(toast2.id);
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t2) => t2.id === toastId || toastId === void 0 ? __spreadProps(__spreadValues({}, t2), {
            open: false
          }) : t2
        )
      });
    }
    case "REMOVE_TOAST":
      if (action.toastId === void 0) {
        return __spreadProps(__spreadValues({}, state), {
          toasts: []
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.filter((t2) => t2.id !== action.toastId)
      });
  }
};
var listeners = [];
var memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
function toast(_a) {
  var props = __objRest(_a, []);
  const id = genId();
  const update = (props2) => dispatch({
    type: "UPDATE_TOAST",
    toast: __spreadProps(__spreadValues({}, props2), { id })
  });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });
  dispatch({
    type: "ADD_TOAST",
    toast: __spreadProps(__spreadValues({}, props), {
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open)
          dismiss();
      }
    })
  });
  return {
    id,
    dismiss,
    update
  };
}
function useToast() {
  const [state, setState] = useState15(memoryState);
  useEffect11(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return __spreadProps(__spreadValues({}, state), {
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId })
  });
}

// src/components/Toast/Toaster.tsx
import { Fragment as Fragment7, jsx as jsx72, jsxs as jsxs39 } from "react/jsx-runtime";
var ICON_SIZE = 24;
var getVariantIcon = (variant) => {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx72(
        SuccessIcon,
        {
          width: ICON_SIZE,
          height: ICON_SIZE,
          className: "tw-text-green-700"
        }
      );
    case "warning":
      return /* @__PURE__ */ jsx72(MdWarning2, { size: ICON_SIZE, className: "tw-text-yellow-500" });
    case "destructive":
      return /* @__PURE__ */ jsx72(
        ErrorIcon,
        {
          width: ICON_SIZE,
          height: ICON_SIZE,
          className: "tw-text-red-500"
        }
      );
    case "info":
      return /* @__PURE__ */ jsx72(MdInfo2, { size: ICON_SIZE, className: "tw-text-blue-500" });
    case "question":
      return /* @__PURE__ */ jsx72(MdHelp, { size: ICON_SIZE, className: "tw-text-gray-500" });
    default:
      return /* @__PURE__ */ jsx72(Fragment7, {});
  }
};
function Toaster(props) {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsxs39(ToastProvider, __spreadProps(__spreadValues({}, props), { children: [
    toasts.map(function(_a) {
      var _b = _a, {
        id,
        title,
        description,
        action,
        variant
      } = _b, props2 = __objRest(_b, [
        "id",
        "title",
        "description",
        "action",
        "variant"
      ]);
      return /* @__PURE__ */ jsxs39(Toast, __spreadProps(__spreadValues({ variant }, props2), { children: [
        /* @__PURE__ */ jsxs39(
          "div",
          {
            className: "tw-grid tw-gap-y-1 tw-gap-x-3",
            style: {
              gridTemplateColumns: variant === "default" || !variant ? "min-content 1fr" : "24px auto"
            },
            children: [
              /* @__PURE__ */ jsx72("div", { className: "tw-row-span-2", children: getVariantIcon(variant) }),
              title && /* @__PURE__ */ jsx72(ToastTitle, { children: title }),
              description && /* @__PURE__ */ jsx72(ToastDescription, { className: "tw-break-words", children: description })
            ]
          }
        ),
        action,
        /* @__PURE__ */ jsx72(ToastClose, {})
      ] }), id);
    }),
    /* @__PURE__ */ jsx72(ToastViewport, {})
  ] }));
}

// src/components/ToggleSwitch/ToggleSwitch.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cva as cva18 } from "class-variance-authority";
import { forwardRef as forwardRef40 } from "react";
import { jsx as jsx73 } from "react/jsx-runtime";
var toggleSwitchRootVariants = cva18(
  "tw-peer tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-background disabled:tw-cursor-not-allowed disabled:tw-opacity-40 data-[state=checked]:tw-bg-info-700 data-[state=unchecked]:tw-bg-gray",
  {
    variants: {
      size: {
        sm: "tw-h-5 tw-w-9",
        md: "tw-h-6 tw-w-11",
        lg: "tw-h-8 tw-w-14"
      }
    },
    defaultVariants: {
      size: "lg"
    }
  }
);
var toggleSwitchThumbVariants = cva18(
  "tw-pointer-events-none tw-block tw-rounded-full tw-bg-white tw-shadow-lg tw-ring-0 tw-transition-transform data-[state=unchecked]:tw-translate-x-0",
  {
    variants: {
      size: {
        sm: "tw-h-4 tw-w-4 data-[state=checked]:tw-translate-x-4",
        md: "tw-h-5 tw-w-5 data-[state=checked]:tw-translate-x-5",
        lg: "tw-h-7 tw-w-7 data-[state=checked]:tw-translate-x-6"
      }
    },
    defaultVariants: {
      size: "lg"
    }
  }
);
var ToggleSwitch = forwardRef40((_a, ref) => {
  var _b = _a, { className, size } = _b, props = __objRest(_b, ["className", "size"]);
  return /* @__PURE__ */ jsx73(
    SwitchPrimitives.Root,
    __spreadProps(__spreadValues({
      className: cn(toggleSwitchRootVariants({ size, className }))
    }, props), {
      ref,
      children: /* @__PURE__ */ jsx73(
        SwitchPrimitives.Thumb,
        {
          className: toggleSwitchThumbVariants({ size, className })
        }
      )
    })
  );
});
ToggleSwitch.displayName = SwitchPrimitives.Root.displayName;
export {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
  Container as ActionBar,
  Alert,
  AlertClose,
  AlertDescription,
  AlertFooter,
  AlertTitle,
  App,
  Avatar,
  AvatarGroup,
  AvatarGroupList,
  AvatarOverflowIndicator,
  Badge,
  BreadcrumbItem,
  BreadcrumbLink,
  Breadcrumbs,
  Button,
  Calendar_default as Calendar,
  CalendarGrid_default as CalendarGrid,
  CalendarRange_default as CalendarRange,
  Checkbox,
  CheckboxButton,
  Combobox,
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuGroup,
  ContextMenuIcon,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuPortal,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuTrigger,
  DateField_default as DateField,
  DatePicker_default as DatePicker,
  DateRangePicker_default as DateRangePicker,
  DateTimePicker_default as DateTimePicker,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DownloadableFile,
  DownloadableFileContent,
  DownloadableFileModal,
  DownloadableFileTitle,
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuIcon,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  Environment,
  Filter_default as Filter,
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Heading,
  HorizontalNav,
  HorizontalNavItem,
  HorizontalNavLink,
  IconButton,
  Input,
  Label4 as Label,
  Menu,
  MenuCheckboxItem,
  MenuContent,
  MenuGroup,
  MenuIcon,
  MenuItem,
  MenuLabel,
  MenuRadioGroup,
  MenuRadioItem,
  MenuSeparator,
  MenuShortcut,
  MenuSub,
  MenuSubContent,
  MenuSubTrigger,
  MenuTrigger,
  MultiSelect,
  NavProvider_default as NavProvider,
  PhoneInput,
  Pill,
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
  AbstractPrimaryNav as PrimaryNav,
  ProgressBar,
  RadioButton,
  RadioGroup3 as RadioGroup,
  RadioGroupItem,
  SecondaryNav,
  SecondaryNavContent,
  SecondaryNavTitle,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Skeleton,
  SkeletonCircle,
  Spinner,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tag,
  TextField,
  TextFieldAddonLeft,
  TextFieldAddonRight,
  TextFieldElementLeft,
  TextFieldElementRight,
  TextFieldGroup,
  TimeField_default as TimeField,
  TimePicker_default as TimePicker,
  Toast,
  Toaster,
  ToggleSwitch,
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
  VerticalNav,
  VerticalNavButton,
  VerticalNavGroup,
  VerticalNavIcon,
  VerticalNavItem,
  VerticalNavLink,
  VerticalNavSeparator,
  appMetadata,
  cn,
  getColorGradientCSS,
  getTranslation,
  multiSelectTriggerVariants,
  useCallbackRef,
  useFormField,
  useOutsideClick,
  useToast
};
